const scriptRel = "modulepreload";
const assetsURL = function(dep, importerUrl) {
  return new URL(dep, importerUrl).href;
};
const seen = {};
const __vitePreload = function preload(baseModule, deps, importerUrl) {
  if (!deps || deps.length === 0) {
    return baseModule();
  }
  const links = document.getElementsByTagName("link");
  return Promise.all(deps.map((dep) => {
    dep = assetsURL(dep, importerUrl);
    if (dep in seen)
      return;
    seen[dep] = true;
    const isCss = dep.endsWith(".css");
    const cssSelector = isCss ? '[rel="stylesheet"]' : "";
    const isBaseRelative = !!importerUrl;
    if (isBaseRelative) {
      for (let i = links.length - 1; i >= 0; i--) {
        const link2 = links[i];
        if (link2.href === dep && (!isCss || link2.rel === "stylesheet")) {
          return;
        }
      }
    } else if (document.querySelector(`link[href="${dep}"]${cssSelector}`)) {
      return;
    }
    const link = document.createElement("link");
    link.rel = isCss ? "stylesheet" : scriptRel;
    if (!isCss) {
      link.as = "script";
      link.crossOrigin = "";
    }
    link.href = dep;
    document.head.appendChild(link);
    if (isCss) {
      return new Promise((res, rej) => {
        link.addEventListener("load", res);
        link.addEventListener("error", () => rej(new Error(`Unable to preload CSS for ${dep}`)));
      });
    }
  })).then(() => baseModule()).catch((err) => {
    const e = new Event("vite:preloadError", { cancelable: true });
    e.payload = err;
    window.dispatchEvent(e);
    if (!e.defaultPrevented) {
      throw err;
    }
  });
};
const theme = "";
const swiperBundle = "";
function isObject$2(obj) {
  return obj !== null && typeof obj === "object" && "constructor" in obj && obj.constructor === Object;
}
function extend$1(target = {}, src = {}) {
  Object.keys(src).forEach((key) => {
    if (typeof target[key] === "undefined")
      target[key] = src[key];
    else if (isObject$2(src[key]) && isObject$2(target[key]) && Object.keys(src[key]).length > 0) {
      extend$1(target[key], src[key]);
    }
  });
}
const ssrDocument = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function getDocument() {
  const doc = typeof document !== "undefined" ? document : {};
  extend$1(doc, ssrDocument);
  return doc;
}
const ssrWindow = {
  document: ssrDocument,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function CustomEvent2() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(callback) {
    if (typeof setTimeout === "undefined") {
      callback();
      return null;
    }
    return setTimeout(callback, 0);
  },
  cancelAnimationFrame(id) {
    if (typeof setTimeout === "undefined") {
      return;
    }
    clearTimeout(id);
  }
};
function getWindow() {
  const win = typeof window !== "undefined" ? window : {};
  extend$1(win, ssrWindow);
  return win;
}
function makeReactive(obj) {
  const proto = obj.__proto__;
  Object.defineProperty(obj, "__proto__", {
    get() {
      return proto;
    },
    set(value) {
      proto.__proto__ = value;
    }
  });
}
class Dom7 extends Array {
  constructor(items) {
    if (typeof items === "number") {
      super(items);
    } else {
      super(...items || []);
      makeReactive(this);
    }
  }
}
function arrayFlat(arr = []) {
  const res = [];
  arr.forEach((el) => {
    if (Array.isArray(el)) {
      res.push(...arrayFlat(el));
    } else {
      res.push(el);
    }
  });
  return res;
}
function arrayFilter(arr, callback) {
  return Array.prototype.filter.call(arr, callback);
}
function arrayUnique(arr) {
  const uniqueArray = [];
  for (let i = 0; i < arr.length; i += 1) {
    if (uniqueArray.indexOf(arr[i]) === -1)
      uniqueArray.push(arr[i]);
  }
  return uniqueArray;
}
function qsa(selector, context) {
  if (typeof selector !== "string") {
    return [selector];
  }
  const a = [];
  const res = context.querySelectorAll(selector);
  for (let i = 0; i < res.length; i += 1) {
    a.push(res[i]);
  }
  return a;
}
function $(selector, context) {
  const window2 = getWindow();
  const document2 = getDocument();
  let arr = [];
  if (!context && selector instanceof Dom7) {
    return selector;
  }
  if (!selector) {
    return new Dom7(arr);
  }
  if (typeof selector === "string") {
    const html2 = selector.trim();
    if (html2.indexOf("<") >= 0 && html2.indexOf(">") >= 0) {
      let toCreate = "div";
      if (html2.indexOf("<li") === 0)
        toCreate = "ul";
      if (html2.indexOf("<tr") === 0)
        toCreate = "tbody";
      if (html2.indexOf("<td") === 0 || html2.indexOf("<th") === 0)
        toCreate = "tr";
      if (html2.indexOf("<tbody") === 0)
        toCreate = "table";
      if (html2.indexOf("<option") === 0)
        toCreate = "select";
      const tempParent = document2.createElement(toCreate);
      tempParent.innerHTML = html2;
      for (let i = 0; i < tempParent.childNodes.length; i += 1) {
        arr.push(tempParent.childNodes[i]);
      }
    } else {
      arr = qsa(selector.trim(), context || document2);
    }
  } else if (selector.nodeType || selector === window2 || selector === document2) {
    arr.push(selector);
  } else if (Array.isArray(selector)) {
    if (selector instanceof Dom7)
      return selector;
    arr = selector;
  }
  return new Dom7(arrayUnique(arr));
}
$.fn = Dom7.prototype;
function addClass(...classes2) {
  const classNames = arrayFlat(classes2.map((c) => c.split(" ")));
  this.forEach((el) => {
    el.classList.add(...classNames);
  });
  return this;
}
function removeClass(...classes2) {
  const classNames = arrayFlat(classes2.map((c) => c.split(" ")));
  this.forEach((el) => {
    el.classList.remove(...classNames);
  });
  return this;
}
function toggleClass(...classes2) {
  const classNames = arrayFlat(classes2.map((c) => c.split(" ")));
  this.forEach((el) => {
    classNames.forEach((className) => {
      el.classList.toggle(className);
    });
  });
}
function hasClass(...classes2) {
  const classNames = arrayFlat(classes2.map((c) => c.split(" ")));
  return arrayFilter(this, (el) => {
    return classNames.filter((className) => el.classList.contains(className)).length > 0;
  }).length > 0;
}
function attr(attrs, value) {
  if (arguments.length === 1 && typeof attrs === "string") {
    if (this[0])
      return this[0].getAttribute(attrs);
    return void 0;
  }
  for (let i = 0; i < this.length; i += 1) {
    if (arguments.length === 2) {
      this[i].setAttribute(attrs, value);
    } else {
      for (const attrName in attrs) {
        this[i][attrName] = attrs[attrName];
        this[i].setAttribute(attrName, attrs[attrName]);
      }
    }
  }
  return this;
}
function removeAttr(attr2) {
  for (let i = 0; i < this.length; i += 1) {
    this[i].removeAttribute(attr2);
  }
  return this;
}
function transform(transform2) {
  for (let i = 0; i < this.length; i += 1) {
    this[i].style.transform = transform2;
  }
  return this;
}
function transition$2(duration) {
  for (let i = 0; i < this.length; i += 1) {
    this[i].style.transitionDuration = typeof duration !== "string" ? `${duration}ms` : duration;
  }
  return this;
}
function on$1(...args) {
  let [eventType, targetSelector, listener, capture] = args;
  if (typeof args[1] === "function") {
    [eventType, listener, capture] = args;
    targetSelector = void 0;
  }
  if (!capture)
    capture = false;
  function handleLiveEvent(e) {
    const target = e.target;
    if (!target)
      return;
    const eventData = e.target.dom7EventData || [];
    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }
    if ($(target).is(targetSelector))
      listener.apply(target, eventData);
    else {
      const parents2 = $(target).parents();
      for (let k = 0; k < parents2.length; k += 1) {
        if ($(parents2[k]).is(targetSelector))
          listener.apply(parents2[k], eventData);
      }
    }
  }
  function handleEvent(e) {
    const eventData = e && e.target ? e.target.dom7EventData || [] : [];
    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }
    listener.apply(this, eventData);
  }
  const events2 = eventType.split(" ");
  let j;
  for (let i = 0; i < this.length; i += 1) {
    const el = this[i];
    if (!targetSelector) {
      for (j = 0; j < events2.length; j += 1) {
        const event = events2[j];
        if (!el.dom7Listeners)
          el.dom7Listeners = {};
        if (!el.dom7Listeners[event])
          el.dom7Listeners[event] = [];
        el.dom7Listeners[event].push({
          listener,
          proxyListener: handleEvent
        });
        el.addEventListener(event, handleEvent, capture);
      }
    } else {
      for (j = 0; j < events2.length; j += 1) {
        const event = events2[j];
        if (!el.dom7LiveListeners)
          el.dom7LiveListeners = {};
        if (!el.dom7LiveListeners[event])
          el.dom7LiveListeners[event] = [];
        el.dom7LiveListeners[event].push({
          listener,
          proxyListener: handleLiveEvent
        });
        el.addEventListener(event, handleLiveEvent, capture);
      }
    }
  }
  return this;
}
function off(...args) {
  let [eventType, targetSelector, listener, capture] = args;
  if (typeof args[1] === "function") {
    [eventType, listener, capture] = args;
    targetSelector = void 0;
  }
  if (!capture)
    capture = false;
  const events2 = eventType.split(" ");
  for (let i = 0; i < events2.length; i += 1) {
    const event = events2[i];
    for (let j = 0; j < this.length; j += 1) {
      const el = this[j];
      let handlers;
      if (!targetSelector && el.dom7Listeners) {
        handlers = el.dom7Listeners[event];
      } else if (targetSelector && el.dom7LiveListeners) {
        handlers = el.dom7LiveListeners[event];
      }
      if (handlers && handlers.length) {
        for (let k = handlers.length - 1; k >= 0; k -= 1) {
          const handler4 = handlers[k];
          if (listener && handler4.listener === listener) {
            el.removeEventListener(event, handler4.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (listener && handler4.listener && handler4.listener.dom7proxy && handler4.listener.dom7proxy === listener) {
            el.removeEventListener(event, handler4.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (!listener) {
            el.removeEventListener(event, handler4.proxyListener, capture);
            handlers.splice(k, 1);
          }
        }
      }
    }
  }
  return this;
}
function trigger$1(...args) {
  const window2 = getWindow();
  const events2 = args[0].split(" ");
  const eventData = args[1];
  for (let i = 0; i < events2.length; i += 1) {
    const event = events2[i];
    for (let j = 0; j < this.length; j += 1) {
      const el = this[j];
      if (window2.CustomEvent) {
        const evt = new window2.CustomEvent(event, {
          detail: eventData,
          bubbles: true,
          cancelable: true
        });
        el.dom7EventData = args.filter((data2, dataIndex) => dataIndex > 0);
        el.dispatchEvent(evt);
        el.dom7EventData = [];
        delete el.dom7EventData;
      }
    }
  }
  return this;
}
function transitionEnd$1(callback) {
  const dom = this;
  function fireCallBack(e) {
    if (e.target !== this)
      return;
    callback.call(this, e);
    dom.off("transitionend", fireCallBack);
  }
  if (callback) {
    dom.on("transitionend", fireCallBack);
  }
  return this;
}
function outerWidth(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      const styles2 = this.styles();
      return this[0].offsetWidth + parseFloat(styles2.getPropertyValue("margin-right")) + parseFloat(styles2.getPropertyValue("margin-left"));
    }
    return this[0].offsetWidth;
  }
  return null;
}
function outerHeight(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      const styles2 = this.styles();
      return this[0].offsetHeight + parseFloat(styles2.getPropertyValue("margin-top")) + parseFloat(styles2.getPropertyValue("margin-bottom"));
    }
    return this[0].offsetHeight;
  }
  return null;
}
function offset() {
  if (this.length > 0) {
    const window2 = getWindow();
    const document2 = getDocument();
    const el = this[0];
    const box = el.getBoundingClientRect();
    const body = document2.body;
    const clientTop = el.clientTop || body.clientTop || 0;
    const clientLeft = el.clientLeft || body.clientLeft || 0;
    const scrollTop = el === window2 ? window2.scrollY : el.scrollTop;
    const scrollLeft = el === window2 ? window2.scrollX : el.scrollLeft;
    return {
      top: box.top + scrollTop - clientTop,
      left: box.left + scrollLeft - clientLeft
    };
  }
  return null;
}
function styles() {
  const window2 = getWindow();
  if (this[0])
    return window2.getComputedStyle(this[0], null);
  return {};
}
function css(props, value) {
  const window2 = getWindow();
  let i;
  if (arguments.length === 1) {
    if (typeof props === "string") {
      if (this[0])
        return window2.getComputedStyle(this[0], null).getPropertyValue(props);
    } else {
      for (i = 0; i < this.length; i += 1) {
        for (const prop in props) {
          this[i].style[prop] = props[prop];
        }
      }
      return this;
    }
  }
  if (arguments.length === 2 && typeof props === "string") {
    for (i = 0; i < this.length; i += 1) {
      this[i].style[props] = value;
    }
    return this;
  }
  return this;
}
function each(callback) {
  if (!callback)
    return this;
  this.forEach((el, index2) => {
    callback.apply(el, [el, index2]);
  });
  return this;
}
function filter(callback) {
  const result = arrayFilter(this, callback);
  return $(result);
}
function html(html2) {
  if (typeof html2 === "undefined") {
    return this[0] ? this[0].innerHTML : null;
  }
  for (let i = 0; i < this.length; i += 1) {
    this[i].innerHTML = html2;
  }
  return this;
}
function text(text2) {
  if (typeof text2 === "undefined") {
    return this[0] ? this[0].textContent.trim() : null;
  }
  for (let i = 0; i < this.length; i += 1) {
    this[i].textContent = text2;
  }
  return this;
}
function is(selector) {
  const window2 = getWindow();
  const document2 = getDocument();
  const el = this[0];
  let compareWith;
  let i;
  if (!el || typeof selector === "undefined")
    return false;
  if (typeof selector === "string") {
    if (el.matches)
      return el.matches(selector);
    if (el.webkitMatchesSelector)
      return el.webkitMatchesSelector(selector);
    if (el.msMatchesSelector)
      return el.msMatchesSelector(selector);
    compareWith = $(selector);
    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el)
        return true;
    }
    return false;
  }
  if (selector === document2) {
    return el === document2;
  }
  if (selector === window2) {
    return el === window2;
  }
  if (selector.nodeType || selector instanceof Dom7) {
    compareWith = selector.nodeType ? [selector] : selector;
    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el)
        return true;
    }
    return false;
  }
  return false;
}
function index() {
  let child = this[0];
  let i;
  if (child) {
    i = 0;
    while ((child = child.previousSibling) !== null) {
      if (child.nodeType === 1)
        i += 1;
    }
    return i;
  }
  return void 0;
}
function eq(index2) {
  if (typeof index2 === "undefined")
    return this;
  const length = this.length;
  if (index2 > length - 1) {
    return $([]);
  }
  if (index2 < 0) {
    const returnIndex = length + index2;
    if (returnIndex < 0)
      return $([]);
    return $([this[returnIndex]]);
  }
  return $([this[index2]]);
}
function append(...els) {
  let newChild;
  const document2 = getDocument();
  for (let k = 0; k < els.length; k += 1) {
    newChild = els[k];
    for (let i = 0; i < this.length; i += 1) {
      if (typeof newChild === "string") {
        const tempDiv = document2.createElement("div");
        tempDiv.innerHTML = newChild;
        while (tempDiv.firstChild) {
          this[i].appendChild(tempDiv.firstChild);
        }
      } else if (newChild instanceof Dom7) {
        for (let j = 0; j < newChild.length; j += 1) {
          this[i].appendChild(newChild[j]);
        }
      } else {
        this[i].appendChild(newChild);
      }
    }
  }
  return this;
}
function prepend(newChild) {
  const document2 = getDocument();
  let i;
  let j;
  for (i = 0; i < this.length; i += 1) {
    if (typeof newChild === "string") {
      const tempDiv = document2.createElement("div");
      tempDiv.innerHTML = newChild;
      for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
        this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
      }
    } else if (newChild instanceof Dom7) {
      for (j = 0; j < newChild.length; j += 1) {
        this[i].insertBefore(newChild[j], this[i].childNodes[0]);
      }
    } else {
      this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
  }
  return this;
}
function next(selector) {
  if (this.length > 0) {
    if (selector) {
      if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
        return $([this[0].nextElementSibling]);
      }
      return $([]);
    }
    if (this[0].nextElementSibling)
      return $([this[0].nextElementSibling]);
    return $([]);
  }
  return $([]);
}
function nextAll(selector) {
  const nextEls = [];
  let el = this[0];
  if (!el)
    return $([]);
  while (el.nextElementSibling) {
    const next2 = el.nextElementSibling;
    if (selector) {
      if ($(next2).is(selector))
        nextEls.push(next2);
    } else
      nextEls.push(next2);
    el = next2;
  }
  return $(nextEls);
}
function prev(selector) {
  if (this.length > 0) {
    const el = this[0];
    if (selector) {
      if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
        return $([el.previousElementSibling]);
      }
      return $([]);
    }
    if (el.previousElementSibling)
      return $([el.previousElementSibling]);
    return $([]);
  }
  return $([]);
}
function prevAll(selector) {
  const prevEls = [];
  let el = this[0];
  if (!el)
    return $([]);
  while (el.previousElementSibling) {
    const prev2 = el.previousElementSibling;
    if (selector) {
      if ($(prev2).is(selector))
        prevEls.push(prev2);
    } else
      prevEls.push(prev2);
    el = prev2;
  }
  return $(prevEls);
}
function parent(selector) {
  const parents2 = [];
  for (let i = 0; i < this.length; i += 1) {
    if (this[i].parentNode !== null) {
      if (selector) {
        if ($(this[i].parentNode).is(selector))
          parents2.push(this[i].parentNode);
      } else {
        parents2.push(this[i].parentNode);
      }
    }
  }
  return $(parents2);
}
function parents(selector) {
  const parents2 = [];
  for (let i = 0; i < this.length; i += 1) {
    let parent2 = this[i].parentNode;
    while (parent2) {
      if (selector) {
        if ($(parent2).is(selector))
          parents2.push(parent2);
      } else {
        parents2.push(parent2);
      }
      parent2 = parent2.parentNode;
    }
  }
  return $(parents2);
}
function closest(selector) {
  let closest2 = this;
  if (typeof selector === "undefined") {
    return $([]);
  }
  if (!closest2.is(selector)) {
    closest2 = closest2.parents(selector).eq(0);
  }
  return closest2;
}
function find(selector) {
  const foundElements = [];
  for (let i = 0; i < this.length; i += 1) {
    const found = this[i].querySelectorAll(selector);
    for (let j = 0; j < found.length; j += 1) {
      foundElements.push(found[j]);
    }
  }
  return $(foundElements);
}
function children(selector) {
  const children2 = [];
  for (let i = 0; i < this.length; i += 1) {
    const childNodes = this[i].children;
    for (let j = 0; j < childNodes.length; j += 1) {
      if (!selector || $(childNodes[j]).is(selector)) {
        children2.push(childNodes[j]);
      }
    }
  }
  return $(children2);
}
function remove() {
  for (let i = 0; i < this.length; i += 1) {
    if (this[i].parentNode)
      this[i].parentNode.removeChild(this[i]);
  }
  return this;
}
const Methods = {
  addClass,
  removeClass,
  hasClass,
  toggleClass,
  attr,
  removeAttr,
  transform,
  transition: transition$2,
  on: on$1,
  off,
  trigger: trigger$1,
  transitionEnd: transitionEnd$1,
  outerWidth,
  outerHeight,
  styles,
  offset,
  css,
  each,
  html,
  text,
  is,
  index,
  eq,
  append,
  prepend,
  next,
  nextAll,
  prev,
  prevAll,
  parent,
  parents,
  closest,
  find,
  children,
  filter,
  remove
};
Object.keys(Methods).forEach((methodName) => {
  Object.defineProperty($.fn, methodName, {
    value: Methods[methodName],
    writable: true
  });
});
function deleteProps(obj) {
  const object = obj;
  Object.keys(object).forEach((key) => {
    try {
      object[key] = null;
    } catch (e) {
    }
    try {
      delete object[key];
    } catch (e) {
    }
  });
}
function nextTick$1(callback, delay = 0) {
  return setTimeout(callback, delay);
}
function now() {
  return Date.now();
}
function getComputedStyle$1(el) {
  const window2 = getWindow();
  let style;
  if (window2.getComputedStyle) {
    style = window2.getComputedStyle(el, null);
  }
  if (!style && el.currentStyle) {
    style = el.currentStyle;
  }
  if (!style) {
    style = el.style;
  }
  return style;
}
function getTranslate(el, axis = "x") {
  const window2 = getWindow();
  let matrix;
  let curTransform;
  let transformMatrix;
  const curStyle = getComputedStyle$1(el);
  if (window2.WebKitCSSMatrix) {
    curTransform = curStyle.transform || curStyle.webkitTransform;
    if (curTransform.split(",").length > 6) {
      curTransform = curTransform.split(", ").map((a) => a.replace(",", ".")).join(", ");
    }
    transformMatrix = new window2.WebKitCSSMatrix(curTransform === "none" ? "" : curTransform);
  } else {
    transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
    matrix = transformMatrix.toString().split(",");
  }
  if (axis === "x") {
    if (window2.WebKitCSSMatrix)
      curTransform = transformMatrix.m41;
    else if (matrix.length === 16)
      curTransform = parseFloat(matrix[12]);
    else
      curTransform = parseFloat(matrix[4]);
  }
  if (axis === "y") {
    if (window2.WebKitCSSMatrix)
      curTransform = transformMatrix.m42;
    else if (matrix.length === 16)
      curTransform = parseFloat(matrix[13]);
    else
      curTransform = parseFloat(matrix[5]);
  }
  return curTransform || 0;
}
function isObject$1(o) {
  return typeof o === "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object";
}
function isNode(node) {
  if (typeof window !== "undefined" && typeof window.HTMLElement !== "undefined") {
    return node instanceof HTMLElement;
  }
  return node && (node.nodeType === 1 || node.nodeType === 11);
}
function extend(...args) {
  const to = Object(args[0]);
  const noExtend = ["__proto__", "constructor", "prototype"];
  for (let i = 1; i < args.length; i += 1) {
    const nextSource = args[i];
    if (nextSource !== void 0 && nextSource !== null && !isNode(nextSource)) {
      const keysArray = Object.keys(Object(nextSource)).filter((key) => noExtend.indexOf(key) < 0);
      for (let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
        const nextKey = keysArray[nextIndex];
        const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
        if (desc !== void 0 && desc.enumerable) {
          if (isObject$1(to[nextKey]) && isObject$1(nextSource[nextKey])) {
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend(to[nextKey], nextSource[nextKey]);
            }
          } else if (!isObject$1(to[nextKey]) && isObject$1(nextSource[nextKey])) {
            to[nextKey] = {};
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend(to[nextKey], nextSource[nextKey]);
            }
          } else {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
  }
  return to;
}
function setCSSProperty(el, varName, varValue) {
  el.style.setProperty(varName, varValue);
}
function animateCSSModeScroll({
  swiper,
  targetPosition,
  side
}) {
  const window2 = getWindow();
  const startPosition = -swiper.translate;
  let startTime = null;
  let time;
  const duration = swiper.params.speed;
  swiper.wrapperEl.style.scrollSnapType = "none";
  window2.cancelAnimationFrame(swiper.cssModeFrameID);
  const dir = targetPosition > startPosition ? "next" : "prev";
  const isOutOfBound = (current, target) => {
    return dir === "next" && current >= target || dir === "prev" && current <= target;
  };
  const animate = () => {
    time = (/* @__PURE__ */ new Date()).getTime();
    if (startTime === null) {
      startTime = time;
    }
    const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
    const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
    let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
    if (isOutOfBound(currentPosition, targetPosition)) {
      currentPosition = targetPosition;
    }
    swiper.wrapperEl.scrollTo({
      [side]: currentPosition
    });
    if (isOutOfBound(currentPosition, targetPosition)) {
      swiper.wrapperEl.style.overflow = "hidden";
      swiper.wrapperEl.style.scrollSnapType = "";
      setTimeout(() => {
        swiper.wrapperEl.style.overflow = "";
        swiper.wrapperEl.scrollTo({
          [side]: currentPosition
        });
      });
      window2.cancelAnimationFrame(swiper.cssModeFrameID);
      return;
    }
    swiper.cssModeFrameID = window2.requestAnimationFrame(animate);
  };
  animate();
}
let support;
function calcSupport() {
  const window2 = getWindow();
  const document2 = getDocument();
  return {
    smoothScroll: document2.documentElement && "scrollBehavior" in document2.documentElement.style,
    touch: !!("ontouchstart" in window2 || window2.DocumentTouch && document2 instanceof window2.DocumentTouch),
    passiveListener: function checkPassiveListener() {
      let supportsPassive = false;
      try {
        const opts = Object.defineProperty({}, "passive", {
          // eslint-disable-next-line
          get() {
            supportsPassive = true;
          }
        });
        window2.addEventListener("testPassiveListener", null, opts);
      } catch (e) {
      }
      return supportsPassive;
    }(),
    gestures: function checkGestures() {
      return "ongesturestart" in window2;
    }()
  };
}
function getSupport() {
  if (!support) {
    support = calcSupport();
  }
  return support;
}
let deviceCached;
function calcDevice({
  userAgent
} = {}) {
  const support2 = getSupport();
  const window2 = getWindow();
  const platform = window2.navigator.platform;
  const ua = userAgent || window2.navigator.userAgent;
  const device = {
    ios: false,
    android: false
  };
  const screenWidth = window2.screen.width;
  const screenHeight = window2.screen.height;
  const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
  let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
  const windows = platform === "Win32";
  let macos = platform === "MacIntel";
  const iPadScreens = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  if (!ipad && macos && support2.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
    ipad = ua.match(/(Version)\/([\d.]+)/);
    if (!ipad)
      ipad = [0, 1, "13_0_0"];
    macos = false;
  }
  if (android && !windows) {
    device.os = "android";
    device.android = true;
  }
  if (ipad || iphone || ipod) {
    device.os = "ios";
    device.ios = true;
  }
  return device;
}
function getDevice(overrides = {}) {
  if (!deviceCached) {
    deviceCached = calcDevice(overrides);
  }
  return deviceCached;
}
let browser;
function calcBrowser() {
  const window2 = getWindow();
  function isSafari() {
    const ua = window2.navigator.userAgent.toLowerCase();
    return ua.indexOf("safari") >= 0 && ua.indexOf("chrome") < 0 && ua.indexOf("android") < 0;
  }
  return {
    isSafari: isSafari(),
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window2.navigator.userAgent)
  };
}
function getBrowser() {
  if (!browser) {
    browser = calcBrowser();
  }
  return browser;
}
function Resize({
  swiper,
  on: on2,
  emit
}) {
  const window2 = getWindow();
  let observer2 = null;
  let animationFrame = null;
  const resizeHandler = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized)
      return;
    emit("beforeResize");
    emit("resize");
  };
  const createObserver = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized)
      return;
    observer2 = new ResizeObserver((entries) => {
      animationFrame = window2.requestAnimationFrame(() => {
        const {
          width,
          height
        } = swiper;
        let newWidth = width;
        let newHeight = height;
        entries.forEach(({
          contentBoxSize,
          contentRect,
          target
        }) => {
          if (target && target !== swiper.el)
            return;
          newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
          newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
        });
        if (newWidth !== width || newHeight !== height) {
          resizeHandler();
        }
      });
    });
    observer2.observe(swiper.el);
  };
  const removeObserver = () => {
    if (animationFrame) {
      window2.cancelAnimationFrame(animationFrame);
    }
    if (observer2 && observer2.unobserve && swiper.el) {
      observer2.unobserve(swiper.el);
      observer2 = null;
    }
  };
  const orientationChangeHandler = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized)
      return;
    emit("orientationchange");
  };
  on2("init", () => {
    if (swiper.params.resizeObserver && typeof window2.ResizeObserver !== "undefined") {
      createObserver();
      return;
    }
    window2.addEventListener("resize", resizeHandler);
    window2.addEventListener("orientationchange", orientationChangeHandler);
  });
  on2("destroy", () => {
    removeObserver();
    window2.removeEventListener("resize", resizeHandler);
    window2.removeEventListener("orientationchange", orientationChangeHandler);
  });
}
function Observer({
  swiper,
  extendParams,
  on: on2,
  emit
}) {
  const observers = [];
  const window2 = getWindow();
  const attach = (target, options = {}) => {
    const ObserverFunc = window2.MutationObserver || window2.WebkitMutationObserver;
    const observer2 = new ObserverFunc((mutations) => {
      if (mutations.length === 1) {
        emit("observerUpdate", mutations[0]);
        return;
      }
      const observerUpdate = function observerUpdate2() {
        emit("observerUpdate", mutations[0]);
      };
      if (window2.requestAnimationFrame) {
        window2.requestAnimationFrame(observerUpdate);
      } else {
        window2.setTimeout(observerUpdate, 0);
      }
    });
    observer2.observe(target, {
      attributes: typeof options.attributes === "undefined" ? true : options.attributes,
      childList: typeof options.childList === "undefined" ? true : options.childList,
      characterData: typeof options.characterData === "undefined" ? true : options.characterData
    });
    observers.push(observer2);
  };
  const init2 = () => {
    if (!swiper.params.observer)
      return;
    if (swiper.params.observeParents) {
      const containerParents = swiper.$el.parents();
      for (let i = 0; i < containerParents.length; i += 1) {
        attach(containerParents[i]);
      }
    }
    attach(swiper.$el[0], {
      childList: swiper.params.observeSlideChildren
    });
    attach(swiper.$wrapperEl[0], {
      attributes: false
    });
  };
  const destroy = () => {
    observers.forEach((observer2) => {
      observer2.disconnect();
    });
    observers.splice(0, observers.length);
  };
  extendParams({
    observer: false,
    observeParents: false,
    observeSlideChildren: false
  });
  on2("init", init2);
  on2("destroy", destroy);
}
const eventsEmitter = {
  on(events2, handler4, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed)
      return self;
    if (typeof handler4 !== "function")
      return self;
    const method = priority ? "unshift" : "push";
    events2.split(" ").forEach((event) => {
      if (!self.eventsListeners[event])
        self.eventsListeners[event] = [];
      self.eventsListeners[event][method](handler4);
    });
    return self;
  },
  once(events2, handler4, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed)
      return self;
    if (typeof handler4 !== "function")
      return self;
    function onceHandler(...args) {
      self.off(events2, onceHandler);
      if (onceHandler.__emitterProxy) {
        delete onceHandler.__emitterProxy;
      }
      handler4.apply(self, args);
    }
    onceHandler.__emitterProxy = handler4;
    return self.on(events2, onceHandler, priority);
  },
  onAny(handler4, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed)
      return self;
    if (typeof handler4 !== "function")
      return self;
    const method = priority ? "unshift" : "push";
    if (self.eventsAnyListeners.indexOf(handler4) < 0) {
      self.eventsAnyListeners[method](handler4);
    }
    return self;
  },
  offAny(handler4) {
    const self = this;
    if (!self.eventsListeners || self.destroyed)
      return self;
    if (!self.eventsAnyListeners)
      return self;
    const index2 = self.eventsAnyListeners.indexOf(handler4);
    if (index2 >= 0) {
      self.eventsAnyListeners.splice(index2, 1);
    }
    return self;
  },
  off(events2, handler4) {
    const self = this;
    if (!self.eventsListeners || self.destroyed)
      return self;
    if (!self.eventsListeners)
      return self;
    events2.split(" ").forEach((event) => {
      if (typeof handler4 === "undefined") {
        self.eventsListeners[event] = [];
      } else if (self.eventsListeners[event]) {
        self.eventsListeners[event].forEach((eventHandler, index2) => {
          if (eventHandler === handler4 || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler4) {
            self.eventsListeners[event].splice(index2, 1);
          }
        });
      }
    });
    return self;
  },
  emit(...args) {
    const self = this;
    if (!self.eventsListeners || self.destroyed)
      return self;
    if (!self.eventsListeners)
      return self;
    let events2;
    let data2;
    let context;
    if (typeof args[0] === "string" || Array.isArray(args[0])) {
      events2 = args[0];
      data2 = args.slice(1, args.length);
      context = self;
    } else {
      events2 = args[0].events;
      data2 = args[0].data;
      context = args[0].context || self;
    }
    data2.unshift(context);
    const eventsArray = Array.isArray(events2) ? events2 : events2.split(" ");
    eventsArray.forEach((event) => {
      if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
        self.eventsAnyListeners.forEach((eventHandler) => {
          eventHandler.apply(context, [event, ...data2]);
        });
      }
      if (self.eventsListeners && self.eventsListeners[event]) {
        self.eventsListeners[event].forEach((eventHandler) => {
          eventHandler.apply(context, data2);
        });
      }
    });
    return self;
  }
};
function updateSize() {
  const swiper = this;
  let width;
  let height;
  const $el = swiper.$el;
  if (typeof swiper.params.width !== "undefined" && swiper.params.width !== null) {
    width = swiper.params.width;
  } else {
    width = $el[0].clientWidth;
  }
  if (typeof swiper.params.height !== "undefined" && swiper.params.height !== null) {
    height = swiper.params.height;
  } else {
    height = $el[0].clientHeight;
  }
  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
    return;
  }
  width = width - parseInt($el.css("padding-left") || 0, 10) - parseInt($el.css("padding-right") || 0, 10);
  height = height - parseInt($el.css("padding-top") || 0, 10) - parseInt($el.css("padding-bottom") || 0, 10);
  if (Number.isNaN(width))
    width = 0;
  if (Number.isNaN(height))
    height = 0;
  Object.assign(swiper, {
    width,
    height,
    size: swiper.isHorizontal() ? width : height
  });
}
function updateSlides() {
  const swiper = this;
  function getDirectionLabel(property) {
    if (swiper.isHorizontal()) {
      return property;
    }
    return {
      "width": "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      "marginRight": "marginBottom"
    }[property];
  }
  function getDirectionPropertyValue(node, label) {
    return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
  }
  const params = swiper.params;
  const {
    $wrapperEl,
    size: swiperSize,
    rtlTranslate: rtl,
    wrongRTL
  } = swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
  const slides = $wrapperEl.children(`.${swiper.params.slideClass}`);
  const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
  let snapGrid = [];
  const slidesGrid = [];
  const slidesSizesGrid = [];
  let offsetBefore = params.slidesOffsetBefore;
  if (typeof offsetBefore === "function") {
    offsetBefore = params.slidesOffsetBefore.call(swiper);
  }
  let offsetAfter = params.slidesOffsetAfter;
  if (typeof offsetAfter === "function") {
    offsetAfter = params.slidesOffsetAfter.call(swiper);
  }
  const previousSnapGridLength = swiper.snapGrid.length;
  const previousSlidesGridLength = swiper.slidesGrid.length;
  let spaceBetween = params.spaceBetween;
  let slidePosition = -offsetBefore;
  let prevSlideSize = 0;
  let index2 = 0;
  if (typeof swiperSize === "undefined") {
    return;
  }
  if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiperSize;
  }
  swiper.virtualSize = -spaceBetween;
  if (rtl)
    slides.css({
      marginLeft: "",
      marginBottom: "",
      marginTop: ""
    });
  else
    slides.css({
      marginRight: "",
      marginBottom: "",
      marginTop: ""
    });
  if (params.centeredSlides && params.cssMode) {
    setCSSProperty(swiper.wrapperEl, "--swiper-centered-offset-before", "");
    setCSSProperty(swiper.wrapperEl, "--swiper-centered-offset-after", "");
  }
  const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
  if (gridEnabled) {
    swiper.grid.initSlides(slidesLength);
  }
  let slideSize;
  const shouldResetSlideSize = params.slidesPerView === "auto" && params.breakpoints && Object.keys(params.breakpoints).filter((key) => {
    return typeof params.breakpoints[key].slidesPerView !== "undefined";
  }).length > 0;
  for (let i = 0; i < slidesLength; i += 1) {
    slideSize = 0;
    const slide2 = slides.eq(i);
    if (gridEnabled) {
      swiper.grid.updateSlide(i, slide2, slidesLength, getDirectionLabel);
    }
    if (slide2.css("display") === "none")
      continue;
    if (params.slidesPerView === "auto") {
      if (shouldResetSlideSize) {
        slides[i].style[getDirectionLabel("width")] = ``;
      }
      const slideStyles = getComputedStyle(slide2[0]);
      const currentTransform = slide2[0].style.transform;
      const currentWebKitTransform = slide2[0].style.webkitTransform;
      if (currentTransform) {
        slide2[0].style.transform = "none";
      }
      if (currentWebKitTransform) {
        slide2[0].style.webkitTransform = "none";
      }
      if (params.roundLengths) {
        slideSize = swiper.isHorizontal() ? slide2.outerWidth(true) : slide2.outerHeight(true);
      } else {
        const width = getDirectionPropertyValue(slideStyles, "width");
        const paddingLeft = getDirectionPropertyValue(slideStyles, "padding-left");
        const paddingRight = getDirectionPropertyValue(slideStyles, "padding-right");
        const marginLeft = getDirectionPropertyValue(slideStyles, "margin-left");
        const marginRight = getDirectionPropertyValue(slideStyles, "margin-right");
        const boxSizing = slideStyles.getPropertyValue("box-sizing");
        if (boxSizing && boxSizing === "border-box") {
          slideSize = width + marginLeft + marginRight;
        } else {
          const {
            clientWidth,
            offsetWidth
          } = slide2[0];
          slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
        }
      }
      if (currentTransform) {
        slide2[0].style.transform = currentTransform;
      }
      if (currentWebKitTransform) {
        slide2[0].style.webkitTransform = currentWebKitTransform;
      }
      if (params.roundLengths)
        slideSize = Math.floor(slideSize);
    } else {
      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
      if (params.roundLengths)
        slideSize = Math.floor(slideSize);
      if (slides[i]) {
        slides[i].style[getDirectionLabel("width")] = `${slideSize}px`;
      }
    }
    if (slides[i]) {
      slides[i].swiperSlideSize = slideSize;
    }
    slidesSizesGrid.push(slideSize);
    if (params.centeredSlides) {
      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
      if (prevSlideSize === 0 && i !== 0)
        slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (i === 0)
        slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (Math.abs(slidePosition) < 1 / 1e3)
        slidePosition = 0;
      if (params.roundLengths)
        slidePosition = Math.floor(slidePosition);
      if (index2 % params.slidesPerGroup === 0)
        snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
    } else {
      if (params.roundLengths)
        slidePosition = Math.floor(slidePosition);
      if ((index2 - Math.min(swiper.params.slidesPerGroupSkip, index2)) % swiper.params.slidesPerGroup === 0)
        snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
      slidePosition = slidePosition + slideSize + spaceBetween;
    }
    swiper.virtualSize += slideSize + spaceBetween;
    prevSlideSize = slideSize;
    index2 += 1;
  }
  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
  if (rtl && wrongRTL && (params.effect === "slide" || params.effect === "coverflow")) {
    $wrapperEl.css({
      width: `${swiper.virtualSize + params.spaceBetween}px`
    });
  }
  if (params.setWrapperSize) {
    $wrapperEl.css({
      [getDirectionLabel("width")]: `${swiper.virtualSize + params.spaceBetween}px`
    });
  }
  if (gridEnabled) {
    swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
  }
  if (!params.centeredSlides) {
    const newSlidesGrid = [];
    for (let i = 0; i < snapGrid.length; i += 1) {
      let slidesGridItem = snapGrid[i];
      if (params.roundLengths)
        slidesGridItem = Math.floor(slidesGridItem);
      if (snapGrid[i] <= swiper.virtualSize - swiperSize) {
        newSlidesGrid.push(slidesGridItem);
      }
    }
    snapGrid = newSlidesGrid;
    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
      snapGrid.push(swiper.virtualSize - swiperSize);
    }
  }
  if (snapGrid.length === 0)
    snapGrid = [0];
  if (params.spaceBetween !== 0) {
    const key = swiper.isHorizontal() && rtl ? "marginLeft" : getDirectionLabel("marginRight");
    slides.filter((_, slideIndex) => {
      if (!params.cssMode)
        return true;
      if (slideIndex === slides.length - 1) {
        return false;
      }
      return true;
    }).css({
      [key]: `${spaceBetween}px`
    });
  }
  if (params.centeredSlides && params.centeredSlidesBounds) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach((slideSizeValue) => {
      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    allSlidesSize -= params.spaceBetween;
    const maxSnap = allSlidesSize - swiperSize;
    snapGrid = snapGrid.map((snap) => {
      if (snap < 0)
        return -offsetBefore;
      if (snap > maxSnap)
        return maxSnap + offsetAfter;
      return snap;
    });
  }
  if (params.centerInsufficientSlides) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach((slideSizeValue) => {
      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    allSlidesSize -= params.spaceBetween;
    if (allSlidesSize < swiperSize) {
      const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
      snapGrid.forEach((snap, snapIndex) => {
        snapGrid[snapIndex] = snap - allSlidesOffset;
      });
      slidesGrid.forEach((snap, snapIndex) => {
        slidesGrid[snapIndex] = snap + allSlidesOffset;
      });
    }
  }
  Object.assign(swiper, {
    slides,
    snapGrid,
    slidesGrid,
    slidesSizesGrid
  });
  if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
    setCSSProperty(swiper.wrapperEl, "--swiper-centered-offset-before", `${-snapGrid[0]}px`);
    setCSSProperty(swiper.wrapperEl, "--swiper-centered-offset-after", `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
    const addToSnapGrid = -swiper.snapGrid[0];
    const addToSlidesGrid = -swiper.slidesGrid[0];
    swiper.snapGrid = swiper.snapGrid.map((v) => v + addToSnapGrid);
    swiper.slidesGrid = swiper.slidesGrid.map((v) => v + addToSlidesGrid);
  }
  if (slidesLength !== previousSlidesLength) {
    swiper.emit("slidesLengthChange");
  }
  if (snapGrid.length !== previousSnapGridLength) {
    if (swiper.params.watchOverflow)
      swiper.checkOverflow();
    swiper.emit("snapGridLengthChange");
  }
  if (slidesGrid.length !== previousSlidesGridLength) {
    swiper.emit("slidesGridLengthChange");
  }
  if (params.watchSlidesProgress) {
    swiper.updateSlidesOffset();
  }
  if (!isVirtual && !params.cssMode && (params.effect === "slide" || params.effect === "fade")) {
    const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
    const hasClassBackfaceClassAdded = swiper.$el.hasClass(backFaceHiddenClass);
    if (slidesLength <= params.maxBackfaceHiddenSlides) {
      if (!hasClassBackfaceClassAdded)
        swiper.$el.addClass(backFaceHiddenClass);
    } else if (hasClassBackfaceClassAdded) {
      swiper.$el.removeClass(backFaceHiddenClass);
    }
  }
}
function updateAutoHeight(speed) {
  const swiper = this;
  const activeSlides = [];
  const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  let newHeight = 0;
  let i;
  if (typeof speed === "number") {
    swiper.setTransition(speed);
  } else if (speed === true) {
    swiper.setTransition(swiper.params.speed);
  }
  const getSlideByIndex = (index2) => {
    if (isVirtual) {
      return swiper.slides.filter((el) => parseInt(el.getAttribute("data-swiper-slide-index"), 10) === index2)[0];
    }
    return swiper.slides.eq(index2)[0];
  };
  if (swiper.params.slidesPerView !== "auto" && swiper.params.slidesPerView > 1) {
    if (swiper.params.centeredSlides) {
      (swiper.visibleSlides || $([])).each((slide2) => {
        activeSlides.push(slide2);
      });
    } else {
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        const index2 = swiper.activeIndex + i;
        if (index2 > swiper.slides.length && !isVirtual)
          break;
        activeSlides.push(getSlideByIndex(index2));
      }
    }
  } else {
    activeSlides.push(getSlideByIndex(swiper.activeIndex));
  }
  for (i = 0; i < activeSlides.length; i += 1) {
    if (typeof activeSlides[i] !== "undefined") {
      const height = activeSlides[i].offsetHeight;
      newHeight = height > newHeight ? height : newHeight;
    }
  }
  if (newHeight || newHeight === 0)
    swiper.$wrapperEl.css("height", `${newHeight}px`);
}
function updateSlidesOffset() {
  const swiper = this;
  const slides = swiper.slides;
  for (let i = 0; i < slides.length; i += 1) {
    slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
  }
}
function updateSlidesProgress(translate2 = this && this.translate || 0) {
  const swiper = this;
  const params = swiper.params;
  const {
    slides,
    rtlTranslate: rtl,
    snapGrid
  } = swiper;
  if (slides.length === 0)
    return;
  if (typeof slides[0].swiperSlideOffset === "undefined")
    swiper.updateSlidesOffset();
  let offsetCenter = -translate2;
  if (rtl)
    offsetCenter = translate2;
  slides.removeClass(params.slideVisibleClass);
  swiper.visibleSlidesIndexes = [];
  swiper.visibleSlides = [];
  for (let i = 0; i < slides.length; i += 1) {
    const slide2 = slides[i];
    let slideOffset = slide2.swiperSlideOffset;
    if (params.cssMode && params.centeredSlides) {
      slideOffset -= slides[0].swiperSlideOffset;
    }
    const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide2.swiperSlideSize + params.spaceBetween);
    const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide2.swiperSlideSize + params.spaceBetween);
    const slideBefore = -(offsetCenter - slideOffset);
    const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
    const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
    if (isVisible) {
      swiper.visibleSlides.push(slide2);
      swiper.visibleSlidesIndexes.push(i);
      slides.eq(i).addClass(params.slideVisibleClass);
    }
    slide2.progress = rtl ? -slideProgress : slideProgress;
    slide2.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
  }
  swiper.visibleSlides = $(swiper.visibleSlides);
}
function updateProgress(translate2) {
  const swiper = this;
  if (typeof translate2 === "undefined") {
    const multiplier = swiper.rtlTranslate ? -1 : 1;
    translate2 = swiper && swiper.translate && swiper.translate * multiplier || 0;
  }
  const params = swiper.params;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  let {
    progress,
    isBeginning,
    isEnd
  } = swiper;
  const wasBeginning = isBeginning;
  const wasEnd = isEnd;
  if (translatesDiff === 0) {
    progress = 0;
    isBeginning = true;
    isEnd = true;
  } else {
    progress = (translate2 - swiper.minTranslate()) / translatesDiff;
    isBeginning = progress <= 0;
    isEnd = progress >= 1;
  }
  Object.assign(swiper, {
    progress,
    isBeginning,
    isEnd
  });
  if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight)
    swiper.updateSlidesProgress(translate2);
  if (isBeginning && !wasBeginning) {
    swiper.emit("reachBeginning toEdge");
  }
  if (isEnd && !wasEnd) {
    swiper.emit("reachEnd toEdge");
  }
  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
    swiper.emit("fromEdge");
  }
  swiper.emit("progress", progress);
}
function updateSlidesClasses() {
  const swiper = this;
  const {
    slides,
    params,
    $wrapperEl,
    activeIndex,
    realIndex
  } = swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  slides.removeClass(`${params.slideActiveClass} ${params.slideNextClass} ${params.slidePrevClass} ${params.slideDuplicateActiveClass} ${params.slideDuplicateNextClass} ${params.slideDuplicatePrevClass}`);
  let activeSlide;
  if (isVirtual) {
    activeSlide = swiper.$wrapperEl.find(`.${params.slideClass}[data-swiper-slide-index="${activeIndex}"]`);
  } else {
    activeSlide = slides.eq(activeIndex);
  }
  activeSlide.addClass(params.slideActiveClass);
  if (params.loop) {
    if (activeSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
    } else {
      $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
    }
  }
  let nextSlide = activeSlide.nextAll(`.${params.slideClass}`).eq(0).addClass(params.slideNextClass);
  if (params.loop && nextSlide.length === 0) {
    nextSlide = slides.eq(0);
    nextSlide.addClass(params.slideNextClass);
  }
  let prevSlide = activeSlide.prevAll(`.${params.slideClass}`).eq(0).addClass(params.slidePrevClass);
  if (params.loop && prevSlide.length === 0) {
    prevSlide = slides.eq(-1);
    prevSlide.addClass(params.slidePrevClass);
  }
  if (params.loop) {
    if (nextSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${nextSlide.attr("data-swiper-slide-index")}"]`).addClass(params.slideDuplicateNextClass);
    } else {
      $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${nextSlide.attr("data-swiper-slide-index")}"]`).addClass(params.slideDuplicateNextClass);
    }
    if (prevSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${prevSlide.attr("data-swiper-slide-index")}"]`).addClass(params.slideDuplicatePrevClass);
    } else {
      $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${prevSlide.attr("data-swiper-slide-index")}"]`).addClass(params.slideDuplicatePrevClass);
    }
  }
  swiper.emitSlidesClasses();
}
function updateActiveIndex(newActiveIndex) {
  const swiper = this;
  const translate2 = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  const {
    slidesGrid,
    snapGrid,
    params,
    activeIndex: previousIndex,
    realIndex: previousRealIndex,
    snapIndex: previousSnapIndex
  } = swiper;
  let activeIndex = newActiveIndex;
  let snapIndex;
  if (typeof activeIndex === "undefined") {
    for (let i = 0; i < slidesGrid.length; i += 1) {
      if (typeof slidesGrid[i + 1] !== "undefined") {
        if (translate2 >= slidesGrid[i] && translate2 < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
          activeIndex = i;
        } else if (translate2 >= slidesGrid[i] && translate2 < slidesGrid[i + 1]) {
          activeIndex = i + 1;
        }
      } else if (translate2 >= slidesGrid[i]) {
        activeIndex = i;
      }
    }
    if (params.normalizeSlideIndex) {
      if (activeIndex < 0 || typeof activeIndex === "undefined")
        activeIndex = 0;
    }
  }
  if (snapGrid.indexOf(translate2) >= 0) {
    snapIndex = snapGrid.indexOf(translate2);
  } else {
    const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
  }
  if (snapIndex >= snapGrid.length)
    snapIndex = snapGrid.length - 1;
  if (activeIndex === previousIndex) {
    if (snapIndex !== previousSnapIndex) {
      swiper.snapIndex = snapIndex;
      swiper.emit("snapIndexChange");
    }
    return;
  }
  const realIndex = parseInt(swiper.slides.eq(activeIndex).attr("data-swiper-slide-index") || activeIndex, 10);
  Object.assign(swiper, {
    snapIndex,
    realIndex,
    previousIndex,
    activeIndex
  });
  swiper.emit("activeIndexChange");
  swiper.emit("snapIndexChange");
  if (previousRealIndex !== realIndex) {
    swiper.emit("realIndexChange");
  }
  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
    swiper.emit("slideChange");
  }
}
function updateClickedSlide(e) {
  const swiper = this;
  const params = swiper.params;
  const slide2 = $(e).closest(`.${params.slideClass}`)[0];
  let slideFound = false;
  let slideIndex;
  if (slide2) {
    for (let i = 0; i < swiper.slides.length; i += 1) {
      if (swiper.slides[i] === slide2) {
        slideFound = true;
        slideIndex = i;
        break;
      }
    }
  }
  if (slide2 && slideFound) {
    swiper.clickedSlide = slide2;
    if (swiper.virtual && swiper.params.virtual.enabled) {
      swiper.clickedIndex = parseInt($(slide2).attr("data-swiper-slide-index"), 10);
    } else {
      swiper.clickedIndex = slideIndex;
    }
  } else {
    swiper.clickedSlide = void 0;
    swiper.clickedIndex = void 0;
    return;
  }
  if (params.slideToClickedSlide && swiper.clickedIndex !== void 0 && swiper.clickedIndex !== swiper.activeIndex) {
    swiper.slideToClickedSlide();
  }
}
const update = {
  updateSize,
  updateSlides,
  updateAutoHeight,
  updateSlidesOffset,
  updateSlidesProgress,
  updateProgress,
  updateSlidesClasses,
  updateActiveIndex,
  updateClickedSlide
};
function getSwiperTranslate(axis = this.isHorizontal() ? "x" : "y") {
  const swiper = this;
  const {
    params,
    rtlTranslate: rtl,
    translate: translate2,
    $wrapperEl
  } = swiper;
  if (params.virtualTranslate) {
    return rtl ? -translate2 : translate2;
  }
  if (params.cssMode) {
    return translate2;
  }
  let currentTranslate = getTranslate($wrapperEl[0], axis);
  if (rtl)
    currentTranslate = -currentTranslate;
  return currentTranslate || 0;
}
function setTranslate(translate2, byController) {
  const swiper = this;
  const {
    rtlTranslate: rtl,
    params,
    $wrapperEl,
    wrapperEl,
    progress
  } = swiper;
  let x = 0;
  let y = 0;
  const z = 0;
  if (swiper.isHorizontal()) {
    x = rtl ? -translate2 : translate2;
  } else {
    y = translate2;
  }
  if (params.roundLengths) {
    x = Math.floor(x);
    y = Math.floor(y);
  }
  if (params.cssMode) {
    wrapperEl[swiper.isHorizontal() ? "scrollLeft" : "scrollTop"] = swiper.isHorizontal() ? -x : -y;
  } else if (!params.virtualTranslate) {
    $wrapperEl.transform(`translate3d(${x}px, ${y}px, ${z}px)`);
  }
  swiper.previousTranslate = swiper.translate;
  swiper.translate = swiper.isHorizontal() ? x : y;
  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (translate2 - swiper.minTranslate()) / translatesDiff;
  }
  if (newProgress !== progress) {
    swiper.updateProgress(translate2);
  }
  swiper.emit("setTranslate", swiper.translate, byController);
}
function minTranslate() {
  return -this.snapGrid[0];
}
function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function translateTo(translate2 = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
  const swiper = this;
  const {
    params,
    wrapperEl
  } = swiper;
  if (swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }
  const minTranslate2 = swiper.minTranslate();
  const maxTranslate2 = swiper.maxTranslate();
  let newTranslate;
  if (translateBounds && translate2 > minTranslate2)
    newTranslate = minTranslate2;
  else if (translateBounds && translate2 < maxTranslate2)
    newTranslate = maxTranslate2;
  else
    newTranslate = translate2;
  swiper.updateProgress(newTranslate);
  if (params.cssMode) {
    const isH = swiper.isHorizontal();
    if (speed === 0) {
      wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
    } else {
      if (!swiper.support.smoothScroll) {
        animateCSSModeScroll({
          swiper,
          targetPosition: -newTranslate,
          side: isH ? "left" : "top"
        });
        return true;
      }
      wrapperEl.scrollTo({
        [isH ? "left" : "top"]: -newTranslate,
        behavior: "smooth"
      });
    }
    return true;
  }
  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(newTranslate);
    if (runCallbacks) {
      swiper.emit("beforeTransitionStart", speed, internal);
      swiper.emit("transitionEnd");
    }
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(newTranslate);
    if (runCallbacks) {
      swiper.emit("beforeTransitionStart", speed, internal);
      swiper.emit("transitionStart");
    }
    if (!swiper.animating) {
      swiper.animating = true;
      if (!swiper.onTranslateToWrapperTransitionEnd) {
        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd2(e) {
          if (!swiper || swiper.destroyed)
            return;
          if (e.target !== this)
            return;
          swiper.$wrapperEl[0].removeEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
          swiper.$wrapperEl[0].removeEventListener("webkitTransitionEnd", swiper.onTranslateToWrapperTransitionEnd);
          swiper.onTranslateToWrapperTransitionEnd = null;
          delete swiper.onTranslateToWrapperTransitionEnd;
          if (runCallbacks) {
            swiper.emit("transitionEnd");
          }
        };
      }
      swiper.$wrapperEl[0].addEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
      swiper.$wrapperEl[0].addEventListener("webkitTransitionEnd", swiper.onTranslateToWrapperTransitionEnd);
    }
  }
  return true;
}
const translate = {
  getTranslate: getSwiperTranslate,
  setTranslate,
  minTranslate,
  maxTranslate,
  translateTo
};
function setTransition(duration, byController) {
  const swiper = this;
  if (!swiper.params.cssMode) {
    swiper.$wrapperEl.transition(duration);
  }
  swiper.emit("setTransition", duration, byController);
}
function transitionEmit({
  swiper,
  runCallbacks,
  direction,
  step
}) {
  const {
    activeIndex,
    previousIndex
  } = swiper;
  let dir = direction;
  if (!dir) {
    if (activeIndex > previousIndex)
      dir = "next";
    else if (activeIndex < previousIndex)
      dir = "prev";
    else
      dir = "reset";
  }
  swiper.emit(`transition${step}`);
  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === "reset") {
      swiper.emit(`slideResetTransition${step}`);
      return;
    }
    swiper.emit(`slideChangeTransition${step}`);
    if (dir === "next") {
      swiper.emit(`slideNextTransition${step}`);
    } else {
      swiper.emit(`slidePrevTransition${step}`);
    }
  }
}
function transitionStart(runCallbacks = true, direction) {
  const swiper = this;
  const {
    params
  } = swiper;
  if (params.cssMode)
    return;
  if (params.autoHeight) {
    swiper.updateAutoHeight();
  }
  transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: "Start"
  });
}
function transitionEnd(runCallbacks = true, direction) {
  const swiper = this;
  const {
    params
  } = swiper;
  swiper.animating = false;
  if (params.cssMode)
    return;
  swiper.setTransition(0);
  transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: "End"
  });
}
const transition$1 = {
  setTransition,
  transitionStart,
  transitionEnd
};
function slideTo(index2 = 0, speed = this.params.speed, runCallbacks = true, internal, initial) {
  if (typeof index2 !== "number" && typeof index2 !== "string") {
    throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof index2}] given.`);
  }
  if (typeof index2 === "string") {
    const indexAsNumber = parseInt(index2, 10);
    const isValidNumber = isFinite(indexAsNumber);
    if (!isValidNumber) {
      throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index2}] given.`);
    }
    index2 = indexAsNumber;
  }
  const swiper = this;
  let slideIndex = index2;
  if (slideIndex < 0)
    slideIndex = 0;
  const {
    params,
    snapGrid,
    slidesGrid,
    previousIndex,
    activeIndex,
    rtlTranslate: rtl,
    wrapperEl,
    enabled
  } = swiper;
  if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) {
    return false;
  }
  const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
  let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
  if (snapIndex >= snapGrid.length)
    snapIndex = snapGrid.length - 1;
  const translate2 = -snapGrid[snapIndex];
  if (params.normalizeSlideIndex) {
    for (let i = 0; i < slidesGrid.length; i += 1) {
      const normalizedTranslate = -Math.floor(translate2 * 100);
      const normalizedGrid = Math.floor(slidesGrid[i] * 100);
      const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
      if (typeof slidesGrid[i + 1] !== "undefined") {
        if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) {
          slideIndex = i;
        } else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) {
          slideIndex = i + 1;
        }
      } else if (normalizedTranslate >= normalizedGrid) {
        slideIndex = i;
      }
    }
  }
  if (swiper.initialized && slideIndex !== activeIndex) {
    if (!swiper.allowSlideNext && translate2 < swiper.translate && translate2 < swiper.minTranslate()) {
      return false;
    }
    if (!swiper.allowSlidePrev && translate2 > swiper.translate && translate2 > swiper.maxTranslate()) {
      if ((activeIndex || 0) !== slideIndex)
        return false;
    }
  }
  if (slideIndex !== (previousIndex || 0) && runCallbacks) {
    swiper.emit("beforeSlideChangeStart");
  }
  swiper.updateProgress(translate2);
  let direction;
  if (slideIndex > activeIndex)
    direction = "next";
  else if (slideIndex < activeIndex)
    direction = "prev";
  else
    direction = "reset";
  if (rtl && -translate2 === swiper.translate || !rtl && translate2 === swiper.translate) {
    swiper.updateActiveIndex(slideIndex);
    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }
    swiper.updateSlidesClasses();
    if (params.effect !== "slide") {
      swiper.setTranslate(translate2);
    }
    if (direction !== "reset") {
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    }
    return false;
  }
  if (params.cssMode) {
    const isH = swiper.isHorizontal();
    const t = rtl ? translate2 : -translate2;
    if (speed === 0) {
      const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
      if (isVirtual) {
        swiper.wrapperEl.style.scrollSnapType = "none";
        swiper._immediateVirtual = true;
      }
      wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
      if (isVirtual) {
        requestAnimationFrame(() => {
          swiper.wrapperEl.style.scrollSnapType = "";
          swiper._swiperImmediateVirtual = false;
        });
      }
    } else {
      if (!swiper.support.smoothScroll) {
        animateCSSModeScroll({
          swiper,
          targetPosition: t,
          side: isH ? "left" : "top"
        });
        return true;
      }
      wrapperEl.scrollTo({
        [isH ? "left" : "top"]: t,
        behavior: "smooth"
      });
    }
    return true;
  }
  swiper.setTransition(speed);
  swiper.setTranslate(translate2);
  swiper.updateActiveIndex(slideIndex);
  swiper.updateSlidesClasses();
  swiper.emit("beforeTransitionStart", speed, internal);
  swiper.transitionStart(runCallbacks, direction);
  if (speed === 0) {
    swiper.transitionEnd(runCallbacks, direction);
  } else if (!swiper.animating) {
    swiper.animating = true;
    if (!swiper.onSlideToWrapperTransitionEnd) {
      swiper.onSlideToWrapperTransitionEnd = function transitionEnd2(e) {
        if (!swiper || swiper.destroyed)
          return;
        if (e.target !== this)
          return;
        swiper.$wrapperEl[0].removeEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].removeEventListener("webkitTransitionEnd", swiper.onSlideToWrapperTransitionEnd);
        swiper.onSlideToWrapperTransitionEnd = null;
        delete swiper.onSlideToWrapperTransitionEnd;
        swiper.transitionEnd(runCallbacks, direction);
      };
    }
    swiper.$wrapperEl[0].addEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
    swiper.$wrapperEl[0].addEventListener("webkitTransitionEnd", swiper.onSlideToWrapperTransitionEnd);
  }
  return true;
}
function slideToLoop(index2 = 0, speed = this.params.speed, runCallbacks = true, internal) {
  if (typeof index2 === "string") {
    const indexAsNumber = parseInt(index2, 10);
    const isValidNumber = isFinite(indexAsNumber);
    if (!isValidNumber) {
      throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index2}] given.`);
    }
    index2 = indexAsNumber;
  }
  const swiper = this;
  let newIndex = index2;
  if (swiper.params.loop) {
    newIndex += swiper.loopedSlides;
  }
  return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}
function slideNext(speed = this.params.speed, runCallbacks = true, internal) {
  const swiper = this;
  const {
    animating,
    enabled,
    params
  } = swiper;
  if (!enabled)
    return swiper;
  let perGroup = params.slidesPerGroup;
  if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
    perGroup = Math.max(swiper.slidesPerViewDynamic("current", true), 1);
  }
  const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
  if (params.loop) {
    if (animating && params.loopPreventsSlide)
      return false;
    swiper.loopFix();
    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }
  if (params.rewind && swiper.isEnd) {
    return swiper.slideTo(0, speed, runCallbacks, internal);
  }
  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
function slidePrev(speed = this.params.speed, runCallbacks = true, internal) {
  const swiper = this;
  const {
    params,
    animating,
    snapGrid,
    slidesGrid,
    rtlTranslate,
    enabled
  } = swiper;
  if (!enabled)
    return swiper;
  if (params.loop) {
    if (animating && params.loopPreventsSlide)
      return false;
    swiper.loopFix();
    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }
  const translate2 = rtlTranslate ? swiper.translate : -swiper.translate;
  function normalize(val) {
    if (val < 0)
      return -Math.floor(Math.abs(val));
    return Math.floor(val);
  }
  const normalizedTranslate = normalize(translate2);
  const normalizedSnapGrid = snapGrid.map((val) => normalize(val));
  let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
  if (typeof prevSnap === "undefined" && params.cssMode) {
    let prevSnapIndex;
    snapGrid.forEach((snap, snapIndex) => {
      if (normalizedTranslate >= snap) {
        prevSnapIndex = snapIndex;
      }
    });
    if (typeof prevSnapIndex !== "undefined") {
      prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
  }
  let prevIndex = 0;
  if (typeof prevSnap !== "undefined") {
    prevIndex = slidesGrid.indexOf(prevSnap);
    if (prevIndex < 0)
      prevIndex = swiper.activeIndex - 1;
    if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
      prevIndex = prevIndex - swiper.slidesPerViewDynamic("previous", true) + 1;
      prevIndex = Math.max(prevIndex, 0);
    }
  }
  if (params.rewind && swiper.isBeginning) {
    const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
  }
  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
function slideReset(speed = this.params.speed, runCallbacks = true, internal) {
  const swiper = this;
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
function slideToClosest(speed = this.params.speed, runCallbacks = true, internal, threshold = 0.5) {
  const swiper = this;
  let index2 = swiper.activeIndex;
  const skip = Math.min(swiper.params.slidesPerGroupSkip, index2);
  const snapIndex = skip + Math.floor((index2 - skip) / swiper.params.slidesPerGroup);
  const translate2 = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  if (translate2 >= swiper.snapGrid[snapIndex]) {
    const currentSnap = swiper.snapGrid[snapIndex];
    const nextSnap = swiper.snapGrid[snapIndex + 1];
    if (translate2 - currentSnap > (nextSnap - currentSnap) * threshold) {
      index2 += swiper.params.slidesPerGroup;
    }
  } else {
    const prevSnap = swiper.snapGrid[snapIndex - 1];
    const currentSnap = swiper.snapGrid[snapIndex];
    if (translate2 - prevSnap <= (currentSnap - prevSnap) * threshold) {
      index2 -= swiper.params.slidesPerGroup;
    }
  }
  index2 = Math.max(index2, 0);
  index2 = Math.min(index2, swiper.slidesGrid.length - 1);
  return swiper.slideTo(index2, speed, runCallbacks, internal);
}
function slideToClickedSlide() {
  const swiper = this;
  const {
    params,
    $wrapperEl
  } = swiper;
  const slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  let slideToIndex = swiper.clickedIndex;
  let realIndex;
  if (params.loop) {
    if (swiper.animating)
      return;
    realIndex = parseInt($(swiper.clickedSlide).attr("data-swiper-slide-index"), 10);
    if (params.centeredSlides) {
      if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
        swiper.loopFix();
        slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
        nextTick$1(() => {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
      swiper.loopFix();
      slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
      nextTick$1(() => {
        swiper.slideTo(slideToIndex);
      });
    } else {
      swiper.slideTo(slideToIndex);
    }
  } else {
    swiper.slideTo(slideToIndex);
  }
}
const slide = {
  slideTo,
  slideToLoop,
  slideNext,
  slidePrev,
  slideReset,
  slideToClosest,
  slideToClickedSlide
};
function loopCreate() {
  const swiper = this;
  const document2 = getDocument();
  const {
    params,
    $wrapperEl
  } = swiper;
  const $selector = $wrapperEl.children().length > 0 ? $($wrapperEl.children()[0].parentNode) : $wrapperEl;
  $selector.children(`.${params.slideClass}.${params.slideDuplicateClass}`).remove();
  let slides = $selector.children(`.${params.slideClass}`);
  if (params.loopFillGroupWithBlank) {
    const blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;
    if (blankSlidesNum !== params.slidesPerGroup) {
      for (let i = 0; i < blankSlidesNum; i += 1) {
        const blankNode = $(document2.createElement("div")).addClass(`${params.slideClass} ${params.slideBlankClass}`);
        $selector.append(blankNode);
      }
      slides = $selector.children(`.${params.slideClass}`);
    }
  }
  if (params.slidesPerView === "auto" && !params.loopedSlides)
    params.loopedSlides = slides.length;
  swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
  swiper.loopedSlides += params.loopAdditionalSlides;
  if (swiper.loopedSlides > slides.length && swiper.params.loopedSlidesLimit) {
    swiper.loopedSlides = slides.length;
  }
  const prependSlides = [];
  const appendSlides = [];
  slides.each((el, index2) => {
    const slide2 = $(el);
    slide2.attr("data-swiper-slide-index", index2);
  });
  for (let i = 0; i < swiper.loopedSlides; i += 1) {
    const index2 = i - Math.floor(i / slides.length) * slides.length;
    appendSlides.push(slides.eq(index2)[0]);
    prependSlides.unshift(slides.eq(slides.length - index2 - 1)[0]);
  }
  for (let i = 0; i < appendSlides.length; i += 1) {
    $selector.append($(appendSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
  }
  for (let i = prependSlides.length - 1; i >= 0; i -= 1) {
    $selector.prepend($(prependSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
  }
}
function loopFix() {
  const swiper = this;
  swiper.emit("beforeLoopFix");
  const {
    activeIndex,
    slides,
    loopedSlides,
    allowSlidePrev,
    allowSlideNext,
    snapGrid,
    rtlTranslate: rtl
  } = swiper;
  let newIndex;
  swiper.allowSlidePrev = true;
  swiper.allowSlideNext = true;
  const snapTranslate = -snapGrid[activeIndex];
  const diff = snapTranslate - swiper.getTranslate();
  if (activeIndex < loopedSlides) {
    newIndex = slides.length - loopedSlides * 3 + activeIndex;
    newIndex += loopedSlides;
    const slideChanged = swiper.slideTo(newIndex, 0, false, true);
    if (slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  } else if (activeIndex >= slides.length - loopedSlides) {
    newIndex = -slides.length + activeIndex + loopedSlides;
    newIndex += loopedSlides;
    const slideChanged = swiper.slideTo(newIndex, 0, false, true);
    if (slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  }
  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  swiper.emit("loopFix");
}
function loopDestroy() {
  const swiper = this;
  const {
    $wrapperEl,
    params,
    slides
  } = swiper;
  $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass},.${params.slideClass}.${params.slideBlankClass}`).remove();
  slides.removeAttr("data-swiper-slide-index");
}
const loop$1 = {
  loopCreate,
  loopFix,
  loopDestroy
};
function setGrabCursor(moving) {
  const swiper = this;
  if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode)
    return;
  const el = swiper.params.touchEventsTarget === "container" ? swiper.el : swiper.wrapperEl;
  el.style.cursor = "move";
  el.style.cursor = moving ? "grabbing" : "grab";
}
function unsetGrabCursor() {
  const swiper = this;
  if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
    return;
  }
  swiper[swiper.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "";
}
const grabCursor = {
  setGrabCursor,
  unsetGrabCursor
};
function closestElement(selector, base = this) {
  function __closestFrom(el) {
    if (!el || el === getDocument() || el === getWindow())
      return null;
    if (el.assignedSlot)
      el = el.assignedSlot;
    const found = el.closest(selector);
    if (!found && !el.getRootNode) {
      return null;
    }
    return found || __closestFrom(el.getRootNode().host);
  }
  return __closestFrom(base);
}
function onTouchStart(event) {
  const swiper = this;
  const document2 = getDocument();
  const window2 = getWindow();
  const data2 = swiper.touchEventsData;
  const {
    params,
    touches,
    enabled
  } = swiper;
  if (!enabled)
    return;
  if (swiper.animating && params.preventInteractionOnTransition) {
    return;
  }
  if (!swiper.animating && params.cssMode && params.loop) {
    swiper.loopFix();
  }
  let e = event;
  if (e.originalEvent)
    e = e.originalEvent;
  let $targetEl = $(e.target);
  if (params.touchEventsTarget === "wrapper") {
    if (!$targetEl.closest(swiper.wrapperEl).length)
      return;
  }
  data2.isTouchEvent = e.type === "touchstart";
  if (!data2.isTouchEvent && "which" in e && e.which === 3)
    return;
  if (!data2.isTouchEvent && "button" in e && e.button > 0)
    return;
  if (data2.isTouched && data2.isMoved)
    return;
  const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== "";
  const eventPath = event.composedPath ? event.composedPath() : event.path;
  if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) {
    $targetEl = $(eventPath[0]);
  }
  const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
  const isTargetShadow = !!(e.target && e.target.shadowRoot);
  if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, $targetEl[0]) : $targetEl.closest(noSwipingSelector)[0])) {
    swiper.allowClick = true;
    return;
  }
  if (params.swipeHandler) {
    if (!$targetEl.closest(params.swipeHandler)[0])
      return;
  }
  touches.currentX = e.type === "touchstart" ? e.targetTouches[0].pageX : e.pageX;
  touches.currentY = e.type === "touchstart" ? e.targetTouches[0].pageY : e.pageY;
  const startX = touches.currentX;
  const startY = touches.currentY;
  const edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
  const edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window2.innerWidth - edgeSwipeThreshold)) {
    if (edgeSwipeDetection === "prevent") {
      event.preventDefault();
    } else {
      return;
    }
  }
  Object.assign(data2, {
    isTouched: true,
    isMoved: false,
    allowTouchCallbacks: true,
    isScrolling: void 0,
    startMoving: void 0
  });
  touches.startX = startX;
  touches.startY = startY;
  data2.touchStartTime = now();
  swiper.allowClick = true;
  swiper.updateSize();
  swiper.swipeDirection = void 0;
  if (params.threshold > 0)
    data2.allowThresholdMove = false;
  if (e.type !== "touchstart") {
    let preventDefault = true;
    if ($targetEl.is(data2.focusableElements)) {
      preventDefault = false;
      if ($targetEl[0].nodeName === "SELECT") {
        data2.isTouched = false;
      }
    }
    if (document2.activeElement && $(document2.activeElement).is(data2.focusableElements) && document2.activeElement !== $targetEl[0]) {
      document2.activeElement.blur();
    }
    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) {
      e.preventDefault();
    }
  }
  if (swiper.params.freeMode && swiper.params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) {
    swiper.freeMode.onTouchStart();
  }
  swiper.emit("touchStart", e);
}
function onTouchMove(event) {
  const document2 = getDocument();
  const swiper = this;
  const data2 = swiper.touchEventsData;
  const {
    params,
    touches,
    rtlTranslate: rtl,
    enabled
  } = swiper;
  if (!enabled)
    return;
  let e = event;
  if (e.originalEvent)
    e = e.originalEvent;
  if (!data2.isTouched) {
    if (data2.startMoving && data2.isScrolling) {
      swiper.emit("touchMoveOpposite", e);
    }
    return;
  }
  if (data2.isTouchEvent && e.type !== "touchmove")
    return;
  const targetTouch = e.type === "touchmove" && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
  const pageX = e.type === "touchmove" ? targetTouch.pageX : e.pageX;
  const pageY = e.type === "touchmove" ? targetTouch.pageY : e.pageY;
  if (e.preventedByNestedSwiper) {
    touches.startX = pageX;
    touches.startY = pageY;
    return;
  }
  if (!swiper.allowTouchMove) {
    if (!$(e.target).is(data2.focusableElements)) {
      swiper.allowClick = false;
    }
    if (data2.isTouched) {
      Object.assign(touches, {
        startX: pageX,
        startY: pageY,
        currentX: pageX,
        currentY: pageY
      });
      data2.touchStartTime = now();
    }
    return;
  }
  if (data2.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
    if (swiper.isVertical()) {
      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
        data2.isTouched = false;
        data2.isMoved = false;
        return;
      }
    } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
      return;
    }
  }
  if (data2.isTouchEvent && document2.activeElement) {
    if (e.target === document2.activeElement && $(e.target).is(data2.focusableElements)) {
      data2.isMoved = true;
      swiper.allowClick = false;
      return;
    }
  }
  if (data2.allowTouchCallbacks) {
    swiper.emit("touchMove", e);
  }
  if (e.targetTouches && e.targetTouches.length > 1)
    return;
  touches.currentX = pageX;
  touches.currentY = pageY;
  const diffX = touches.currentX - touches.startX;
  const diffY = touches.currentY - touches.startY;
  if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold)
    return;
  if (typeof data2.isScrolling === "undefined") {
    let touchAngle;
    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
      data2.isScrolling = false;
    } else {
      if (diffX * diffX + diffY * diffY >= 25) {
        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
        data2.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
      }
    }
  }
  if (data2.isScrolling) {
    swiper.emit("touchMoveOpposite", e);
  }
  if (typeof data2.startMoving === "undefined") {
    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
      data2.startMoving = true;
    }
  }
  if (data2.isScrolling) {
    data2.isTouched = false;
    return;
  }
  if (!data2.startMoving) {
    return;
  }
  swiper.allowClick = false;
  if (!params.cssMode && e.cancelable) {
    e.preventDefault();
  }
  if (params.touchMoveStopPropagation && !params.nested) {
    e.stopPropagation();
  }
  if (!data2.isMoved) {
    if (params.loop && !params.cssMode) {
      swiper.loopFix();
    }
    data2.startTranslate = swiper.getTranslate();
    swiper.setTransition(0);
    if (swiper.animating) {
      swiper.$wrapperEl.trigger("webkitTransitionEnd transitionend");
    }
    data2.allowMomentumBounce = false;
    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(true);
    }
    swiper.emit("sliderFirstMove", e);
  }
  swiper.emit("sliderMove", e);
  data2.isMoved = true;
  let diff = swiper.isHorizontal() ? diffX : diffY;
  touches.diff = diff;
  diff *= params.touchRatio;
  if (rtl)
    diff = -diff;
  swiper.swipeDirection = diff > 0 ? "prev" : "next";
  data2.currentTranslate = diff + data2.startTranslate;
  let disableParentSwiper = true;
  let resistanceRatio = params.resistanceRatio;
  if (params.touchReleaseOnEdges) {
    resistanceRatio = 0;
  }
  if (diff > 0 && data2.currentTranslate > swiper.minTranslate()) {
    disableParentSwiper = false;
    if (params.resistance)
      data2.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data2.startTranslate + diff) ** resistanceRatio;
  } else if (diff < 0 && data2.currentTranslate < swiper.maxTranslate()) {
    disableParentSwiper = false;
    if (params.resistance)
      data2.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data2.startTranslate - diff) ** resistanceRatio;
  }
  if (disableParentSwiper) {
    e.preventedByNestedSwiper = true;
  }
  if (!swiper.allowSlideNext && swiper.swipeDirection === "next" && data2.currentTranslate < data2.startTranslate) {
    data2.currentTranslate = data2.startTranslate;
  }
  if (!swiper.allowSlidePrev && swiper.swipeDirection === "prev" && data2.currentTranslate > data2.startTranslate) {
    data2.currentTranslate = data2.startTranslate;
  }
  if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
    data2.currentTranslate = data2.startTranslate;
  }
  if (params.threshold > 0) {
    if (Math.abs(diff) > params.threshold || data2.allowThresholdMove) {
      if (!data2.allowThresholdMove) {
        data2.allowThresholdMove = true;
        touches.startX = touches.currentX;
        touches.startY = touches.currentY;
        data2.currentTranslate = data2.startTranslate;
        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
        return;
      }
    } else {
      data2.currentTranslate = data2.startTranslate;
      return;
    }
  }
  if (!params.followFinger || params.cssMode)
    return;
  if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }
  if (swiper.params.freeMode && params.freeMode.enabled && swiper.freeMode) {
    swiper.freeMode.onTouchMove();
  }
  swiper.updateProgress(data2.currentTranslate);
  swiper.setTranslate(data2.currentTranslate);
}
function onTouchEnd(event) {
  const swiper = this;
  const data2 = swiper.touchEventsData;
  const {
    params,
    touches,
    rtlTranslate: rtl,
    slidesGrid,
    enabled
  } = swiper;
  if (!enabled)
    return;
  let e = event;
  if (e.originalEvent)
    e = e.originalEvent;
  if (data2.allowTouchCallbacks) {
    swiper.emit("touchEnd", e);
  }
  data2.allowTouchCallbacks = false;
  if (!data2.isTouched) {
    if (data2.isMoved && params.grabCursor) {
      swiper.setGrabCursor(false);
    }
    data2.isMoved = false;
    data2.startMoving = false;
    return;
  }
  if (params.grabCursor && data2.isMoved && data2.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
    swiper.setGrabCursor(false);
  }
  const touchEndTime = now();
  const timeDiff = touchEndTime - data2.touchStartTime;
  if (swiper.allowClick) {
    const pathTree = e.path || e.composedPath && e.composedPath();
    swiper.updateClickedSlide(pathTree && pathTree[0] || e.target);
    swiper.emit("tap click", e);
    if (timeDiff < 300 && touchEndTime - data2.lastClickTime < 300) {
      swiper.emit("doubleTap doubleClick", e);
    }
  }
  data2.lastClickTime = now();
  nextTick$1(() => {
    if (!swiper.destroyed)
      swiper.allowClick = true;
  });
  if (!data2.isTouched || !data2.isMoved || !swiper.swipeDirection || touches.diff === 0 || data2.currentTranslate === data2.startTranslate) {
    data2.isTouched = false;
    data2.isMoved = false;
    data2.startMoving = false;
    return;
  }
  data2.isTouched = false;
  data2.isMoved = false;
  data2.startMoving = false;
  let currentPos;
  if (params.followFinger) {
    currentPos = rtl ? swiper.translate : -swiper.translate;
  } else {
    currentPos = -data2.currentTranslate;
  }
  if (params.cssMode) {
    return;
  }
  if (swiper.params.freeMode && params.freeMode.enabled) {
    swiper.freeMode.onTouchEnd({
      currentPos
    });
    return;
  }
  let stopIndex = 0;
  let groupSize = swiper.slidesSizesGrid[0];
  for (let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
    const increment2 = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (typeof slidesGrid[i + increment2] !== "undefined") {
      if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment2]) {
        stopIndex = i;
        groupSize = slidesGrid[i + increment2] - slidesGrid[i];
      }
    } else if (currentPos >= slidesGrid[i]) {
      stopIndex = i;
      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
    }
  }
  let rewindFirstIndex = null;
  let rewindLastIndex = null;
  if (params.rewind) {
    if (swiper.isBeginning) {
      rewindLastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    } else if (swiper.isEnd) {
      rewindFirstIndex = 0;
    }
  }
  const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
  const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
  if (timeDiff > params.longSwipesMs) {
    if (!params.longSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    if (swiper.swipeDirection === "next") {
      if (ratio >= params.longSwipesRatio)
        swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
      else
        swiper.slideTo(stopIndex);
    }
    if (swiper.swipeDirection === "prev") {
      if (ratio > 1 - params.longSwipesRatio) {
        swiper.slideTo(stopIndex + increment);
      } else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) {
        swiper.slideTo(rewindLastIndex);
      } else {
        swiper.slideTo(stopIndex);
      }
    }
  } else {
    if (!params.shortSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
    if (!isNavButtonTarget) {
      if (swiper.swipeDirection === "next") {
        swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
      }
      if (swiper.swipeDirection === "prev") {
        swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
      }
    } else if (e.target === swiper.navigation.nextEl) {
      swiper.slideTo(stopIndex + increment);
    } else {
      swiper.slideTo(stopIndex);
    }
  }
}
function onResize() {
  const swiper = this;
  const {
    params,
    el
  } = swiper;
  if (el && el.offsetWidth === 0)
    return;
  if (params.breakpoints) {
    swiper.setBreakpoint();
  }
  const {
    allowSlideNext,
    allowSlidePrev,
    snapGrid
  } = swiper;
  swiper.allowSlideNext = true;
  swiper.allowSlidePrev = true;
  swiper.updateSize();
  swiper.updateSlides();
  swiper.updateSlidesClasses();
  if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) {
    swiper.slideTo(swiper.slides.length - 1, 0, false, true);
  } else {
    swiper.slideTo(swiper.activeIndex, 0, false, true);
  }
  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
    swiper.autoplay.run();
  }
  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
    swiper.checkOverflow();
  }
}
function onClick(e) {
  const swiper = this;
  if (!swiper.enabled)
    return;
  if (!swiper.allowClick) {
    if (swiper.params.preventClicks)
      e.preventDefault();
    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}
function onScroll() {
  const swiper = this;
  const {
    wrapperEl,
    rtlTranslate,
    enabled
  } = swiper;
  if (!enabled)
    return;
  swiper.previousTranslate = swiper.translate;
  if (swiper.isHorizontal()) {
    swiper.translate = -wrapperEl.scrollLeft;
  } else {
    swiper.translate = -wrapperEl.scrollTop;
  }
  if (swiper.translate === 0)
    swiper.translate = 0;
  swiper.updateActiveIndex();
  swiper.updateSlidesClasses();
  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
  }
  if (newProgress !== swiper.progress) {
    swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
  }
  swiper.emit("setTranslate", swiper.translate, false);
}
let dummyEventAttached = false;
function dummyEventListener() {
}
const events = (swiper, method) => {
  const document2 = getDocument();
  const {
    params,
    touchEvents,
    el,
    wrapperEl,
    device,
    support: support2
  } = swiper;
  const capture = !!params.nested;
  const domMethod = method === "on" ? "addEventListener" : "removeEventListener";
  const swiperMethod = method;
  if (!support2.touch) {
    el[domMethod](touchEvents.start, swiper.onTouchStart, false);
    document2[domMethod](touchEvents.move, swiper.onTouchMove, capture);
    document2[domMethod](touchEvents.end, swiper.onTouchEnd, false);
  } else {
    const passiveListener = touchEvents.start === "touchstart" && support2.passiveListener && params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    el[domMethod](touchEvents.start, swiper.onTouchStart, passiveListener);
    el[domMethod](touchEvents.move, swiper.onTouchMove, support2.passiveListener ? {
      passive: false,
      capture
    } : capture);
    el[domMethod](touchEvents.end, swiper.onTouchEnd, passiveListener);
    if (touchEvents.cancel) {
      el[domMethod](touchEvents.cancel, swiper.onTouchEnd, passiveListener);
    }
  }
  if (params.preventClicks || params.preventClicksPropagation) {
    el[domMethod]("click", swiper.onClick, true);
  }
  if (params.cssMode) {
    wrapperEl[domMethod]("scroll", swiper.onScroll);
  }
  if (params.updateOnWindowResize) {
    swiper[swiperMethod](device.ios || device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", onResize, true);
  } else {
    swiper[swiperMethod]("observerUpdate", onResize, true);
  }
};
function attachEvents() {
  const swiper = this;
  const document2 = getDocument();
  const {
    params,
    support: support2
  } = swiper;
  swiper.onTouchStart = onTouchStart.bind(swiper);
  swiper.onTouchMove = onTouchMove.bind(swiper);
  swiper.onTouchEnd = onTouchEnd.bind(swiper);
  if (params.cssMode) {
    swiper.onScroll = onScroll.bind(swiper);
  }
  swiper.onClick = onClick.bind(swiper);
  if (support2.touch && !dummyEventAttached) {
    document2.addEventListener("touchstart", dummyEventListener);
    dummyEventAttached = true;
  }
  events(swiper, "on");
}
function detachEvents() {
  const swiper = this;
  events(swiper, "off");
}
const events$1 = {
  attachEvents,
  detachEvents
};
const isGridEnabled = (swiper, params) => {
  return swiper.grid && params.grid && params.grid.rows > 1;
};
function setBreakpoint() {
  const swiper = this;
  const {
    activeIndex,
    initialized,
    loopedSlides = 0,
    params,
    $el
  } = swiper;
  const breakpoints2 = params.breakpoints;
  if (!breakpoints2 || breakpoints2 && Object.keys(breakpoints2).length === 0)
    return;
  const breakpoint = swiper.getBreakpoint(breakpoints2, swiper.params.breakpointsBase, swiper.el);
  if (!breakpoint || swiper.currentBreakpoint === breakpoint)
    return;
  const breakpointOnlyParams = breakpoint in breakpoints2 ? breakpoints2[breakpoint] : void 0;
  const breakpointParams = breakpointOnlyParams || swiper.originalParams;
  const wasMultiRow = isGridEnabled(swiper, params);
  const isMultiRow = isGridEnabled(swiper, breakpointParams);
  const wasEnabled = params.enabled;
  if (wasMultiRow && !isMultiRow) {
    $el.removeClass(`${params.containerModifierClass}grid ${params.containerModifierClass}grid-column`);
    swiper.emitContainerClasses();
  } else if (!wasMultiRow && isMultiRow) {
    $el.addClass(`${params.containerModifierClass}grid`);
    if (breakpointParams.grid.fill && breakpointParams.grid.fill === "column" || !breakpointParams.grid.fill && params.grid.fill === "column") {
      $el.addClass(`${params.containerModifierClass}grid-column`);
    }
    swiper.emitContainerClasses();
  }
  ["navigation", "pagination", "scrollbar"].forEach((prop) => {
    const wasModuleEnabled = params[prop] && params[prop].enabled;
    const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
    if (wasModuleEnabled && !isModuleEnabled) {
      swiper[prop].disable();
    }
    if (!wasModuleEnabled && isModuleEnabled) {
      swiper[prop].enable();
    }
  });
  const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
  const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
  if (directionChanged && initialized) {
    swiper.changeDirection();
  }
  extend(swiper.params, breakpointParams);
  const isEnabled = swiper.params.enabled;
  Object.assign(swiper, {
    allowTouchMove: swiper.params.allowTouchMove,
    allowSlideNext: swiper.params.allowSlideNext,
    allowSlidePrev: swiper.params.allowSlidePrev
  });
  if (wasEnabled && !isEnabled) {
    swiper.disable();
  } else if (!wasEnabled && isEnabled) {
    swiper.enable();
  }
  swiper.currentBreakpoint = breakpoint;
  swiper.emit("_beforeBreakpoint", breakpointParams);
  if (needsReLoop && initialized) {
    swiper.loopDestroy();
    swiper.loopCreate();
    swiper.updateSlides();
    swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
  }
  swiper.emit("breakpoint", breakpointParams);
}
function getBreakpoint(breakpoints2, base = "window", containerEl) {
  if (!breakpoints2 || base === "container" && !containerEl)
    return void 0;
  let breakpoint = false;
  const window2 = getWindow();
  const currentHeight = base === "window" ? window2.innerHeight : containerEl.clientHeight;
  const points = Object.keys(breakpoints2).map((point) => {
    if (typeof point === "string" && point.indexOf("@") === 0) {
      const minRatio = parseFloat(point.substr(1));
      const value = currentHeight * minRatio;
      return {
        value,
        point
      };
    }
    return {
      value: point,
      point
    };
  });
  points.sort((a, b) => parseInt(a.value, 10) - parseInt(b.value, 10));
  for (let i = 0; i < points.length; i += 1) {
    const {
      point,
      value
    } = points[i];
    if (base === "window") {
      if (window2.matchMedia(`(min-width: ${value}px)`).matches) {
        breakpoint = point;
      }
    } else if (value <= containerEl.clientWidth) {
      breakpoint = point;
    }
  }
  return breakpoint || "max";
}
const breakpoints = {
  setBreakpoint,
  getBreakpoint
};
function prepareClasses(entries, prefix2) {
  const resultClasses = [];
  entries.forEach((item) => {
    if (typeof item === "object") {
      Object.keys(item).forEach((classNames) => {
        if (item[classNames]) {
          resultClasses.push(prefix2 + classNames);
        }
      });
    } else if (typeof item === "string") {
      resultClasses.push(prefix2 + item);
    }
  });
  return resultClasses;
}
function addClasses() {
  const swiper = this;
  const {
    classNames,
    params,
    rtl,
    $el,
    device,
    support: support2
  } = swiper;
  const suffixes = prepareClasses(["initialized", params.direction, {
    "pointer-events": !support2.touch
  }, {
    "free-mode": swiper.params.freeMode && params.freeMode.enabled
  }, {
    "autoheight": params.autoHeight
  }, {
    "rtl": rtl
  }, {
    "grid": params.grid && params.grid.rows > 1
  }, {
    "grid-column": params.grid && params.grid.rows > 1 && params.grid.fill === "column"
  }, {
    "android": device.android
  }, {
    "ios": device.ios
  }, {
    "css-mode": params.cssMode
  }, {
    "centered": params.cssMode && params.centeredSlides
  }, {
    "watch-progress": params.watchSlidesProgress
  }], params.containerModifierClass);
  classNames.push(...suffixes);
  $el.addClass([...classNames].join(" "));
  swiper.emitContainerClasses();
}
function removeClasses() {
  const swiper = this;
  const {
    $el,
    classNames
  } = swiper;
  $el.removeClass(classNames.join(" "));
  swiper.emitContainerClasses();
}
const classes = {
  addClasses,
  removeClasses
};
function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
  const window2 = getWindow();
  let image;
  function onReady() {
    if (callback)
      callback();
  }
  const isPicture = $(imageEl).parent("picture")[0];
  if (!isPicture && (!imageEl.complete || !checkForComplete)) {
    if (src) {
      image = new window2.Image();
      image.onload = onReady;
      image.onerror = onReady;
      if (sizes) {
        image.sizes = sizes;
      }
      if (srcset) {
        image.srcset = srcset;
      }
      if (src) {
        image.src = src;
      }
    } else {
      onReady();
    }
  } else {
    onReady();
  }
}
function preloadImages() {
  const swiper = this;
  swiper.imagesToLoad = swiper.$el.find("img");
  function onReady() {
    if (typeof swiper === "undefined" || swiper === null || !swiper || swiper.destroyed)
      return;
    if (swiper.imagesLoaded !== void 0)
      swiper.imagesLoaded += 1;
    if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
      if (swiper.params.updateOnImagesReady)
        swiper.update();
      swiper.emit("imagesReady");
    }
  }
  for (let i = 0; i < swiper.imagesToLoad.length; i += 1) {
    const imageEl = swiper.imagesToLoad[i];
    swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute("src"), imageEl.srcset || imageEl.getAttribute("srcset"), imageEl.sizes || imageEl.getAttribute("sizes"), true, onReady);
  }
}
const images = {
  loadImage,
  preloadImages
};
function checkOverflow() {
  const swiper = this;
  const {
    isLocked: wasLocked,
    params
  } = swiper;
  const {
    slidesOffsetBefore
  } = params;
  if (slidesOffsetBefore) {
    const lastSlideIndex = swiper.slides.length - 1;
    const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
    swiper.isLocked = swiper.size > lastSlideRightEdge;
  } else {
    swiper.isLocked = swiper.snapGrid.length === 1;
  }
  if (params.allowSlideNext === true) {
    swiper.allowSlideNext = !swiper.isLocked;
  }
  if (params.allowSlidePrev === true) {
    swiper.allowSlidePrev = !swiper.isLocked;
  }
  if (wasLocked && wasLocked !== swiper.isLocked) {
    swiper.isEnd = false;
  }
  if (wasLocked !== swiper.isLocked) {
    swiper.emit(swiper.isLocked ? "lock" : "unlock");
  }
}
const checkOverflow$1 = {
  checkOverflow
};
const defaults$1 = {
  init: true,
  direction: "horizontal",
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: false,
  updateOnWindowResize: true,
  resizeObserver: true,
  nested: false,
  createElements: false,
  enabled: true,
  focusableElements: "input, select, option, textarea, button, video, label",
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: false,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: false,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: false,
  // Set wrapper width
  setWrapperSize: false,
  // Virtual Translate
  virtualTranslate: false,
  // Effects
  effect: "slide",
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: void 0,
  breakpointsBase: "window",
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: false,
  centeredSlides: false,
  centeredSlidesBounds: false,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: true,
  centerInsufficientSlides: false,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: true,
  // Round length
  roundLengths: false,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: true,
  shortSwipes: true,
  longSwipes: true,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: true,
  allowTouchMove: true,
  threshold: 0,
  touchMoveStopPropagation: false,
  touchStartPreventDefault: true,
  touchStartForcePreventDefault: false,
  touchReleaseOnEdges: false,
  // Unique Navigation Elements
  uniqueNavElements: true,
  // Resistance
  resistance: true,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: false,
  // Cursor
  grabCursor: false,
  // Clicks
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: false,
  // Images
  preloadImages: true,
  updateOnImagesReady: true,
  // loop
  loop: false,
  loopAdditionalSlides: 0,
  loopedSlides: null,
  loopedSlidesLimit: true,
  loopFillGroupWithBlank: false,
  loopPreventsSlide: true,
  // rewind
  rewind: false,
  // Swiping/no swiping
  allowSlidePrev: true,
  allowSlideNext: true,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: true,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: true,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: "swiper-",
  // NEW
  slideClass: "swiper-slide",
  slideBlankClass: "swiper-slide-invisible-blank",
  slideActiveClass: "swiper-slide-active",
  slideDuplicateActiveClass: "swiper-slide-duplicate-active",
  slideVisibleClass: "swiper-slide-visible",
  slideDuplicateClass: "swiper-slide-duplicate",
  slideNextClass: "swiper-slide-next",
  slideDuplicateNextClass: "swiper-slide-duplicate-next",
  slidePrevClass: "swiper-slide-prev",
  slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
  wrapperClass: "swiper-wrapper",
  // Callbacks
  runCallbacksOnInit: true,
  // Internals
  _emitClasses: false
};
function moduleExtendParams(params, allModulesParams) {
  return function extendParams(obj = {}) {
    const moduleParamName = Object.keys(obj)[0];
    const moduleParams = obj[moduleParamName];
    if (typeof moduleParams !== "object" || moduleParams === null) {
      extend(allModulesParams, obj);
      return;
    }
    if (["navigation", "pagination", "scrollbar"].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) {
      params[moduleParamName] = {
        auto: true
      };
    }
    if (!(moduleParamName in params && "enabled" in moduleParams)) {
      extend(allModulesParams, obj);
      return;
    }
    if (params[moduleParamName] === true) {
      params[moduleParamName] = {
        enabled: true
      };
    }
    if (typeof params[moduleParamName] === "object" && !("enabled" in params[moduleParamName])) {
      params[moduleParamName].enabled = true;
    }
    if (!params[moduleParamName])
      params[moduleParamName] = {
        enabled: false
      };
    extend(allModulesParams, obj);
  };
}
const prototypes = {
  eventsEmitter,
  update,
  translate,
  transition: transition$1,
  slide,
  loop: loop$1,
  grabCursor,
  events: events$1,
  breakpoints,
  checkOverflow: checkOverflow$1,
  classes,
  images
};
const extendedDefaults = {};
class Swiper {
  constructor(...args) {
    let el;
    let params;
    if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === "Object") {
      params = args[0];
    } else {
      [el, params] = args;
    }
    if (!params)
      params = {};
    params = extend({}, params);
    if (el && !params.el)
      params.el = el;
    if (params.el && $(params.el).length > 1) {
      const swipers = [];
      $(params.el).each((containerEl) => {
        const newParams = extend({}, params, {
          el: containerEl
        });
        swipers.push(new Swiper(newParams));
      });
      return swipers;
    }
    const swiper = this;
    swiper.__swiper__ = true;
    swiper.support = getSupport();
    swiper.device = getDevice({
      userAgent: params.userAgent
    });
    swiper.browser = getBrowser();
    swiper.eventsListeners = {};
    swiper.eventsAnyListeners = [];
    swiper.modules = [...swiper.__modules__];
    if (params.modules && Array.isArray(params.modules)) {
      swiper.modules.push(...params.modules);
    }
    const allModulesParams = {};
    swiper.modules.forEach((mod) => {
      mod({
        swiper,
        extendParams: moduleExtendParams(params, allModulesParams),
        on: swiper.on.bind(swiper),
        once: swiper.once.bind(swiper),
        off: swiper.off.bind(swiper),
        emit: swiper.emit.bind(swiper)
      });
    });
    const swiperParams = extend({}, defaults$1, allModulesParams);
    swiper.params = extend({}, swiperParams, extendedDefaults, params);
    swiper.originalParams = extend({}, swiper.params);
    swiper.passedParams = extend({}, params);
    if (swiper.params && swiper.params.on) {
      Object.keys(swiper.params.on).forEach((eventName) => {
        swiper.on(eventName, swiper.params.on[eventName]);
      });
    }
    if (swiper.params && swiper.params.onAny) {
      swiper.onAny(swiper.params.onAny);
    }
    swiper.$ = $;
    Object.assign(swiper, {
      enabled: swiper.params.enabled,
      el,
      // Classes
      classNames: [],
      // Slides
      slides: $(),
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return swiper.params.direction === "horizontal";
      },
      isVertical() {
        return swiper.params.direction === "vertical";
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: true,
      isEnd: false,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: false,
      // Locks
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,
      // Touch Events
      touchEvents: function touchEvents() {
        const touch = ["touchstart", "touchmove", "touchend", "touchcancel"];
        const desktop = ["pointerdown", "pointermove", "pointerup"];
        swiper.touchEventsTouch = {
          start: touch[0],
          move: touch[1],
          end: touch[2],
          cancel: touch[3]
        };
        swiper.touchEventsDesktop = {
          start: desktop[0],
          move: desktop[1],
          end: desktop[2]
        };
        return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
      }(),
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        // Form elements to match
        focusableElements: swiper.params.focusableElements,
        // Last click time
        lastClickTime: now(),
        clickTimeout: void 0,
        // Velocities
        velocities: [],
        allowMomentumBounce: void 0,
        isTouchEvent: void 0,
        startMoving: void 0
      },
      // Clicks
      allowClick: true,
      // Touches
      allowTouchMove: swiper.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    });
    swiper.emit("_swiper");
    if (swiper.params.init) {
      swiper.init();
    }
    return swiper;
  }
  enable() {
    const swiper = this;
    if (swiper.enabled)
      return;
    swiper.enabled = true;
    if (swiper.params.grabCursor) {
      swiper.setGrabCursor();
    }
    swiper.emit("enable");
  }
  disable() {
    const swiper = this;
    if (!swiper.enabled)
      return;
    swiper.enabled = false;
    if (swiper.params.grabCursor) {
      swiper.unsetGrabCursor();
    }
    swiper.emit("disable");
  }
  setProgress(progress, speed) {
    const swiper = this;
    progress = Math.min(Math.max(progress, 0), 1);
    const min = swiper.minTranslate();
    const max = swiper.maxTranslate();
    const current = (max - min) * progress + min;
    swiper.translateTo(current, typeof speed === "undefined" ? 0 : speed);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }
  emitContainerClasses() {
    const swiper = this;
    if (!swiper.params._emitClasses || !swiper.el)
      return;
    const cls = swiper.el.className.split(" ").filter((className) => {
      return className.indexOf("swiper") === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
    });
    swiper.emit("_containerClasses", cls.join(" "));
  }
  getSlideClasses(slideEl) {
    const swiper = this;
    if (swiper.destroyed)
      return "";
    return slideEl.className.split(" ").filter((className) => {
      return className.indexOf("swiper-slide") === 0 || className.indexOf(swiper.params.slideClass) === 0;
    }).join(" ");
  }
  emitSlidesClasses() {
    const swiper = this;
    if (!swiper.params._emitClasses || !swiper.el)
      return;
    const updates = [];
    swiper.slides.each((slideEl) => {
      const classNames = swiper.getSlideClasses(slideEl);
      updates.push({
        slideEl,
        classNames
      });
      swiper.emit("_slideClass", slideEl, classNames);
    });
    swiper.emit("_slideClasses", updates);
  }
  slidesPerViewDynamic(view = "current", exact = false) {
    const swiper = this;
    const {
      params,
      slides,
      slidesGrid,
      slidesSizesGrid,
      size: swiperSize,
      activeIndex
    } = swiper;
    let spv = 1;
    if (params.centeredSlides) {
      let slideSize = slides[activeIndex].swiperSlideSize;
      let breakLoop;
      for (let i = activeIndex + 1; i < slides.length; i += 1) {
        if (slides[i] && !breakLoop) {
          slideSize += slides[i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize)
            breakLoop = true;
        }
      }
      for (let i = activeIndex - 1; i >= 0; i -= 1) {
        if (slides[i] && !breakLoop) {
          slideSize += slides[i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize)
            breakLoop = true;
        }
      }
    } else {
      if (view === "current") {
        for (let i = activeIndex + 1; i < slides.length; i += 1) {
          const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
          if (slideInView) {
            spv += 1;
          }
        }
      } else {
        for (let i = activeIndex - 1; i >= 0; i -= 1) {
          const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
          if (slideInView) {
            spv += 1;
          }
        }
      }
    }
    return spv;
  }
  update() {
    const swiper = this;
    if (!swiper || swiper.destroyed)
      return;
    const {
      snapGrid,
      params
    } = swiper;
    if (params.breakpoints) {
      swiper.setBreakpoint();
    }
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateProgress();
    swiper.updateSlidesClasses();
    function setTranslate2() {
      const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
      const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
      swiper.setTranslate(newTranslate);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
    let translated;
    if (swiper.params.freeMode && swiper.params.freeMode.enabled) {
      setTranslate2();
      if (swiper.params.autoHeight) {
        swiper.updateAutoHeight();
      }
    } else {
      if ((swiper.params.slidesPerView === "auto" || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
        translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
      } else {
        translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
      }
      if (!translated) {
        setTranslate2();
      }
    }
    if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }
    swiper.emit("update");
  }
  changeDirection(newDirection, needUpdate = true) {
    const swiper = this;
    const currentDirection = swiper.params.direction;
    if (!newDirection) {
      newDirection = currentDirection === "horizontal" ? "vertical" : "horizontal";
    }
    if (newDirection === currentDirection || newDirection !== "horizontal" && newDirection !== "vertical") {
      return swiper;
    }
    swiper.$el.removeClass(`${swiper.params.containerModifierClass}${currentDirection}`).addClass(`${swiper.params.containerModifierClass}${newDirection}`);
    swiper.emitContainerClasses();
    swiper.params.direction = newDirection;
    swiper.slides.each((slideEl) => {
      if (newDirection === "vertical") {
        slideEl.style.width = "";
      } else {
        slideEl.style.height = "";
      }
    });
    swiper.emit("changeDirection");
    if (needUpdate)
      swiper.update();
    return swiper;
  }
  changeLanguageDirection(direction) {
    const swiper = this;
    if (swiper.rtl && direction === "rtl" || !swiper.rtl && direction === "ltr")
      return;
    swiper.rtl = direction === "rtl";
    swiper.rtlTranslate = swiper.params.direction === "horizontal" && swiper.rtl;
    if (swiper.rtl) {
      swiper.$el.addClass(`${swiper.params.containerModifierClass}rtl`);
      swiper.el.dir = "rtl";
    } else {
      swiper.$el.removeClass(`${swiper.params.containerModifierClass}rtl`);
      swiper.el.dir = "ltr";
    }
    swiper.update();
  }
  mount(el) {
    const swiper = this;
    if (swiper.mounted)
      return true;
    const $el = $(el || swiper.params.el);
    el = $el[0];
    if (!el) {
      return false;
    }
    el.swiper = swiper;
    const getWrapperSelector = () => {
      return `.${(swiper.params.wrapperClass || "").trim().split(" ").join(".")}`;
    };
    const getWrapper = () => {
      if (el && el.shadowRoot && el.shadowRoot.querySelector) {
        const res = $(el.shadowRoot.querySelector(getWrapperSelector()));
        res.children = (options) => $el.children(options);
        return res;
      }
      if (!$el.children) {
        return $($el).children(getWrapperSelector());
      }
      return $el.children(getWrapperSelector());
    };
    let $wrapperEl = getWrapper();
    if ($wrapperEl.length === 0 && swiper.params.createElements) {
      const document2 = getDocument();
      const wrapper = document2.createElement("div");
      $wrapperEl = $(wrapper);
      wrapper.className = swiper.params.wrapperClass;
      $el.append(wrapper);
      $el.children(`.${swiper.params.slideClass}`).each((slideEl) => {
        $wrapperEl.append(slideEl);
      });
    }
    Object.assign(swiper, {
      $el,
      el,
      $wrapperEl,
      wrapperEl: $wrapperEl[0],
      mounted: true,
      // RTL
      rtl: el.dir.toLowerCase() === "rtl" || $el.css("direction") === "rtl",
      rtlTranslate: swiper.params.direction === "horizontal" && (el.dir.toLowerCase() === "rtl" || $el.css("direction") === "rtl"),
      wrongRTL: $wrapperEl.css("display") === "-webkit-box"
    });
    return true;
  }
  init(el) {
    const swiper = this;
    if (swiper.initialized)
      return swiper;
    const mounted = swiper.mount(el);
    if (mounted === false)
      return swiper;
    swiper.emit("beforeInit");
    if (swiper.params.breakpoints) {
      swiper.setBreakpoint();
    }
    swiper.addClasses();
    if (swiper.params.loop) {
      swiper.loopCreate();
    }
    swiper.updateSize();
    swiper.updateSlides();
    if (swiper.params.watchOverflow) {
      swiper.checkOverflow();
    }
    if (swiper.params.grabCursor && swiper.enabled) {
      swiper.setGrabCursor();
    }
    if (swiper.params.preloadImages) {
      swiper.preloadImages();
    }
    if (swiper.params.loop) {
      swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
    } else {
      swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
    }
    swiper.attachEvents();
    swiper.initialized = true;
    swiper.emit("init");
    swiper.emit("afterInit");
    return swiper;
  }
  destroy(deleteInstance = true, cleanStyles = true) {
    const swiper = this;
    const {
      params,
      $el,
      $wrapperEl,
      slides
    } = swiper;
    if (typeof swiper.params === "undefined" || swiper.destroyed) {
      return null;
    }
    swiper.emit("beforeDestroy");
    swiper.initialized = false;
    swiper.detachEvents();
    if (params.loop) {
      swiper.loopDestroy();
    }
    if (cleanStyles) {
      swiper.removeClasses();
      $el.removeAttr("style");
      $wrapperEl.removeAttr("style");
      if (slides && slides.length) {
        slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index");
      }
    }
    swiper.emit("destroy");
    Object.keys(swiper.eventsListeners).forEach((eventName) => {
      swiper.off(eventName);
    });
    if (deleteInstance !== false) {
      swiper.$el[0].swiper = null;
      deleteProps(swiper);
    }
    swiper.destroyed = true;
    return null;
  }
  static extendDefaults(newDefaults) {
    extend(extendedDefaults, newDefaults);
  }
  static get extendedDefaults() {
    return extendedDefaults;
  }
  static get defaults() {
    return defaults$1;
  }
  static installModule(mod) {
    if (!Swiper.prototype.__modules__)
      Swiper.prototype.__modules__ = [];
    const modules = Swiper.prototype.__modules__;
    if (typeof mod === "function" && modules.indexOf(mod) < 0) {
      modules.push(mod);
    }
  }
  static use(module) {
    if (Array.isArray(module)) {
      module.forEach((m) => Swiper.installModule(m));
      return Swiper;
    }
    Swiper.installModule(module);
    return Swiper;
  }
}
Object.keys(prototypes).forEach((prototypeGroup) => {
  Object.keys(prototypes[prototypeGroup]).forEach((protoMethod) => {
    Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
  });
});
Swiper.use([Resize, Observer]);
function createElementIfNotDefined(swiper, originalParams, params, checkProps) {
  const document2 = getDocument();
  if (swiper.params.createElements) {
    Object.keys(checkProps).forEach((key) => {
      if (!params[key] && params.auto === true) {
        let element = swiper.$el.children(`.${checkProps[key]}`)[0];
        if (!element) {
          element = document2.createElement("div");
          element.className = checkProps[key];
          swiper.$el.append(element);
        }
        params[key] = element;
        originalParams[key] = element;
      }
    });
  }
  return params;
}
function Navigation({
  swiper,
  extendParams,
  on: on2,
  emit
}) {
  extendParams({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: false,
      disabledClass: "swiper-button-disabled",
      hiddenClass: "swiper-button-hidden",
      lockClass: "swiper-button-lock",
      navigationDisabledClass: "swiper-navigation-disabled"
    }
  });
  swiper.navigation = {
    nextEl: null,
    $nextEl: null,
    prevEl: null,
    $prevEl: null
  };
  function getEl(el) {
    let $el;
    if (el) {
      $el = $(el);
      if (swiper.params.uniqueNavElements && typeof el === "string" && $el.length > 1 && swiper.$el.find(el).length === 1) {
        $el = swiper.$el.find(el);
      }
    }
    return $el;
  }
  function toggleEl($el, disabled) {
    const params = swiper.params.navigation;
    if ($el && $el.length > 0) {
      $el[disabled ? "addClass" : "removeClass"](params.disabledClass);
      if ($el[0] && $el[0].tagName === "BUTTON")
        $el[0].disabled = disabled;
      if (swiper.params.watchOverflow && swiper.enabled) {
        $el[swiper.isLocked ? "addClass" : "removeClass"](params.lockClass);
      }
    }
  }
  function update2() {
    if (swiper.params.loop)
      return;
    const {
      $nextEl,
      $prevEl
    } = swiper.navigation;
    toggleEl($prevEl, swiper.isBeginning && !swiper.params.rewind);
    toggleEl($nextEl, swiper.isEnd && !swiper.params.rewind);
  }
  function onPrevClick(e) {
    e.preventDefault();
    if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind)
      return;
    swiper.slidePrev();
    emit("navigationPrev");
  }
  function onNextClick(e) {
    e.preventDefault();
    if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind)
      return;
    swiper.slideNext();
    emit("navigationNext");
  }
  function init2() {
    const params = swiper.params.navigation;
    swiper.params.navigation = createElementIfNotDefined(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
      nextEl: "swiper-button-next",
      prevEl: "swiper-button-prev"
    });
    if (!(params.nextEl || params.prevEl))
      return;
    const $nextEl = getEl(params.nextEl);
    const $prevEl = getEl(params.prevEl);
    if ($nextEl && $nextEl.length > 0) {
      $nextEl.on("click", onNextClick);
    }
    if ($prevEl && $prevEl.length > 0) {
      $prevEl.on("click", onPrevClick);
    }
    Object.assign(swiper.navigation, {
      $nextEl,
      nextEl: $nextEl && $nextEl[0],
      $prevEl,
      prevEl: $prevEl && $prevEl[0]
    });
    if (!swiper.enabled) {
      if ($nextEl)
        $nextEl.addClass(params.lockClass);
      if ($prevEl)
        $prevEl.addClass(params.lockClass);
    }
  }
  function destroy() {
    const {
      $nextEl,
      $prevEl
    } = swiper.navigation;
    if ($nextEl && $nextEl.length) {
      $nextEl.off("click", onNextClick);
      $nextEl.removeClass(swiper.params.navigation.disabledClass);
    }
    if ($prevEl && $prevEl.length) {
      $prevEl.off("click", onPrevClick);
      $prevEl.removeClass(swiper.params.navigation.disabledClass);
    }
  }
  on2("init", () => {
    if (swiper.params.navigation.enabled === false) {
      disable();
    } else {
      init2();
      update2();
    }
  });
  on2("toEdge fromEdge lock unlock", () => {
    update2();
  });
  on2("destroy", () => {
    destroy();
  });
  on2("enable disable", () => {
    const {
      $nextEl,
      $prevEl
    } = swiper.navigation;
    if ($nextEl) {
      $nextEl[swiper.enabled ? "removeClass" : "addClass"](swiper.params.navigation.lockClass);
    }
    if ($prevEl) {
      $prevEl[swiper.enabled ? "removeClass" : "addClass"](swiper.params.navigation.lockClass);
    }
  });
  on2("click", (_s, e) => {
    const {
      $nextEl,
      $prevEl
    } = swiper.navigation;
    const targetEl = e.target;
    if (swiper.params.navigation.hideOnClick && !$(targetEl).is($prevEl) && !$(targetEl).is($nextEl)) {
      if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl)))
        return;
      let isHidden;
      if ($nextEl) {
        isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
      } else if ($prevEl) {
        isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
      }
      if (isHidden === true) {
        emit("navigationShow");
      } else {
        emit("navigationHide");
      }
      if ($nextEl) {
        $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
      }
      if ($prevEl) {
        $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
      }
    }
  });
  const enable = () => {
    swiper.$el.removeClass(swiper.params.navigation.navigationDisabledClass);
    init2();
    update2();
  };
  const disable = () => {
    swiper.$el.addClass(swiper.params.navigation.navigationDisabledClass);
    destroy();
  };
  Object.assign(swiper.navigation, {
    enable,
    disable,
    update: update2,
    init: init2,
    destroy
  });
}
function classesToSelector(classes2 = "") {
  return `.${classes2.trim().replace(/([\.:!\/])/g, "\\$1").replace(/ /g, ".")}`;
}
function Pagination({
  swiper,
  extendParams,
  on: on2,
  emit
}) {
  const pfx = "swiper-pagination";
  extendParams({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: false,
      hideOnClick: false,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: false,
      type: "bullets",
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: false,
      dynamicMainBullets: 1,
      formatFractionCurrent: (number) => number,
      formatFractionTotal: (number) => number,
      bulletClass: `${pfx}-bullet`,
      bulletActiveClass: `${pfx}-bullet-active`,
      modifierClass: `${pfx}-`,
      currentClass: `${pfx}-current`,
      totalClass: `${pfx}-total`,
      hiddenClass: `${pfx}-hidden`,
      progressbarFillClass: `${pfx}-progressbar-fill`,
      progressbarOppositeClass: `${pfx}-progressbar-opposite`,
      clickableClass: `${pfx}-clickable`,
      lockClass: `${pfx}-lock`,
      horizontalClass: `${pfx}-horizontal`,
      verticalClass: `${pfx}-vertical`,
      paginationDisabledClass: `${pfx}-disabled`
    }
  });
  swiper.pagination = {
    el: null,
    $el: null,
    bullets: []
  };
  let bulletSize;
  let dynamicBulletIndex = 0;
  function isPaginationDisabled() {
    return !swiper.params.pagination.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0;
  }
  function setSideBullets($bulletEl, position) {
    const {
      bulletActiveClass
    } = swiper.params.pagination;
    $bulletEl[position]().addClass(`${bulletActiveClass}-${position}`)[position]().addClass(`${bulletActiveClass}-${position}-${position}`);
  }
  function update2() {
    const rtl = swiper.rtl;
    const params = swiper.params.pagination;
    if (isPaginationDisabled())
      return;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    const $el = swiper.pagination.$el;
    let current;
    const total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
    if (swiper.params.loop) {
      current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
      if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
        current -= slidesLength - swiper.loopedSlides * 2;
      }
      if (current > total - 1)
        current -= total;
      if (current < 0 && swiper.params.paginationType !== "bullets")
        current = total + current;
    } else if (typeof swiper.snapIndex !== "undefined") {
      current = swiper.snapIndex;
    } else {
      current = swiper.activeIndex || 0;
    }
    if (params.type === "bullets" && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
      const bullets = swiper.pagination.bullets;
      let firstIndex;
      let lastIndex;
      let midIndex;
      if (params.dynamicBullets) {
        bulletSize = bullets.eq(0)[swiper.isHorizontal() ? "outerWidth" : "outerHeight"](true);
        $el.css(swiper.isHorizontal() ? "width" : "height", `${bulletSize * (params.dynamicMainBullets + 4)}px`);
        if (params.dynamicMainBullets > 1 && swiper.previousIndex !== void 0) {
          dynamicBulletIndex += current - (swiper.previousIndex - swiper.loopedSlides || 0);
          if (dynamicBulletIndex > params.dynamicMainBullets - 1) {
            dynamicBulletIndex = params.dynamicMainBullets - 1;
          } else if (dynamicBulletIndex < 0) {
            dynamicBulletIndex = 0;
          }
        }
        firstIndex = Math.max(current - dynamicBulletIndex, 0);
        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
        midIndex = (lastIndex + firstIndex) / 2;
      }
      bullets.removeClass(["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((suffix) => `${params.bulletActiveClass}${suffix}`).join(" "));
      if ($el.length > 1) {
        bullets.each((bullet) => {
          const $bullet = $(bullet);
          const bulletIndex = $bullet.index();
          if (bulletIndex === current) {
            $bullet.addClass(params.bulletActiveClass);
          }
          if (params.dynamicBullets) {
            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
              $bullet.addClass(`${params.bulletActiveClass}-main`);
            }
            if (bulletIndex === firstIndex) {
              setSideBullets($bullet, "prev");
            }
            if (bulletIndex === lastIndex) {
              setSideBullets($bullet, "next");
            }
          }
        });
      } else {
        const $bullet = bullets.eq(current);
        const bulletIndex = $bullet.index();
        $bullet.addClass(params.bulletActiveClass);
        if (params.dynamicBullets) {
          const $firstDisplayedBullet = bullets.eq(firstIndex);
          const $lastDisplayedBullet = bullets.eq(lastIndex);
          for (let i = firstIndex; i <= lastIndex; i += 1) {
            bullets.eq(i).addClass(`${params.bulletActiveClass}-main`);
          }
          if (swiper.params.loop) {
            if (bulletIndex >= bullets.length) {
              for (let i = params.dynamicMainBullets; i >= 0; i -= 1) {
                bullets.eq(bullets.length - i).addClass(`${params.bulletActiveClass}-main`);
              }
              bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(`${params.bulletActiveClass}-prev`);
            } else {
              setSideBullets($firstDisplayedBullet, "prev");
              setSideBullets($lastDisplayedBullet, "next");
            }
          } else {
            setSideBullets($firstDisplayedBullet, "prev");
            setSideBullets($lastDisplayedBullet, "next");
          }
        }
      }
      if (params.dynamicBullets) {
        const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
        const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
        const offsetProp = rtl ? "right" : "left";
        bullets.css(swiper.isHorizontal() ? offsetProp : "top", `${bulletsOffset}px`);
      }
    }
    if (params.type === "fraction") {
      $el.find(classesToSelector(params.currentClass)).text(params.formatFractionCurrent(current + 1));
      $el.find(classesToSelector(params.totalClass)).text(params.formatFractionTotal(total));
    }
    if (params.type === "progressbar") {
      let progressbarDirection;
      if (params.progressbarOpposite) {
        progressbarDirection = swiper.isHorizontal() ? "vertical" : "horizontal";
      } else {
        progressbarDirection = swiper.isHorizontal() ? "horizontal" : "vertical";
      }
      const scale = (current + 1) / total;
      let scaleX = 1;
      let scaleY = 1;
      if (progressbarDirection === "horizontal") {
        scaleX = scale;
      } else {
        scaleY = scale;
      }
      $el.find(classesToSelector(params.progressbarFillClass)).transform(`translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`).transition(swiper.params.speed);
    }
    if (params.type === "custom" && params.renderCustom) {
      $el.html(params.renderCustom(swiper, current + 1, total));
      emit("paginationRender", $el[0]);
    } else {
      emit("paginationUpdate", $el[0]);
    }
    if (swiper.params.watchOverflow && swiper.enabled) {
      $el[swiper.isLocked ? "addClass" : "removeClass"](params.lockClass);
    }
  }
  function render() {
    const params = swiper.params.pagination;
    if (isPaginationDisabled())
      return;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    const $el = swiper.pagination.$el;
    let paginationHTML = "";
    if (params.type === "bullets") {
      let numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
      if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.loop && numberOfBullets > slidesLength) {
        numberOfBullets = slidesLength;
      }
      for (let i = 0; i < numberOfBullets; i += 1) {
        if (params.renderBullet) {
          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
        } else {
          paginationHTML += `<${params.bulletElement} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
      }
      $el.html(paginationHTML);
      swiper.pagination.bullets = $el.find(classesToSelector(params.bulletClass));
    }
    if (params.type === "fraction") {
      if (params.renderFraction) {
        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
      } else {
        paginationHTML = `<span class="${params.currentClass}"></span> / <span class="${params.totalClass}"></span>`;
      }
      $el.html(paginationHTML);
    }
    if (params.type === "progressbar") {
      if (params.renderProgressbar) {
        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
      } else {
        paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
      }
      $el.html(paginationHTML);
    }
    if (params.type !== "custom") {
      emit("paginationRender", swiper.pagination.$el[0]);
    }
  }
  function init2() {
    swiper.params.pagination = createElementIfNotDefined(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
      el: "swiper-pagination"
    });
    const params = swiper.params.pagination;
    if (!params.el)
      return;
    let $el = $(params.el);
    if ($el.length === 0)
      return;
    if (swiper.params.uniqueNavElements && typeof params.el === "string" && $el.length > 1) {
      $el = swiper.$el.find(params.el);
      if ($el.length > 1) {
        $el = $el.filter((el) => {
          if ($(el).parents(".swiper")[0] !== swiper.el)
            return false;
          return true;
        });
      }
    }
    if (params.type === "bullets" && params.clickable) {
      $el.addClass(params.clickableClass);
    }
    $el.addClass(params.modifierClass + params.type);
    $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    if (params.type === "bullets" && params.dynamicBullets) {
      $el.addClass(`${params.modifierClass}${params.type}-dynamic`);
      dynamicBulletIndex = 0;
      if (params.dynamicMainBullets < 1) {
        params.dynamicMainBullets = 1;
      }
    }
    if (params.type === "progressbar" && params.progressbarOpposite) {
      $el.addClass(params.progressbarOppositeClass);
    }
    if (params.clickable) {
      $el.on("click", classesToSelector(params.bulletClass), function onClick2(e) {
        e.preventDefault();
        let index2 = $(this).index() * swiper.params.slidesPerGroup;
        if (swiper.params.loop)
          index2 += swiper.loopedSlides;
        swiper.slideTo(index2);
      });
    }
    Object.assign(swiper.pagination, {
      $el,
      el: $el[0]
    });
    if (!swiper.enabled) {
      $el.addClass(params.lockClass);
    }
  }
  function destroy() {
    const params = swiper.params.pagination;
    if (isPaginationDisabled())
      return;
    const $el = swiper.pagination.$el;
    $el.removeClass(params.hiddenClass);
    $el.removeClass(params.modifierClass + params.type);
    $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    if (swiper.pagination.bullets && swiper.pagination.bullets.removeClass)
      swiper.pagination.bullets.removeClass(params.bulletActiveClass);
    if (params.clickable) {
      $el.off("click", classesToSelector(params.bulletClass));
    }
  }
  on2("init", () => {
    if (swiper.params.pagination.enabled === false) {
      disable();
    } else {
      init2();
      render();
      update2();
    }
  });
  on2("activeIndexChange", () => {
    if (swiper.params.loop) {
      update2();
    } else if (typeof swiper.snapIndex === "undefined") {
      update2();
    }
  });
  on2("snapIndexChange", () => {
    if (!swiper.params.loop) {
      update2();
    }
  });
  on2("slidesLengthChange", () => {
    if (swiper.params.loop) {
      render();
      update2();
    }
  });
  on2("snapGridLengthChange", () => {
    if (!swiper.params.loop) {
      render();
      update2();
    }
  });
  on2("destroy", () => {
    destroy();
  });
  on2("enable disable", () => {
    const {
      $el
    } = swiper.pagination;
    if ($el) {
      $el[swiper.enabled ? "removeClass" : "addClass"](swiper.params.pagination.lockClass);
    }
  });
  on2("lock unlock", () => {
    update2();
  });
  on2("click", (_s, e) => {
    const targetEl = e.target;
    const {
      $el
    } = swiper.pagination;
    if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && $el && $el.length > 0 && !$(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
      if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl))
        return;
      const isHidden = $el.hasClass(swiper.params.pagination.hiddenClass);
      if (isHidden === true) {
        emit("paginationShow");
      } else {
        emit("paginationHide");
      }
      $el.toggleClass(swiper.params.pagination.hiddenClass);
    }
  });
  const enable = () => {
    swiper.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
    if (swiper.pagination.$el) {
      swiper.pagination.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
    }
    init2();
    render();
    update2();
  };
  const disable = () => {
    swiper.$el.addClass(swiper.params.pagination.paginationDisabledClass);
    if (swiper.pagination.$el) {
      swiper.pagination.$el.addClass(swiper.params.pagination.paginationDisabledClass);
    }
    destroy();
  };
  Object.assign(swiper.pagination, {
    enable,
    disable,
    render,
    update: update2,
    init: init2,
    destroy
  });
}
function Scrollbar({
  swiper,
  extendParams,
  on: on2,
  emit
}) {
  const document2 = getDocument();
  let isTouched = false;
  let timeout = null;
  let dragTimeout = null;
  let dragStartPos;
  let dragSize;
  let trackSize;
  let divider;
  extendParams({
    scrollbar: {
      el: null,
      dragSize: "auto",
      hide: false,
      draggable: false,
      snapOnRelease: true,
      lockClass: "swiper-scrollbar-lock",
      dragClass: "swiper-scrollbar-drag",
      scrollbarDisabledClass: "swiper-scrollbar-disabled",
      horizontalClass: `swiper-scrollbar-horizontal`,
      verticalClass: `swiper-scrollbar-vertical`
    }
  });
  swiper.scrollbar = {
    el: null,
    dragEl: null,
    $el: null,
    $dragEl: null
  };
  function setTranslate2() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el)
      return;
    const {
      scrollbar,
      rtlTranslate: rtl,
      progress
    } = swiper;
    const {
      $dragEl,
      $el
    } = scrollbar;
    const params = swiper.params.scrollbar;
    let newSize = dragSize;
    let newPos = (trackSize - dragSize) * progress;
    if (rtl) {
      newPos = -newPos;
      if (newPos > 0) {
        newSize = dragSize - newPos;
        newPos = 0;
      } else if (-newPos + dragSize > trackSize) {
        newSize = trackSize + newPos;
      }
    } else if (newPos < 0) {
      newSize = dragSize + newPos;
      newPos = 0;
    } else if (newPos + dragSize > trackSize) {
      newSize = trackSize - newPos;
    }
    if (swiper.isHorizontal()) {
      $dragEl.transform(`translate3d(${newPos}px, 0, 0)`);
      $dragEl[0].style.width = `${newSize}px`;
    } else {
      $dragEl.transform(`translate3d(0px, ${newPos}px, 0)`);
      $dragEl[0].style.height = `${newSize}px`;
    }
    if (params.hide) {
      clearTimeout(timeout);
      $el[0].style.opacity = 1;
      timeout = setTimeout(() => {
        $el[0].style.opacity = 0;
        $el.transition(400);
      }, 1e3);
    }
  }
  function setTransition2(duration) {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el)
      return;
    swiper.scrollbar.$dragEl.transition(duration);
  }
  function updateSize2() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el)
      return;
    const {
      scrollbar
    } = swiper;
    const {
      $dragEl,
      $el
    } = scrollbar;
    $dragEl[0].style.width = "";
    $dragEl[0].style.height = "";
    trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
    divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
    if (swiper.params.scrollbar.dragSize === "auto") {
      dragSize = trackSize * divider;
    } else {
      dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
    }
    if (swiper.isHorizontal()) {
      $dragEl[0].style.width = `${dragSize}px`;
    } else {
      $dragEl[0].style.height = `${dragSize}px`;
    }
    if (divider >= 1) {
      $el[0].style.display = "none";
    } else {
      $el[0].style.display = "";
    }
    if (swiper.params.scrollbar.hide) {
      $el[0].style.opacity = 0;
    }
    if (swiper.params.watchOverflow && swiper.enabled) {
      scrollbar.$el[swiper.isLocked ? "addClass" : "removeClass"](swiper.params.scrollbar.lockClass);
    }
  }
  function getPointerPosition(e) {
    if (swiper.isHorizontal()) {
      return e.type === "touchstart" || e.type === "touchmove" ? e.targetTouches[0].clientX : e.clientX;
    }
    return e.type === "touchstart" || e.type === "touchmove" ? e.targetTouches[0].clientY : e.clientY;
  }
  function setDragPosition(e) {
    const {
      scrollbar,
      rtlTranslate: rtl
    } = swiper;
    const {
      $el
    } = scrollbar;
    let positionRatio;
    positionRatio = (getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? "left" : "top"] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
    positionRatio = Math.max(Math.min(positionRatio, 1), 0);
    if (rtl) {
      positionRatio = 1 - positionRatio;
    }
    const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
    swiper.updateProgress(position);
    swiper.setTranslate(position);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }
  function onDragStart(e) {
    const params = swiper.params.scrollbar;
    const {
      scrollbar,
      $wrapperEl
    } = swiper;
    const {
      $el,
      $dragEl
    } = scrollbar;
    isTouched = true;
    dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? "left" : "top"] : null;
    e.preventDefault();
    e.stopPropagation();
    $wrapperEl.transition(100);
    $dragEl.transition(100);
    setDragPosition(e);
    clearTimeout(dragTimeout);
    $el.transition(0);
    if (params.hide) {
      $el.css("opacity", 1);
    }
    if (swiper.params.cssMode) {
      swiper.$wrapperEl.css("scroll-snap-type", "none");
    }
    emit("scrollbarDragStart", e);
  }
  function onDragMove(e) {
    const {
      scrollbar,
      $wrapperEl
    } = swiper;
    const {
      $el,
      $dragEl
    } = scrollbar;
    if (!isTouched)
      return;
    if (e.preventDefault)
      e.preventDefault();
    else
      e.returnValue = false;
    setDragPosition(e);
    $wrapperEl.transition(0);
    $el.transition(0);
    $dragEl.transition(0);
    emit("scrollbarDragMove", e);
  }
  function onDragEnd(e) {
    const params = swiper.params.scrollbar;
    const {
      scrollbar,
      $wrapperEl
    } = swiper;
    const {
      $el
    } = scrollbar;
    if (!isTouched)
      return;
    isTouched = false;
    if (swiper.params.cssMode) {
      swiper.$wrapperEl.css("scroll-snap-type", "");
      $wrapperEl.transition("");
    }
    if (params.hide) {
      clearTimeout(dragTimeout);
      dragTimeout = nextTick$1(() => {
        $el.css("opacity", 0);
        $el.transition(400);
      }, 1e3);
    }
    emit("scrollbarDragEnd", e);
    if (params.snapOnRelease) {
      swiper.slideToClosest();
    }
  }
  function events2(method) {
    const {
      scrollbar,
      touchEventsTouch,
      touchEventsDesktop,
      params,
      support: support2
    } = swiper;
    const $el = scrollbar.$el;
    if (!$el)
      return;
    const target = $el[0];
    const activeListener = support2.passiveListener && params.passiveListeners ? {
      passive: false,
      capture: false
    } : false;
    const passiveListener = support2.passiveListener && params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    if (!target)
      return;
    const eventMethod = method === "on" ? "addEventListener" : "removeEventListener";
    if (!support2.touch) {
      target[eventMethod](touchEventsDesktop.start, onDragStart, activeListener);
      document2[eventMethod](touchEventsDesktop.move, onDragMove, activeListener);
      document2[eventMethod](touchEventsDesktop.end, onDragEnd, passiveListener);
    } else {
      target[eventMethod](touchEventsTouch.start, onDragStart, activeListener);
      target[eventMethod](touchEventsTouch.move, onDragMove, activeListener);
      target[eventMethod](touchEventsTouch.end, onDragEnd, passiveListener);
    }
  }
  function enableDraggable() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el)
      return;
    events2("on");
  }
  function disableDraggable() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el)
      return;
    events2("off");
  }
  function init2() {
    const {
      scrollbar,
      $el: $swiperEl
    } = swiper;
    swiper.params.scrollbar = createElementIfNotDefined(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
      el: "swiper-scrollbar"
    });
    const params = swiper.params.scrollbar;
    if (!params.el)
      return;
    let $el = $(params.el);
    if (swiper.params.uniqueNavElements && typeof params.el === "string" && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
      $el = $swiperEl.find(params.el);
    }
    $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    let $dragEl = $el.find(`.${swiper.params.scrollbar.dragClass}`);
    if ($dragEl.length === 0) {
      $dragEl = $(`<div class="${swiper.params.scrollbar.dragClass}"></div>`);
      $el.append($dragEl);
    }
    Object.assign(scrollbar, {
      $el,
      el: $el[0],
      $dragEl,
      dragEl: $dragEl[0]
    });
    if (params.draggable) {
      enableDraggable();
    }
    if ($el) {
      $el[swiper.enabled ? "removeClass" : "addClass"](swiper.params.scrollbar.lockClass);
    }
  }
  function destroy() {
    const params = swiper.params.scrollbar;
    const $el = swiper.scrollbar.$el;
    if ($el) {
      $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    }
    disableDraggable();
  }
  on2("init", () => {
    if (swiper.params.scrollbar.enabled === false) {
      disable();
    } else {
      init2();
      updateSize2();
      setTranslate2();
    }
  });
  on2("update resize observerUpdate lock unlock", () => {
    updateSize2();
  });
  on2("setTranslate", () => {
    setTranslate2();
  });
  on2("setTransition", (_s, duration) => {
    setTransition2(duration);
  });
  on2("enable disable", () => {
    const {
      $el
    } = swiper.scrollbar;
    if ($el) {
      $el[swiper.enabled ? "removeClass" : "addClass"](swiper.params.scrollbar.lockClass);
    }
  });
  on2("destroy", () => {
    destroy();
  });
  const enable = () => {
    swiper.$el.removeClass(swiper.params.scrollbar.scrollbarDisabledClass);
    if (swiper.scrollbar.$el) {
      swiper.scrollbar.$el.removeClass(swiper.params.scrollbar.scrollbarDisabledClass);
    }
    init2();
    updateSize2();
    setTranslate2();
  };
  const disable = () => {
    swiper.$el.addClass(swiper.params.scrollbar.scrollbarDisabledClass);
    if (swiper.scrollbar.$el) {
      swiper.scrollbar.$el.addClass(swiper.params.scrollbar.scrollbarDisabledClass);
    }
    destroy();
  };
  Object.assign(swiper.scrollbar, {
    enable,
    disable,
    updateSize: updateSize2,
    setTranslate: setTranslate2,
    init: init2,
    destroy
  });
}
var flushPending = false;
var flushing = false;
var queue = [];
var lastFlushedIndex = -1;
function scheduler(callback) {
  queueJob(callback);
}
function queueJob(job) {
  if (!queue.includes(job))
    queue.push(job);
  queueFlush();
}
function dequeueJob(job) {
  let index2 = queue.indexOf(job);
  if (index2 !== -1 && index2 > lastFlushedIndex)
    queue.splice(index2, 1);
}
function queueFlush() {
  if (!flushing && !flushPending) {
    flushPending = true;
    queueMicrotask(flushJobs);
  }
}
function flushJobs() {
  flushPending = false;
  flushing = true;
  for (let i = 0; i < queue.length; i++) {
    queue[i]();
    lastFlushedIndex = i;
  }
  queue.length = 0;
  lastFlushedIndex = -1;
  flushing = false;
}
var reactive;
var effect;
var release;
var raw;
var shouldSchedule = true;
function disableEffectScheduling(callback) {
  shouldSchedule = false;
  callback();
  shouldSchedule = true;
}
function setReactivityEngine(engine) {
  reactive = engine.reactive;
  release = engine.release;
  effect = (callback) => engine.effect(callback, { scheduler: (task) => {
    if (shouldSchedule) {
      scheduler(task);
    } else {
      task();
    }
  } });
  raw = engine.raw;
}
function overrideEffect(override) {
  effect = override;
}
function elementBoundEffect(el) {
  let cleanup2 = () => {
  };
  let wrappedEffect = (callback) => {
    let effectReference = effect(callback);
    if (!el._x_effects) {
      el._x_effects = /* @__PURE__ */ new Set();
      el._x_runEffects = () => {
        el._x_effects.forEach((i) => i());
      };
    }
    el._x_effects.add(effectReference);
    cleanup2 = () => {
      if (effectReference === void 0)
        return;
      el._x_effects.delete(effectReference);
      release(effectReference);
    };
    return effectReference;
  };
  return [wrappedEffect, () => {
    cleanup2();
  }];
}
function watch(getter, callback) {
  let firstTime = true;
  let oldValue;
  let effectReference = effect(() => {
    let value = getter();
    JSON.stringify(value);
    if (!firstTime) {
      queueMicrotask(() => {
        callback(value, oldValue);
        oldValue = value;
      });
    } else {
      oldValue = value;
    }
    firstTime = false;
  });
  return () => release(effectReference);
}
var onAttributeAddeds = [];
var onElRemoveds = [];
var onElAddeds = [];
function onElAdded(callback) {
  onElAddeds.push(callback);
}
function onElRemoved(el, callback) {
  if (typeof callback === "function") {
    if (!el._x_cleanups)
      el._x_cleanups = [];
    el._x_cleanups.push(callback);
  } else {
    callback = el;
    onElRemoveds.push(callback);
  }
}
function onAttributesAdded(callback) {
  onAttributeAddeds.push(callback);
}
function onAttributeRemoved(el, name, callback) {
  if (!el._x_attributeCleanups)
    el._x_attributeCleanups = {};
  if (!el._x_attributeCleanups[name])
    el._x_attributeCleanups[name] = [];
  el._x_attributeCleanups[name].push(callback);
}
function cleanupAttributes(el, names) {
  if (!el._x_attributeCleanups)
    return;
  Object.entries(el._x_attributeCleanups).forEach(([name, value]) => {
    if (names === void 0 || names.includes(name)) {
      value.forEach((i) => i());
      delete el._x_attributeCleanups[name];
    }
  });
}
function cleanupElement(el) {
  if (el._x_cleanups) {
    while (el._x_cleanups.length)
      el._x_cleanups.pop()();
  }
}
var observer = new MutationObserver(onMutate);
var currentlyObserving = false;
function startObservingMutations() {
  observer.observe(document, { subtree: true, childList: true, attributes: true, attributeOldValue: true });
  currentlyObserving = true;
}
function stopObservingMutations() {
  flushObserver();
  observer.disconnect();
  currentlyObserving = false;
}
var queuedMutations = [];
function flushObserver() {
  let records = observer.takeRecords();
  queuedMutations.push(() => records.length > 0 && onMutate(records));
  let queueLengthWhenTriggered = queuedMutations.length;
  queueMicrotask(() => {
    if (queuedMutations.length === queueLengthWhenTriggered) {
      while (queuedMutations.length > 0)
        queuedMutations.shift()();
    }
  });
}
function mutateDom(callback) {
  if (!currentlyObserving)
    return callback();
  stopObservingMutations();
  let result = callback();
  startObservingMutations();
  return result;
}
var isCollecting = false;
var deferredMutations = [];
function deferMutations() {
  isCollecting = true;
}
function flushAndStopDeferringMutations() {
  isCollecting = false;
  onMutate(deferredMutations);
  deferredMutations = [];
}
function onMutate(mutations) {
  if (isCollecting) {
    deferredMutations = deferredMutations.concat(mutations);
    return;
  }
  let addedNodes = /* @__PURE__ */ new Set();
  let removedNodes = /* @__PURE__ */ new Set();
  let addedAttributes = /* @__PURE__ */ new Map();
  let removedAttributes = /* @__PURE__ */ new Map();
  for (let i = 0; i < mutations.length; i++) {
    if (mutations[i].target._x_ignoreMutationObserver)
      continue;
    if (mutations[i].type === "childList") {
      mutations[i].addedNodes.forEach((node) => node.nodeType === 1 && addedNodes.add(node));
      mutations[i].removedNodes.forEach((node) => node.nodeType === 1 && removedNodes.add(node));
    }
    if (mutations[i].type === "attributes") {
      let el = mutations[i].target;
      let name = mutations[i].attributeName;
      let oldValue = mutations[i].oldValue;
      let add2 = () => {
        if (!addedAttributes.has(el))
          addedAttributes.set(el, []);
        addedAttributes.get(el).push({ name, value: el.getAttribute(name) });
      };
      let remove2 = () => {
        if (!removedAttributes.has(el))
          removedAttributes.set(el, []);
        removedAttributes.get(el).push(name);
      };
      if (el.hasAttribute(name) && oldValue === null) {
        add2();
      } else if (el.hasAttribute(name)) {
        remove2();
        add2();
      } else {
        remove2();
      }
    }
  }
  removedAttributes.forEach((attrs, el) => {
    cleanupAttributes(el, attrs);
  });
  addedAttributes.forEach((attrs, el) => {
    onAttributeAddeds.forEach((i) => i(el, attrs));
  });
  for (let node of removedNodes) {
    if (addedNodes.has(node))
      continue;
    onElRemoveds.forEach((i) => i(node));
  }
  addedNodes.forEach((node) => {
    node._x_ignoreSelf = true;
    node._x_ignore = true;
  });
  for (let node of addedNodes) {
    if (removedNodes.has(node))
      continue;
    if (!node.isConnected)
      continue;
    delete node._x_ignoreSelf;
    delete node._x_ignore;
    onElAddeds.forEach((i) => i(node));
    node._x_ignore = true;
    node._x_ignoreSelf = true;
  }
  addedNodes.forEach((node) => {
    delete node._x_ignoreSelf;
    delete node._x_ignore;
  });
  addedNodes = null;
  removedNodes = null;
  addedAttributes = null;
  removedAttributes = null;
}
function scope(node) {
  return mergeProxies(closestDataStack(node));
}
function addScopeToNode(node, data2, referenceNode) {
  node._x_dataStack = [data2, ...closestDataStack(referenceNode || node)];
  return () => {
    node._x_dataStack = node._x_dataStack.filter((i) => i !== data2);
  };
}
function closestDataStack(node) {
  if (node._x_dataStack)
    return node._x_dataStack;
  if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) {
    return closestDataStack(node.host);
  }
  if (!node.parentNode) {
    return [];
  }
  return closestDataStack(node.parentNode);
}
function mergeProxies(objects) {
  return new Proxy({ objects }, mergeProxyTrap);
}
var mergeProxyTrap = {
  ownKeys({ objects }) {
    return Array.from(
      new Set(objects.flatMap((i) => Object.keys(i)))
    );
  },
  has({ objects }, name) {
    if (name == Symbol.unscopables)
      return false;
    return objects.some(
      (obj) => Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name)
    );
  },
  get({ objects }, name, thisProxy) {
    if (name == "toJSON")
      return collapseProxies;
    return Reflect.get(
      objects.find(
        (obj) => Reflect.has(obj, name)
      ) || {},
      name,
      thisProxy
    );
  },
  set({ objects }, name, value, thisProxy) {
    const target = objects.find(
      (obj) => Object.prototype.hasOwnProperty.call(obj, name)
    ) || objects[objects.length - 1];
    const descriptor = Object.getOwnPropertyDescriptor(target, name);
    if ((descriptor == null ? void 0 : descriptor.set) && (descriptor == null ? void 0 : descriptor.get))
      return Reflect.set(target, name, value, thisProxy);
    return Reflect.set(target, name, value);
  }
};
function collapseProxies() {
  let keys = Reflect.ownKeys(this);
  return keys.reduce((acc, key) => {
    acc[key] = Reflect.get(this, key);
    return acc;
  }, {});
}
function initInterceptors(data2) {
  let isObject2 = (val) => typeof val === "object" && !Array.isArray(val) && val !== null;
  let recurse = (obj, basePath = "") => {
    Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value, enumerable }]) => {
      if (enumerable === false || value === void 0)
        return;
      if (typeof value === "object" && value !== null && value.__v_skip)
        return;
      let path = basePath === "" ? key : `${basePath}.${key}`;
      if (typeof value === "object" && value !== null && value._x_interceptor) {
        obj[key] = value.initialize(data2, path, key);
      } else {
        if (isObject2(value) && value !== obj && !(value instanceof Element)) {
          recurse(value, path);
        }
      }
    });
  };
  return recurse(data2);
}
function interceptor(callback, mutateObj = () => {
}) {
  let obj = {
    initialValue: void 0,
    _x_interceptor: true,
    initialize(data2, path, key) {
      return callback(this.initialValue, () => get(data2, path), (value) => set(data2, path, value), path, key);
    }
  };
  mutateObj(obj);
  return (initialValue) => {
    if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
      let initialize = obj.initialize.bind(obj);
      obj.initialize = (data2, path, key) => {
        let innerValue = initialValue.initialize(data2, path, key);
        obj.initialValue = innerValue;
        return initialize(data2, path, key);
      };
    } else {
      obj.initialValue = initialValue;
    }
    return obj;
  };
}
function get(obj, path) {
  return path.split(".").reduce((carry, segment) => carry[segment], obj);
}
function set(obj, path, value) {
  if (typeof path === "string")
    path = path.split(".");
  if (path.length === 1)
    obj[path[0]] = value;
  else if (path.length === 0)
    throw error;
  else {
    if (obj[path[0]])
      return set(obj[path[0]], path.slice(1), value);
    else {
      obj[path[0]] = {};
      return set(obj[path[0]], path.slice(1), value);
    }
  }
}
var magics = {};
function magic(name, callback) {
  magics[name] = callback;
}
function injectMagics(obj, el) {
  Object.entries(magics).forEach(([name, callback]) => {
    let memoizedUtilities = null;
    function getUtilities() {
      if (memoizedUtilities) {
        return memoizedUtilities;
      } else {
        let [utilities, cleanup2] = getElementBoundUtilities(el);
        memoizedUtilities = { interceptor, ...utilities };
        onElRemoved(el, cleanup2);
        return memoizedUtilities;
      }
    }
    Object.defineProperty(obj, `$${name}`, {
      get() {
        return callback(el, getUtilities());
      },
      enumerable: false
    });
  });
  return obj;
}
function tryCatch(el, expression, callback, ...args) {
  try {
    return callback(...args);
  } catch (e) {
    handleError(e, el, expression);
  }
}
function handleError(error2, el, expression = void 0) {
  error2 = Object.assign(
    error2 ?? { message: "No error message given." },
    { el, expression }
  );
  console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
  setTimeout(() => {
    throw error2;
  }, 0);
}
var shouldAutoEvaluateFunctions = true;
function dontAutoEvaluateFunctions(callback) {
  let cache = shouldAutoEvaluateFunctions;
  shouldAutoEvaluateFunctions = false;
  let result = callback();
  shouldAutoEvaluateFunctions = cache;
  return result;
}
function evaluate(el, expression, extras = {}) {
  let result;
  evaluateLater(el, expression)((value) => result = value, extras);
  return result;
}
function evaluateLater(...args) {
  return theEvaluatorFunction(...args);
}
var theEvaluatorFunction = normalEvaluator;
function setEvaluator(newEvaluator) {
  theEvaluatorFunction = newEvaluator;
}
function normalEvaluator(el, expression) {
  let overriddenMagics = {};
  injectMagics(overriddenMagics, el);
  let dataStack = [overriddenMagics, ...closestDataStack(el)];
  let evaluator = typeof expression === "function" ? generateEvaluatorFromFunction(dataStack, expression) : generateEvaluatorFromString(dataStack, expression, el);
  return tryCatch.bind(null, el, expression, evaluator);
}
function generateEvaluatorFromFunction(dataStack, func) {
  return (receiver = () => {
  }, { scope: scope2 = {}, params = [] } = {}) => {
    let result = func.apply(mergeProxies([scope2, ...dataStack]), params);
    runIfTypeOfFunction(receiver, result);
  };
}
var evaluatorMemo = {};
function generateFunctionFromString(expression, el) {
  if (evaluatorMemo[expression]) {
    return evaluatorMemo[expression];
  }
  let AsyncFunction = Object.getPrototypeOf(async function() {
  }).constructor;
  let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
  const safeAsyncFunction = () => {
    try {
      let func2 = new AsyncFunction(
        ["__self", "scope"],
        `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`
      );
      Object.defineProperty(func2, "name", {
        value: `[Alpine] ${expression}`
      });
      return func2;
    } catch (error2) {
      handleError(error2, el, expression);
      return Promise.resolve();
    }
  };
  let func = safeAsyncFunction();
  evaluatorMemo[expression] = func;
  return func;
}
function generateEvaluatorFromString(dataStack, expression, el) {
  let func = generateFunctionFromString(expression, el);
  return (receiver = () => {
  }, { scope: scope2 = {}, params = [] } = {}) => {
    func.result = void 0;
    func.finished = false;
    let completeScope = mergeProxies([scope2, ...dataStack]);
    if (typeof func === "function") {
      let promise = func(func, completeScope).catch((error2) => handleError(error2, el, expression));
      if (func.finished) {
        runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
        func.result = void 0;
      } else {
        promise.then((result) => {
          runIfTypeOfFunction(receiver, result, completeScope, params, el);
        }).catch((error2) => handleError(error2, el, expression)).finally(() => func.result = void 0);
      }
    }
  };
}
function runIfTypeOfFunction(receiver, value, scope2, params, el) {
  if (shouldAutoEvaluateFunctions && typeof value === "function") {
    let result = value.apply(scope2, params);
    if (result instanceof Promise) {
      result.then((i) => runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2) => handleError(error2, el, value));
    } else {
      receiver(result);
    }
  } else if (typeof value === "object" && value instanceof Promise) {
    value.then((i) => receiver(i));
  } else {
    receiver(value);
  }
}
var prefixAsString = "x-";
function prefix(subject = "") {
  return prefixAsString + subject;
}
function setPrefix(newPrefix) {
  prefixAsString = newPrefix;
}
var directiveHandlers = {};
function directive(name, callback) {
  directiveHandlers[name] = callback;
  return {
    before(directive2) {
      if (!directiveHandlers[directive2]) {
        console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
        return;
      }
      const pos = directiveOrder.indexOf(directive2);
      directiveOrder.splice(pos >= 0 ? pos : directiveOrder.indexOf("DEFAULT"), 0, name);
    }
  };
}
function directiveExists(name) {
  return Object.keys(directiveHandlers).includes(name);
}
function directives(el, attributes, originalAttributeOverride) {
  attributes = Array.from(attributes);
  if (el._x_virtualDirectives) {
    let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value]) => ({ name, value }));
    let staticAttributes = attributesOnly(vAttributes);
    vAttributes = vAttributes.map((attribute) => {
      if (staticAttributes.find((attr2) => attr2.name === attribute.name)) {
        return {
          name: `x-bind:${attribute.name}`,
          value: `"${attribute.value}"`
        };
      }
      return attribute;
    });
    attributes = attributes.concat(vAttributes);
  }
  let transformedAttributeMap = {};
  let directives2 = attributes.map(toTransformedAttributes((newName, oldName) => transformedAttributeMap[newName] = oldName)).filter(outNonAlpineAttributes).map(toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort(byPriority);
  return directives2.map((directive2) => {
    return getDirectiveHandler(el, directive2);
  });
}
function attributesOnly(attributes) {
  return Array.from(attributes).map(toTransformedAttributes()).filter((attr2) => !outNonAlpineAttributes(attr2));
}
var isDeferringHandlers = false;
var directiveHandlerStacks = /* @__PURE__ */ new Map();
var currentHandlerStackKey = Symbol();
function deferHandlingDirectives(callback) {
  isDeferringHandlers = true;
  let key = Symbol();
  currentHandlerStackKey = key;
  directiveHandlerStacks.set(key, []);
  let flushHandlers = () => {
    while (directiveHandlerStacks.get(key).length)
      directiveHandlerStacks.get(key).shift()();
    directiveHandlerStacks.delete(key);
  };
  let stopDeferring = () => {
    isDeferringHandlers = false;
    flushHandlers();
  };
  callback(flushHandlers);
  stopDeferring();
}
function getElementBoundUtilities(el) {
  let cleanups = [];
  let cleanup2 = (callback) => cleanups.push(callback);
  let [effect3, cleanupEffect] = elementBoundEffect(el);
  cleanups.push(cleanupEffect);
  let utilities = {
    Alpine: alpine_default,
    effect: effect3,
    cleanup: cleanup2,
    evaluateLater: evaluateLater.bind(evaluateLater, el),
    evaluate: evaluate.bind(evaluate, el)
  };
  let doCleanup = () => cleanups.forEach((i) => i());
  return [utilities, doCleanup];
}
function getDirectiveHandler(el, directive2) {
  let noop = () => {
  };
  let handler4 = directiveHandlers[directive2.type] || noop;
  let [utilities, cleanup2] = getElementBoundUtilities(el);
  onAttributeRemoved(el, directive2.original, cleanup2);
  let fullHandler = () => {
    if (el._x_ignore || el._x_ignoreSelf)
      return;
    handler4.inline && handler4.inline(el, directive2, utilities);
    handler4 = handler4.bind(handler4, el, directive2, utilities);
    isDeferringHandlers ? directiveHandlerStacks.get(currentHandlerStackKey).push(handler4) : handler4();
  };
  fullHandler.runCleanups = cleanup2;
  return fullHandler;
}
var startingWith = (subject, replacement) => ({ name, value }) => {
  if (name.startsWith(subject))
    name = name.replace(subject, replacement);
  return { name, value };
};
var into = (i) => i;
function toTransformedAttributes(callback = () => {
}) {
  return ({ name, value }) => {
    let { name: newName, value: newValue } = attributeTransformers.reduce((carry, transform2) => {
      return transform2(carry);
    }, { name, value });
    if (newName !== name)
      callback(newName, name);
    return { name: newName, value: newValue };
  };
}
var attributeTransformers = [];
function mapAttributes(callback) {
  attributeTransformers.push(callback);
}
function outNonAlpineAttributes({ name }) {
  return alpineAttributeRegex().test(name);
}
var alpineAttributeRegex = () => new RegExp(`^${prefixAsString}([^:^.]+)\\b`);
function toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
  return ({ name, value }) => {
    let typeMatch = name.match(alpineAttributeRegex());
    let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
    let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
    let original = originalAttributeOverride || transformedAttributeMap[name] || name;
    return {
      type: typeMatch ? typeMatch[1] : null,
      value: valueMatch ? valueMatch[1] : null,
      modifiers: modifiers.map((i) => i.replace(".", "")),
      expression: value,
      original
    };
  };
}
var DEFAULT = "DEFAULT";
var directiveOrder = [
  "ignore",
  "ref",
  "data",
  "id",
  "anchor",
  "bind",
  "init",
  "for",
  "model",
  "modelable",
  "transition",
  "show",
  "if",
  DEFAULT,
  "teleport"
];
function byPriority(a, b) {
  let typeA = directiveOrder.indexOf(a.type) === -1 ? DEFAULT : a.type;
  let typeB = directiveOrder.indexOf(b.type) === -1 ? DEFAULT : b.type;
  return directiveOrder.indexOf(typeA) - directiveOrder.indexOf(typeB);
}
function dispatch(el, name, detail = {}) {
  el.dispatchEvent(
    new CustomEvent(name, {
      detail,
      bubbles: true,
      // Allows events to pass the shadow DOM barrier.
      composed: true,
      cancelable: true
    })
  );
}
function walk(el, callback) {
  if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
    Array.from(el.children).forEach((el2) => walk(el2, callback));
    return;
  }
  let skip = false;
  callback(el, () => skip = true);
  if (skip)
    return;
  let node = el.firstElementChild;
  while (node) {
    walk(node, callback);
    node = node.nextElementSibling;
  }
}
function warn(message, ...args) {
  console.warn(`Alpine Warning: ${message}`, ...args);
}
var started = false;
function start() {
  if (started)
    warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
  started = true;
  if (!document.body)
    warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
  dispatch(document, "alpine:init");
  dispatch(document, "alpine:initializing");
  startObservingMutations();
  onElAdded((el) => initTree(el, walk));
  onElRemoved((el) => destroyTree(el));
  onAttributesAdded((el, attrs) => {
    directives(el, attrs).forEach((handle) => handle());
  });
  let outNestedComponents = (el) => !closestRoot(el.parentElement, true);
  Array.from(document.querySelectorAll(allSelectors().join(","))).filter(outNestedComponents).forEach((el) => {
    initTree(el);
  });
  dispatch(document, "alpine:initialized");
  setTimeout(() => {
    warnAboutMissingPlugins();
  });
}
var rootSelectorCallbacks = [];
var initSelectorCallbacks = [];
function rootSelectors() {
  return rootSelectorCallbacks.map((fn) => fn());
}
function allSelectors() {
  return rootSelectorCallbacks.concat(initSelectorCallbacks).map((fn) => fn());
}
function addRootSelector(selectorCallback) {
  rootSelectorCallbacks.push(selectorCallback);
}
function addInitSelector(selectorCallback) {
  initSelectorCallbacks.push(selectorCallback);
}
function closestRoot(el, includeInitSelectors = false) {
  return findClosest(el, (element) => {
    const selectors = includeInitSelectors ? allSelectors() : rootSelectors();
    if (selectors.some((selector) => element.matches(selector)))
      return true;
  });
}
function findClosest(el, callback) {
  if (!el)
    return;
  if (callback(el))
    return el;
  if (el._x_teleportBack)
    el = el._x_teleportBack;
  if (!el.parentElement)
    return;
  return findClosest(el.parentElement, callback);
}
function isRoot(el) {
  return rootSelectors().some((selector) => el.matches(selector));
}
var initInterceptors2 = [];
function interceptInit(callback) {
  initInterceptors2.push(callback);
}
function initTree(el, walker = walk, intercept = () => {
}) {
  deferHandlingDirectives(() => {
    walker(el, (el2, skip) => {
      intercept(el2, skip);
      initInterceptors2.forEach((i) => i(el2, skip));
      directives(el2, el2.attributes).forEach((handle) => handle());
      el2._x_ignore && skip();
    });
  });
}
function destroyTree(root, walker = walk) {
  walker(root, (el) => {
    cleanupAttributes(el);
    cleanupElement(el);
  });
}
function warnAboutMissingPlugins() {
  let pluginDirectives = [
    ["ui", "dialog", ["[x-dialog], [x-popover]"]],
    ["anchor", "anchor", ["[x-anchor]"]],
    ["sort", "sort", ["[x-sort]"]]
  ];
  pluginDirectives.forEach(([plugin2, directive2, selectors]) => {
    if (directiveExists(directive2))
      return;
    selectors.some((selector) => {
      if (document.querySelector(selector)) {
        warn(`found "${selector}", but missing ${plugin2} plugin`);
        return true;
      }
    });
  });
}
var tickStack = [];
var isHolding = false;
function nextTick(callback = () => {
}) {
  queueMicrotask(() => {
    isHolding || setTimeout(() => {
      releaseNextTicks();
    });
  });
  return new Promise((res) => {
    tickStack.push(() => {
      callback();
      res();
    });
  });
}
function releaseNextTicks() {
  isHolding = false;
  while (tickStack.length)
    tickStack.shift()();
}
function holdNextTicks() {
  isHolding = true;
}
function setClasses(el, value) {
  if (Array.isArray(value)) {
    return setClassesFromString(el, value.join(" "));
  } else if (typeof value === "object" && value !== null) {
    return setClassesFromObject(el, value);
  } else if (typeof value === "function") {
    return setClasses(el, value());
  }
  return setClassesFromString(el, value);
}
function setClassesFromString(el, classString) {
  let missingClasses = (classString2) => classString2.split(" ").filter((i) => !el.classList.contains(i)).filter(Boolean);
  let addClassesAndReturnUndo = (classes2) => {
    el.classList.add(...classes2);
    return () => {
      el.classList.remove(...classes2);
    };
  };
  classString = classString === true ? classString = "" : classString || "";
  return addClassesAndReturnUndo(missingClasses(classString));
}
function setClassesFromObject(el, classObject) {
  let split = (classString) => classString.split(" ").filter(Boolean);
  let forAdd = Object.entries(classObject).flatMap(([classString, bool]) => bool ? split(classString) : false).filter(Boolean);
  let forRemove = Object.entries(classObject).flatMap(([classString, bool]) => !bool ? split(classString) : false).filter(Boolean);
  let added = [];
  let removed = [];
  forRemove.forEach((i) => {
    if (el.classList.contains(i)) {
      el.classList.remove(i);
      removed.push(i);
    }
  });
  forAdd.forEach((i) => {
    if (!el.classList.contains(i)) {
      el.classList.add(i);
      added.push(i);
    }
  });
  return () => {
    removed.forEach((i) => el.classList.add(i));
    added.forEach((i) => el.classList.remove(i));
  };
}
function setStyles(el, value) {
  if (typeof value === "object" && value !== null) {
    return setStylesFromObject(el, value);
  }
  return setStylesFromString(el, value);
}
function setStylesFromObject(el, value) {
  let previousStyles = {};
  Object.entries(value).forEach(([key, value2]) => {
    previousStyles[key] = el.style[key];
    if (!key.startsWith("--")) {
      key = kebabCase(key);
    }
    el.style.setProperty(key, value2);
  });
  setTimeout(() => {
    if (el.style.length === 0) {
      el.removeAttribute("style");
    }
  });
  return () => {
    setStyles(el, previousStyles);
  };
}
function setStylesFromString(el, value) {
  let cache = el.getAttribute("style", value);
  el.setAttribute("style", value);
  return () => {
    el.setAttribute("style", cache || "");
  };
}
function kebabCase(subject) {
  return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function once(callback, fallback = () => {
}) {
  let called = false;
  return function() {
    if (!called) {
      called = true;
      callback.apply(this, arguments);
    } else {
      fallback.apply(this, arguments);
    }
  };
}
directive("transition", (el, { value, modifiers, expression }, { evaluate: evaluate2 }) => {
  if (typeof expression === "function")
    expression = evaluate2(expression);
  if (expression === false)
    return;
  if (!expression || typeof expression === "boolean") {
    registerTransitionsFromHelper(el, modifiers, value);
  } else {
    registerTransitionsFromClassString(el, expression, value);
  }
});
function registerTransitionsFromClassString(el, classString, stage) {
  registerTransitionObject(el, setClasses, "");
  let directiveStorageMap = {
    "enter": (classes2) => {
      el._x_transition.enter.during = classes2;
    },
    "enter-start": (classes2) => {
      el._x_transition.enter.start = classes2;
    },
    "enter-end": (classes2) => {
      el._x_transition.enter.end = classes2;
    },
    "leave": (classes2) => {
      el._x_transition.leave.during = classes2;
    },
    "leave-start": (classes2) => {
      el._x_transition.leave.start = classes2;
    },
    "leave-end": (classes2) => {
      el._x_transition.leave.end = classes2;
    }
  };
  directiveStorageMap[stage](classString);
}
function registerTransitionsFromHelper(el, modifiers, stage) {
  registerTransitionObject(el, setStyles);
  let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
  let transitioningIn = doesntSpecify || modifiers.includes("in") || ["enter"].includes(stage);
  let transitioningOut = doesntSpecify || modifiers.includes("out") || ["leave"].includes(stage);
  if (modifiers.includes("in") && !doesntSpecify) {
    modifiers = modifiers.filter((i, index2) => index2 < modifiers.indexOf("out"));
  }
  if (modifiers.includes("out") && !doesntSpecify) {
    modifiers = modifiers.filter((i, index2) => index2 > modifiers.indexOf("out"));
  }
  let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
  let wantsOpacity = wantsAll || modifiers.includes("opacity");
  let wantsScale = wantsAll || modifiers.includes("scale");
  let opacityValue = wantsOpacity ? 0 : 1;
  let scaleValue = wantsScale ? modifierValue(modifiers, "scale", 95) / 100 : 1;
  let delay = modifierValue(modifiers, "delay", 0) / 1e3;
  let origin = modifierValue(modifiers, "origin", "center");
  let property = "opacity, transform";
  let durationIn = modifierValue(modifiers, "duration", 150) / 1e3;
  let durationOut = modifierValue(modifiers, "duration", 75) / 1e3;
  let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
  if (transitioningIn) {
    el._x_transition.enter.during = {
      transformOrigin: origin,
      transitionDelay: `${delay}s`,
      transitionProperty: property,
      transitionDuration: `${durationIn}s`,
      transitionTimingFunction: easing
    };
    el._x_transition.enter.start = {
      opacity: opacityValue,
      transform: `scale(${scaleValue})`
    };
    el._x_transition.enter.end = {
      opacity: 1,
      transform: `scale(1)`
    };
  }
  if (transitioningOut) {
    el._x_transition.leave.during = {
      transformOrigin: origin,
      transitionDelay: `${delay}s`,
      transitionProperty: property,
      transitionDuration: `${durationOut}s`,
      transitionTimingFunction: easing
    };
    el._x_transition.leave.start = {
      opacity: 1,
      transform: `scale(1)`
    };
    el._x_transition.leave.end = {
      opacity: opacityValue,
      transform: `scale(${scaleValue})`
    };
  }
}
function registerTransitionObject(el, setFunction, defaultValue = {}) {
  if (!el._x_transition)
    el._x_transition = {
      enter: { during: defaultValue, start: defaultValue, end: defaultValue },
      leave: { during: defaultValue, start: defaultValue, end: defaultValue },
      in(before = () => {
      }, after = () => {
      }) {
        transition(el, setFunction, {
          during: this.enter.during,
          start: this.enter.start,
          end: this.enter.end
        }, before, after);
      },
      out(before = () => {
      }, after = () => {
      }) {
        transition(el, setFunction, {
          during: this.leave.during,
          start: this.leave.start,
          end: this.leave.end
        }, before, after);
      }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
  const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
  let clickAwayCompatibleShow = () => nextTick2(show);
  if (value) {
    if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) {
      el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
    } else {
      el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
    }
    return;
  }
  el._x_hidePromise = el._x_transition ? new Promise((resolve, reject) => {
    el._x_transition.out(() => {
    }, () => resolve(hide));
    el._x_transitioning && el._x_transitioning.beforeCancel(() => reject({ isFromCancelledTransition: true }));
  }) : Promise.resolve(hide);
  queueMicrotask(() => {
    let closest2 = closestHide(el);
    if (closest2) {
      if (!closest2._x_hideChildren)
        closest2._x_hideChildren = [];
      closest2._x_hideChildren.push(el);
    } else {
      nextTick2(() => {
        let hideAfterChildren = (el2) => {
          let carry = Promise.all([
            el2._x_hidePromise,
            ...(el2._x_hideChildren || []).map(hideAfterChildren)
          ]).then(([i]) => i());
          delete el2._x_hidePromise;
          delete el2._x_hideChildren;
          return carry;
        };
        hideAfterChildren(el).catch((e) => {
          if (!e.isFromCancelledTransition)
            throw e;
        });
      });
    }
  });
};
function closestHide(el) {
  let parent2 = el.parentNode;
  if (!parent2)
    return;
  return parent2._x_hidePromise ? parent2 : closestHide(parent2);
}
function transition(el, setFunction, { during, start: start2, end } = {}, before = () => {
}, after = () => {
}) {
  if (el._x_transitioning)
    el._x_transitioning.cancel();
  if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
    before();
    after();
    return;
  }
  let undoStart, undoDuring, undoEnd;
  performTransition(el, {
    start() {
      undoStart = setFunction(el, start2);
    },
    during() {
      undoDuring = setFunction(el, during);
    },
    before,
    end() {
      undoStart();
      undoEnd = setFunction(el, end);
    },
    after,
    cleanup() {
      undoDuring();
      undoEnd();
    }
  });
}
function performTransition(el, stages) {
  let interrupted, reachedBefore, reachedEnd;
  let finish = once(() => {
    mutateDom(() => {
      interrupted = true;
      if (!reachedBefore)
        stages.before();
      if (!reachedEnd) {
        stages.end();
        releaseNextTicks();
      }
      stages.after();
      if (el.isConnected)
        stages.cleanup();
      delete el._x_transitioning;
    });
  });
  el._x_transitioning = {
    beforeCancels: [],
    beforeCancel(callback) {
      this.beforeCancels.push(callback);
    },
    cancel: once(function() {
      while (this.beforeCancels.length) {
        this.beforeCancels.shift()();
      }
      finish();
    }),
    finish
  };
  mutateDom(() => {
    stages.start();
    stages.during();
  });
  holdNextTicks();
  requestAnimationFrame(() => {
    if (interrupted)
      return;
    let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
    let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
    if (duration === 0)
      duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
    mutateDom(() => {
      stages.before();
    });
    reachedBefore = true;
    requestAnimationFrame(() => {
      if (interrupted)
        return;
      mutateDom(() => {
        stages.end();
      });
      releaseNextTicks();
      setTimeout(el._x_transitioning.finish, duration + delay);
      reachedEnd = true;
    });
  });
}
function modifierValue(modifiers, key, fallback) {
  if (modifiers.indexOf(key) === -1)
    return fallback;
  const rawValue = modifiers[modifiers.indexOf(key) + 1];
  if (!rawValue)
    return fallback;
  if (key === "scale") {
    if (isNaN(rawValue))
      return fallback;
  }
  if (key === "duration" || key === "delay") {
    let match = rawValue.match(/([0-9]+)ms/);
    if (match)
      return match[1];
  }
  if (key === "origin") {
    if (["top", "right", "left", "center", "bottom"].includes(modifiers[modifiers.indexOf(key) + 2])) {
      return [rawValue, modifiers[modifiers.indexOf(key) + 2]].join(" ");
    }
  }
  return rawValue;
}
var isCloning = false;
function skipDuringClone(callback, fallback = () => {
}) {
  return (...args) => isCloning ? fallback(...args) : callback(...args);
}
function onlyDuringClone(callback) {
  return (...args) => isCloning && callback(...args);
}
var interceptors = [];
function interceptClone(callback) {
  interceptors.push(callback);
}
function cloneNode(from, to) {
  interceptors.forEach((i) => i(from, to));
  isCloning = true;
  dontRegisterReactiveSideEffects(() => {
    initTree(to, (el, callback) => {
      callback(el, () => {
      });
    });
  });
  isCloning = false;
}
var isCloningLegacy = false;
function clone(oldEl, newEl) {
  if (!newEl._x_dataStack)
    newEl._x_dataStack = oldEl._x_dataStack;
  isCloning = true;
  isCloningLegacy = true;
  dontRegisterReactiveSideEffects(() => {
    cloneTree(newEl);
  });
  isCloning = false;
  isCloningLegacy = false;
}
function cloneTree(el) {
  let hasRunThroughFirstEl = false;
  let shallowWalker = (el2, callback) => {
    walk(el2, (el3, skip) => {
      if (hasRunThroughFirstEl && isRoot(el3))
        return skip();
      hasRunThroughFirstEl = true;
      callback(el3, skip);
    });
  };
  initTree(el, shallowWalker);
}
function dontRegisterReactiveSideEffects(callback) {
  let cache = effect;
  overrideEffect((callback2, el) => {
    let storedEffect = cache(callback2);
    release(storedEffect);
    return () => {
    };
  });
  callback();
  overrideEffect(cache);
}
function bind(el, name, value, modifiers = []) {
  if (!el._x_bindings)
    el._x_bindings = reactive({});
  el._x_bindings[name] = value;
  name = modifiers.includes("camel") ? camelCase(name) : name;
  switch (name) {
    case "value":
      bindInputValue(el, value);
      break;
    case "style":
      bindStyles(el, value);
      break;
    case "class":
      bindClasses(el, value);
      break;
    case "selected":
    case "checked":
      bindAttributeAndProperty(el, name, value);
      break;
    default:
      bindAttribute(el, name, value);
      break;
  }
}
function bindInputValue(el, value) {
  if (el.type === "radio") {
    if (el.attributes.value === void 0) {
      el.value = value;
    }
    if (window.fromModel) {
      if (typeof value === "boolean") {
        el.checked = safeParseBoolean(el.value) === value;
      } else {
        el.checked = checkedAttrLooseCompare(el.value, value);
      }
    }
  } else if (el.type === "checkbox") {
    if (Number.isInteger(value)) {
      el.value = value;
    } else if (!Array.isArray(value) && typeof value !== "boolean" && ![null, void 0].includes(value)) {
      el.value = String(value);
    } else {
      if (Array.isArray(value)) {
        el.checked = value.some((val) => checkedAttrLooseCompare(val, el.value));
      } else {
        el.checked = !!value;
      }
    }
  } else if (el.tagName === "SELECT") {
    updateSelect(el, value);
  } else {
    if (el.value === value)
      return;
    el.value = value === void 0 ? "" : value;
  }
}
function bindClasses(el, value) {
  if (el._x_undoAddedClasses)
    el._x_undoAddedClasses();
  el._x_undoAddedClasses = setClasses(el, value);
}
function bindStyles(el, value) {
  if (el._x_undoAddedStyles)
    el._x_undoAddedStyles();
  el._x_undoAddedStyles = setStyles(el, value);
}
function bindAttributeAndProperty(el, name, value) {
  bindAttribute(el, name, value);
  setPropertyIfChanged(el, name, value);
}
function bindAttribute(el, name, value) {
  if ([null, void 0, false].includes(value) && attributeShouldntBePreservedIfFalsy(name)) {
    el.removeAttribute(name);
  } else {
    if (isBooleanAttr(name))
      value = name;
    setIfChanged(el, name, value);
  }
}
function setIfChanged(el, attrName, value) {
  if (el.getAttribute(attrName) != value) {
    el.setAttribute(attrName, value);
  }
}
function setPropertyIfChanged(el, propName, value) {
  if (el[propName] !== value) {
    el[propName] = value;
  }
}
function updateSelect(el, value) {
  const arrayWrappedValue = [].concat(value).map((value2) => {
    return value2 + "";
  });
  Array.from(el.options).forEach((option) => {
    option.selected = arrayWrappedValue.includes(option.value);
  });
}
function camelCase(subject) {
  return subject.toLowerCase().replace(/-(\w)/g, (match, char) => char.toUpperCase());
}
function checkedAttrLooseCompare(valueA, valueB) {
  return valueA == valueB;
}
function safeParseBoolean(rawValue) {
  if ([1, "1", "true", "on", "yes", true].includes(rawValue)) {
    return true;
  }
  if ([0, "0", "false", "off", "no", false].includes(rawValue)) {
    return false;
  }
  return rawValue ? Boolean(rawValue) : null;
}
function isBooleanAttr(attrName) {
  const booleanAttributes = [
    "disabled",
    "checked",
    "required",
    "readonly",
    "open",
    "selected",
    "autofocus",
    "itemscope",
    "multiple",
    "novalidate",
    "allowfullscreen",
    "allowpaymentrequest",
    "formnovalidate",
    "autoplay",
    "controls",
    "loop",
    "muted",
    "playsinline",
    "default",
    "ismap",
    "reversed",
    "async",
    "defer",
    "nomodule"
  ];
  return booleanAttributes.includes(attrName);
}
function attributeShouldntBePreservedIfFalsy(name) {
  return !["aria-pressed", "aria-checked", "aria-expanded", "aria-selected"].includes(name);
}
function getBinding(el, name, fallback) {
  if (el._x_bindings && el._x_bindings[name] !== void 0)
    return el._x_bindings[name];
  return getAttributeBinding(el, name, fallback);
}
function extractProp(el, name, fallback, extract = true) {
  if (el._x_bindings && el._x_bindings[name] !== void 0)
    return el._x_bindings[name];
  if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
    let binding = el._x_inlineBindings[name];
    binding.extract = extract;
    return dontAutoEvaluateFunctions(() => {
      return evaluate(el, binding.expression);
    });
  }
  return getAttributeBinding(el, name, fallback);
}
function getAttributeBinding(el, name, fallback) {
  let attr2 = el.getAttribute(name);
  if (attr2 === null)
    return typeof fallback === "function" ? fallback() : fallback;
  if (attr2 === "")
    return true;
  if (isBooleanAttr(name)) {
    return !![name, "true"].includes(attr2);
  }
  return attr2;
}
function debounce(func, wait) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      func.apply(context, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}
function throttle(func, limit) {
  let inThrottle;
  return function() {
    let context = this, args = arguments;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  };
}
function entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
  let firstRun = true;
  let outerHash;
  let reference = effect(() => {
    let outer = outerGet();
    let inner = innerGet();
    if (firstRun) {
      innerSet(cloneIfObject(outer));
      firstRun = false;
    } else {
      let outerHashLatest = JSON.stringify(outer);
      let innerHashLatest = JSON.stringify(inner);
      if (outerHashLatest !== outerHash) {
        innerSet(cloneIfObject(outer));
      } else if (outerHashLatest !== innerHashLatest) {
        outerSet(cloneIfObject(inner));
      } else
        ;
    }
    outerHash = JSON.stringify(outerGet());
    JSON.stringify(innerGet());
  });
  return () => {
    release(reference);
  };
}
function cloneIfObject(value) {
  return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
function plugin(callback) {
  let callbacks = Array.isArray(callback) ? callback : [callback];
  callbacks.forEach((i) => i(alpine_default));
}
var stores = {};
var isReactive = false;
function store(name, value) {
  if (!isReactive) {
    stores = reactive(stores);
    isReactive = true;
  }
  if (value === void 0) {
    return stores[name];
  }
  stores[name] = value;
  if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") {
    stores[name].init();
  }
  initInterceptors(stores[name]);
}
function getStores() {
  return stores;
}
var binds = {};
function bind2(name, bindings) {
  let getBindings = typeof bindings !== "function" ? () => bindings : bindings;
  if (name instanceof Element) {
    return applyBindingsObject(name, getBindings());
  } else {
    binds[name] = getBindings;
  }
  return () => {
  };
}
function injectBindingProviders(obj) {
  Object.entries(binds).forEach(([name, callback]) => {
    Object.defineProperty(obj, name, {
      get() {
        return (...args) => {
          return callback(...args);
        };
      }
    });
  });
  return obj;
}
function applyBindingsObject(el, obj, original) {
  let cleanupRunners = [];
  while (cleanupRunners.length)
    cleanupRunners.pop()();
  let attributes = Object.entries(obj).map(([name, value]) => ({ name, value }));
  let staticAttributes = attributesOnly(attributes);
  attributes = attributes.map((attribute) => {
    if (staticAttributes.find((attr2) => attr2.name === attribute.name)) {
      return {
        name: `x-bind:${attribute.name}`,
        value: `"${attribute.value}"`
      };
    }
    return attribute;
  });
  directives(el, attributes, original).map((handle) => {
    cleanupRunners.push(handle.runCleanups);
    handle();
  });
  return () => {
    while (cleanupRunners.length)
      cleanupRunners.pop()();
  };
}
var datas = {};
function data(name, callback) {
  datas[name] = callback;
}
function injectDataProviders(obj, context) {
  Object.entries(datas).forEach(([name, callback]) => {
    Object.defineProperty(obj, name, {
      get() {
        return (...args) => {
          return callback.bind(context)(...args);
        };
      },
      enumerable: false
    });
  });
  return obj;
}
var Alpine = {
  get reactive() {
    return reactive;
  },
  get release() {
    return release;
  },
  get effect() {
    return effect;
  },
  get raw() {
    return raw;
  },
  version: "3.13.10",
  flushAndStopDeferringMutations,
  dontAutoEvaluateFunctions,
  disableEffectScheduling,
  startObservingMutations,
  stopObservingMutations,
  setReactivityEngine,
  onAttributeRemoved,
  onAttributesAdded,
  closestDataStack,
  skipDuringClone,
  onlyDuringClone,
  addRootSelector,
  addInitSelector,
  interceptClone,
  addScopeToNode,
  deferMutations,
  mapAttributes,
  evaluateLater,
  interceptInit,
  setEvaluator,
  mergeProxies,
  extractProp,
  findClosest,
  onElRemoved,
  closestRoot,
  destroyTree,
  interceptor,
  // INTERNAL: not public API and is subject to change without major release.
  transition,
  // INTERNAL
  setStyles,
  // INTERNAL
  mutateDom,
  directive,
  entangle,
  throttle,
  debounce,
  evaluate,
  initTree,
  nextTick,
  prefixed: prefix,
  prefix: setPrefix,
  plugin,
  magic,
  store,
  start,
  clone,
  // INTERNAL
  cloneNode,
  // INTERNAL
  bound: getBinding,
  $data: scope,
  watch,
  walk,
  data,
  bind: bind2
};
var alpine_default = Alpine;
function makeMap(str, expectsLowerCase) {
  const map = /* @__PURE__ */ Object.create(null);
  const list = str.split(",");
  for (let i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase ? (val) => !!map[val.toLowerCase()] : (val) => !!map[val];
}
var EMPTY_OBJ = Object.freeze({});
var hasOwnProperty = Object.prototype.hasOwnProperty;
var hasOwn = (val, key) => hasOwnProperty.call(val, key);
var isArray = Array.isArray;
var isMap = (val) => toTypeString(val) === "[object Map]";
var isString = (val) => typeof val === "string";
var isSymbol = (val) => typeof val === "symbol";
var isObject = (val) => val !== null && typeof val === "object";
var objectToString = Object.prototype.toString;
var toTypeString = (value) => objectToString.call(value);
var toRawType = (value) => {
  return toTypeString(value).slice(8, -1);
};
var isIntegerKey = (key) => isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var cacheStringFunction = (fn) => {
  const cache = /* @__PURE__ */ Object.create(null);
  return (str) => {
    const hit = cache[str];
    return hit || (cache[str] = fn(str));
  };
};
var capitalize = cacheStringFunction((str) => str.charAt(0).toUpperCase() + str.slice(1));
var hasChanged = (value, oldValue) => value !== oldValue && (value === value || oldValue === oldValue);
var targetMap = /* @__PURE__ */ new WeakMap();
var effectStack = [];
var activeEffect;
var ITERATE_KEY = Symbol("iterate");
var MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function isEffect(fn) {
  return fn && fn._isEffect === true;
}
function effect2(fn, options = EMPTY_OBJ) {
  if (isEffect(fn)) {
    fn = fn.raw;
  }
  const effect3 = createReactiveEffect(fn, options);
  if (!options.lazy) {
    effect3();
  }
  return effect3;
}
function stop(effect3) {
  if (effect3.active) {
    cleanup(effect3);
    if (effect3.options.onStop) {
      effect3.options.onStop();
    }
    effect3.active = false;
  }
}
var uid = 0;
function createReactiveEffect(fn, options) {
  const effect3 = function reactiveEffect() {
    if (!effect3.active) {
      return fn();
    }
    if (!effectStack.includes(effect3)) {
      cleanup(effect3);
      try {
        enableTracking();
        effectStack.push(effect3);
        activeEffect = effect3;
        return fn();
      } finally {
        effectStack.pop();
        resetTracking();
        activeEffect = effectStack[effectStack.length - 1];
      }
    }
  };
  effect3.id = uid++;
  effect3.allowRecurse = !!options.allowRecurse;
  effect3._isEffect = true;
  effect3.active = true;
  effect3.raw = fn;
  effect3.deps = [];
  effect3.options = options;
  return effect3;
}
function cleanup(effect3) {
  const { deps } = effect3;
  if (deps.length) {
    for (let i = 0; i < deps.length; i++) {
      deps[i].delete(effect3);
    }
    deps.length = 0;
  }
}
var shouldTrack = true;
var trackStack = [];
function pauseTracking() {
  trackStack.push(shouldTrack);
  shouldTrack = false;
}
function enableTracking() {
  trackStack.push(shouldTrack);
  shouldTrack = true;
}
function resetTracking() {
  const last = trackStack.pop();
  shouldTrack = last === void 0 ? true : last;
}
function track(target, type, key) {
  if (!shouldTrack || activeEffect === void 0) {
    return;
  }
  let depsMap = targetMap.get(target);
  if (!depsMap) {
    targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
  }
  let dep = depsMap.get(key);
  if (!dep) {
    depsMap.set(key, dep = /* @__PURE__ */ new Set());
  }
  if (!dep.has(activeEffect)) {
    dep.add(activeEffect);
    activeEffect.deps.push(dep);
    if (activeEffect.options.onTrack) {
      activeEffect.options.onTrack({
        effect: activeEffect,
        target,
        type,
        key
      });
    }
  }
}
function trigger(target, type, key, newValue, oldValue, oldTarget) {
  const depsMap = targetMap.get(target);
  if (!depsMap) {
    return;
  }
  const effects = /* @__PURE__ */ new Set();
  const add2 = (effectsToAdd) => {
    if (effectsToAdd) {
      effectsToAdd.forEach((effect3) => {
        if (effect3 !== activeEffect || effect3.allowRecurse) {
          effects.add(effect3);
        }
      });
    }
  };
  if (type === "clear") {
    depsMap.forEach(add2);
  } else if (key === "length" && isArray(target)) {
    depsMap.forEach((dep, key2) => {
      if (key2 === "length" || key2 >= newValue) {
        add2(dep);
      }
    });
  } else {
    if (key !== void 0) {
      add2(depsMap.get(key));
    }
    switch (type) {
      case "add":
        if (!isArray(target)) {
          add2(depsMap.get(ITERATE_KEY));
          if (isMap(target)) {
            add2(depsMap.get(MAP_KEY_ITERATE_KEY));
          }
        } else if (isIntegerKey(key)) {
          add2(depsMap.get("length"));
        }
        break;
      case "delete":
        if (!isArray(target)) {
          add2(depsMap.get(ITERATE_KEY));
          if (isMap(target)) {
            add2(depsMap.get(MAP_KEY_ITERATE_KEY));
          }
        }
        break;
      case "set":
        if (isMap(target)) {
          add2(depsMap.get(ITERATE_KEY));
        }
        break;
    }
  }
  const run = (effect3) => {
    if (effect3.options.onTrigger) {
      effect3.options.onTrigger({
        effect: effect3,
        target,
        key,
        type,
        newValue,
        oldValue,
        oldTarget
      });
    }
    if (effect3.options.scheduler) {
      effect3.options.scheduler(effect3);
    } else {
      effect3();
    }
  };
  effects.forEach(run);
}
var isNonTrackableKeys = /* @__PURE__ */ makeMap(`__proto__,__v_isRef,__isVue`);
var builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key) => Symbol[key]).filter(isSymbol));
var get2 = /* @__PURE__ */ createGetter();
var readonlyGet = /* @__PURE__ */ createGetter(true);
var arrayInstrumentations = /* @__PURE__ */ createArrayInstrumentations();
function createArrayInstrumentations() {
  const instrumentations = {};
  ["includes", "indexOf", "lastIndexOf"].forEach((key) => {
    instrumentations[key] = function(...args) {
      const arr = toRaw(this);
      for (let i = 0, l = this.length; i < l; i++) {
        track(arr, "get", i + "");
      }
      const res = arr[key](...args);
      if (res === -1 || res === false) {
        return arr[key](...args.map(toRaw));
      } else {
        return res;
      }
    };
  });
  ["push", "pop", "shift", "unshift", "splice"].forEach((key) => {
    instrumentations[key] = function(...args) {
      pauseTracking();
      const res = toRaw(this)[key].apply(this, args);
      resetTracking();
      return res;
    };
  });
  return instrumentations;
}
function createGetter(isReadonly = false, shallow = false) {
  return function get3(target, key, receiver) {
    if (key === "__v_isReactive") {
      return !isReadonly;
    } else if (key === "__v_isReadonly") {
      return isReadonly;
    } else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? shallowReadonlyMap : readonlyMap : shallow ? shallowReactiveMap : reactiveMap).get(target)) {
      return target;
    }
    const targetIsArray = isArray(target);
    if (!isReadonly && targetIsArray && hasOwn(arrayInstrumentations, key)) {
      return Reflect.get(arrayInstrumentations, key, receiver);
    }
    const res = Reflect.get(target, key, receiver);
    if (isSymbol(key) ? builtInSymbols.has(key) : isNonTrackableKeys(key)) {
      return res;
    }
    if (!isReadonly) {
      track(target, "get", key);
    }
    if (shallow) {
      return res;
    }
    if (isRef(res)) {
      const shouldUnwrap = !targetIsArray || !isIntegerKey(key);
      return shouldUnwrap ? res.value : res;
    }
    if (isObject(res)) {
      return isReadonly ? readonly(res) : reactive2(res);
    }
    return res;
  };
}
var set2 = /* @__PURE__ */ createSetter();
function createSetter(shallow = false) {
  return function set3(target, key, value, receiver) {
    let oldValue = target[key];
    if (!shallow) {
      value = toRaw(value);
      oldValue = toRaw(oldValue);
      if (!isArray(target) && isRef(oldValue) && !isRef(value)) {
        oldValue.value = value;
        return true;
      }
    }
    const hadKey = isArray(target) && isIntegerKey(key) ? Number(key) < target.length : hasOwn(target, key);
    const result = Reflect.set(target, key, value, receiver);
    if (target === toRaw(receiver)) {
      if (!hadKey) {
        trigger(target, "add", key, value);
      } else if (hasChanged(value, oldValue)) {
        trigger(target, "set", key, value, oldValue);
      }
    }
    return result;
  };
}
function deleteProperty(target, key) {
  const hadKey = hasOwn(target, key);
  const oldValue = target[key];
  const result = Reflect.deleteProperty(target, key);
  if (result && hadKey) {
    trigger(target, "delete", key, void 0, oldValue);
  }
  return result;
}
function has(target, key) {
  const result = Reflect.has(target, key);
  if (!isSymbol(key) || !builtInSymbols.has(key)) {
    track(target, "has", key);
  }
  return result;
}
function ownKeys(target) {
  track(target, "iterate", isArray(target) ? "length" : ITERATE_KEY);
  return Reflect.ownKeys(target);
}
var mutableHandlers = {
  get: get2,
  set: set2,
  deleteProperty,
  has,
  ownKeys
};
var readonlyHandlers = {
  get: readonlyGet,
  set(target, key) {
    {
      console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
    }
    return true;
  },
  deleteProperty(target, key) {
    {
      console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
    }
    return true;
  }
};
var toReactive = (value) => isObject(value) ? reactive2(value) : value;
var toReadonly = (value) => isObject(value) ? readonly(value) : value;
var toShallow = (value) => value;
var getProto = (v) => Reflect.getPrototypeOf(v);
function get$1(target, key, isReadonly = false, isShallow = false) {
  target = target[
    "__v_raw"
    /* RAW */
  ];
  const rawTarget = toRaw(target);
  const rawKey = toRaw(key);
  if (key !== rawKey) {
    !isReadonly && track(rawTarget, "get", key);
  }
  !isReadonly && track(rawTarget, "get", rawKey);
  const { has: has2 } = getProto(rawTarget);
  const wrap = isShallow ? toShallow : isReadonly ? toReadonly : toReactive;
  if (has2.call(rawTarget, key)) {
    return wrap(target.get(key));
  } else if (has2.call(rawTarget, rawKey)) {
    return wrap(target.get(rawKey));
  } else if (target !== rawTarget) {
    target.get(key);
  }
}
function has$1(key, isReadonly = false) {
  const target = this[
    "__v_raw"
    /* RAW */
  ];
  const rawTarget = toRaw(target);
  const rawKey = toRaw(key);
  if (key !== rawKey) {
    !isReadonly && track(rawTarget, "has", key);
  }
  !isReadonly && track(rawTarget, "has", rawKey);
  return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function size(target, isReadonly = false) {
  target = target[
    "__v_raw"
    /* RAW */
  ];
  !isReadonly && track(toRaw(target), "iterate", ITERATE_KEY);
  return Reflect.get(target, "size", target);
}
function add(value) {
  value = toRaw(value);
  const target = toRaw(this);
  const proto = getProto(target);
  const hadKey = proto.has.call(target, value);
  if (!hadKey) {
    target.add(value);
    trigger(target, "add", value, value);
  }
  return this;
}
function set$1(key, value) {
  value = toRaw(value);
  const target = toRaw(this);
  const { has: has2, get: get3 } = getProto(target);
  let hadKey = has2.call(target, key);
  if (!hadKey) {
    key = toRaw(key);
    hadKey = has2.call(target, key);
  } else {
    checkIdentityKeys(target, has2, key);
  }
  const oldValue = get3.call(target, key);
  target.set(key, value);
  if (!hadKey) {
    trigger(target, "add", key, value);
  } else if (hasChanged(value, oldValue)) {
    trigger(target, "set", key, value, oldValue);
  }
  return this;
}
function deleteEntry(key) {
  const target = toRaw(this);
  const { has: has2, get: get3 } = getProto(target);
  let hadKey = has2.call(target, key);
  if (!hadKey) {
    key = toRaw(key);
    hadKey = has2.call(target, key);
  } else {
    checkIdentityKeys(target, has2, key);
  }
  const oldValue = get3 ? get3.call(target, key) : void 0;
  const result = target.delete(key);
  if (hadKey) {
    trigger(target, "delete", key, void 0, oldValue);
  }
  return result;
}
function clear() {
  const target = toRaw(this);
  const hadItems = target.size !== 0;
  const oldTarget = isMap(target) ? new Map(target) : new Set(target);
  const result = target.clear();
  if (hadItems) {
    trigger(target, "clear", void 0, void 0, oldTarget);
  }
  return result;
}
function createForEach(isReadonly, isShallow) {
  return function forEach(callback, thisArg) {
    const observed = this;
    const target = observed[
      "__v_raw"
      /* RAW */
    ];
    const rawTarget = toRaw(target);
    const wrap = isShallow ? toShallow : isReadonly ? toReadonly : toReactive;
    !isReadonly && track(rawTarget, "iterate", ITERATE_KEY);
    return target.forEach((value, key) => {
      return callback.call(thisArg, wrap(value), wrap(key), observed);
    });
  };
}
function createIterableMethod(method, isReadonly, isShallow) {
  return function(...args) {
    const target = this[
      "__v_raw"
      /* RAW */
    ];
    const rawTarget = toRaw(target);
    const targetIsMap = isMap(rawTarget);
    const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
    const isKeyOnly = method === "keys" && targetIsMap;
    const innerIterator = target[method](...args);
    const wrap = isShallow ? toShallow : isReadonly ? toReadonly : toReactive;
    !isReadonly && track(rawTarget, "iterate", isKeyOnly ? MAP_KEY_ITERATE_KEY : ITERATE_KEY);
    return {
      // iterator protocol
      next() {
        const { value, done } = innerIterator.next();
        return done ? { value, done } : {
          value: isPair ? [wrap(value[0]), wrap(value[1])] : wrap(value),
          done
        };
      },
      // iterable protocol
      [Symbol.iterator]() {
        return this;
      }
    };
  };
}
function createReadonlyMethod(type) {
  return function(...args) {
    {
      const key = args[0] ? `on key "${args[0]}" ` : ``;
      console.warn(`${capitalize(type)} operation ${key}failed: target is readonly.`, toRaw(this));
    }
    return type === "delete" ? false : this;
  };
}
function createInstrumentations() {
  const mutableInstrumentations2 = {
    get(key) {
      return get$1(this, key);
    },
    get size() {
      return size(this);
    },
    has: has$1,
    add,
    set: set$1,
    delete: deleteEntry,
    clear,
    forEach: createForEach(false, false)
  };
  const shallowInstrumentations2 = {
    get(key) {
      return get$1(this, key, false, true);
    },
    get size() {
      return size(this);
    },
    has: has$1,
    add,
    set: set$1,
    delete: deleteEntry,
    clear,
    forEach: createForEach(false, true)
  };
  const readonlyInstrumentations2 = {
    get(key) {
      return get$1(this, key, true);
    },
    get size() {
      return size(this, true);
    },
    has(key) {
      return has$1.call(this, key, true);
    },
    add: createReadonlyMethod(
      "add"
      /* ADD */
    ),
    set: createReadonlyMethod(
      "set"
      /* SET */
    ),
    delete: createReadonlyMethod(
      "delete"
      /* DELETE */
    ),
    clear: createReadonlyMethod(
      "clear"
      /* CLEAR */
    ),
    forEach: createForEach(true, false)
  };
  const shallowReadonlyInstrumentations2 = {
    get(key) {
      return get$1(this, key, true, true);
    },
    get size() {
      return size(this, true);
    },
    has(key) {
      return has$1.call(this, key, true);
    },
    add: createReadonlyMethod(
      "add"
      /* ADD */
    ),
    set: createReadonlyMethod(
      "set"
      /* SET */
    ),
    delete: createReadonlyMethod(
      "delete"
      /* DELETE */
    ),
    clear: createReadonlyMethod(
      "clear"
      /* CLEAR */
    ),
    forEach: createForEach(true, true)
  };
  const iteratorMethods = ["keys", "values", "entries", Symbol.iterator];
  iteratorMethods.forEach((method) => {
    mutableInstrumentations2[method] = createIterableMethod(method, false, false);
    readonlyInstrumentations2[method] = createIterableMethod(method, true, false);
    shallowInstrumentations2[method] = createIterableMethod(method, false, true);
    shallowReadonlyInstrumentations2[method] = createIterableMethod(method, true, true);
  });
  return [
    mutableInstrumentations2,
    readonlyInstrumentations2,
    shallowInstrumentations2,
    shallowReadonlyInstrumentations2
  ];
}
var [mutableInstrumentations, readonlyInstrumentations, shallowInstrumentations, shallowReadonlyInstrumentations] = /* @__PURE__ */ createInstrumentations();
function createInstrumentationGetter(isReadonly, shallow) {
  const instrumentations = shallow ? isReadonly ? shallowReadonlyInstrumentations : shallowInstrumentations : isReadonly ? readonlyInstrumentations : mutableInstrumentations;
  return (target, key, receiver) => {
    if (key === "__v_isReactive") {
      return !isReadonly;
    } else if (key === "__v_isReadonly") {
      return isReadonly;
    } else if (key === "__v_raw") {
      return target;
    }
    return Reflect.get(hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
  };
}
var mutableCollectionHandlers = {
  get: /* @__PURE__ */ createInstrumentationGetter(false, false)
};
var readonlyCollectionHandlers = {
  get: /* @__PURE__ */ createInstrumentationGetter(true, false)
};
function checkIdentityKeys(target, has2, key) {
  const rawKey = toRaw(key);
  if (rawKey !== key && has2.call(target, rawKey)) {
    const type = toRawType(target);
    console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
  }
}
var reactiveMap = /* @__PURE__ */ new WeakMap();
var shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var readonlyMap = /* @__PURE__ */ new WeakMap();
var shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function targetTypeMap(rawType) {
  switch (rawType) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
function getTargetType(value) {
  return value[
    "__v_skip"
    /* SKIP */
  ] || !Object.isExtensible(value) ? 0 : targetTypeMap(toRawType(value));
}
function reactive2(target) {
  if (target && target[
    "__v_isReadonly"
    /* IS_READONLY */
  ]) {
    return target;
  }
  return createReactiveObject(target, false, mutableHandlers, mutableCollectionHandlers, reactiveMap);
}
function readonly(target) {
  return createReactiveObject(target, true, readonlyHandlers, readonlyCollectionHandlers, readonlyMap);
}
function createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
  if (!isObject(target)) {
    {
      console.warn(`value cannot be made reactive: ${String(target)}`);
    }
    return target;
  }
  if (target[
    "__v_raw"
    /* RAW */
  ] && !(isReadonly && target[
    "__v_isReactive"
    /* IS_REACTIVE */
  ])) {
    return target;
  }
  const existingProxy = proxyMap.get(target);
  if (existingProxy) {
    return existingProxy;
  }
  const targetType = getTargetType(target);
  if (targetType === 0) {
    return target;
  }
  const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
  proxyMap.set(target, proxy);
  return proxy;
}
function toRaw(observed) {
  return observed && toRaw(observed[
    "__v_raw"
    /* RAW */
  ]) || observed;
}
function isRef(r) {
  return Boolean(r && r.__v_isRef === true);
}
magic("nextTick", () => nextTick);
magic("dispatch", (el) => dispatch.bind(dispatch, el));
magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 }) => (key, callback) => {
  let evaluate2 = evaluateLater2(key);
  let getter = () => {
    let value;
    evaluate2((i) => value = i);
    return value;
  };
  let unwatch = watch(getter, callback);
  cleanup2(unwatch);
});
magic("store", getStores);
magic("data", (el) => scope(el));
magic("root", (el) => closestRoot(el));
magic("refs", (el) => {
  if (el._x_refs_proxy)
    return el._x_refs_proxy;
  el._x_refs_proxy = mergeProxies(getArrayOfRefObject(el));
  return el._x_refs_proxy;
});
function getArrayOfRefObject(el) {
  let refObjects = [];
  findClosest(el, (i) => {
    if (i._x_refs)
      refObjects.push(i._x_refs);
  });
  return refObjects;
}
var globalIdMemo = {};
function findAndIncrementId(name) {
  if (!globalIdMemo[name])
    globalIdMemo[name] = 0;
  return ++globalIdMemo[name];
}
function closestIdRoot(el, name) {
  return findClosest(el, (element) => {
    if (element._x_ids && element._x_ids[name])
      return true;
  });
}
function setIdRoot(el, name) {
  if (!el._x_ids)
    el._x_ids = {};
  if (!el._x_ids[name])
    el._x_ids[name] = findAndIncrementId(name);
}
magic("id", (el, { cleanup: cleanup2 }) => (name, key = null) => {
  let cacheKey = `${name}${key ? `-${key}` : ""}`;
  return cacheIdByNameOnElement(el, cacheKey, cleanup2, () => {
    let root = closestIdRoot(el, name);
    let id = root ? root._x_ids[name] : findAndIncrementId(name);
    return key ? `${name}-${id}-${key}` : `${name}-${id}`;
  });
});
interceptClone((from, to) => {
  if (from._x_id) {
    to._x_id = from._x_id;
  }
});
function cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
  if (!el._x_id)
    el._x_id = {};
  if (el._x_id[cacheKey])
    return el._x_id[cacheKey];
  let output = callback();
  el._x_id[cacheKey] = output;
  cleanup2(() => {
    delete el._x_id[cacheKey];
  });
  return output;
}
magic("el", (el) => el);
warnMissingPluginMagic("Focus", "focus", "focus");
warnMissingPluginMagic("Persist", "persist", "persist");
function warnMissingPluginMagic(name, magicName, slug) {
  magic(magicName, (el) => warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
directive("modelable", (el, { expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 }) => {
  let func = evaluateLater2(expression);
  let innerGet = () => {
    let result;
    func((i) => result = i);
    return result;
  };
  let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
  let innerSet = (val) => evaluateInnerSet(() => {
  }, { scope: { "__placeholder": val } });
  let initialValue = innerGet();
  innerSet(initialValue);
  queueMicrotask(() => {
    if (!el._x_model)
      return;
    el._x_removeModelListeners["default"]();
    let outerGet = el._x_model.get;
    let outerSet = el._x_model.set;
    let releaseEntanglement = entangle(
      {
        get() {
          return outerGet();
        },
        set(value) {
          outerSet(value);
        }
      },
      {
        get() {
          return innerGet();
        },
        set(value) {
          innerSet(value);
        }
      }
    );
    cleanup2(releaseEntanglement);
  });
});
directive("teleport", (el, { modifiers, expression }, { cleanup: cleanup2 }) => {
  if (el.tagName.toLowerCase() !== "template")
    warn("x-teleport can only be used on a <template> tag", el);
  let target = getTarget(expression);
  let clone2 = el.content.cloneNode(true).firstElementChild;
  el._x_teleport = clone2;
  clone2._x_teleportBack = el;
  el.setAttribute("data-teleport-template", true);
  clone2.setAttribute("data-teleport-target", true);
  if (el._x_forwardEvents) {
    el._x_forwardEvents.forEach((eventName) => {
      clone2.addEventListener(eventName, (e) => {
        e.stopPropagation();
        el.dispatchEvent(new e.constructor(e.type, e));
      });
    });
  }
  addScopeToNode(clone2, {}, el);
  let placeInDom = (clone3, target2, modifiers2) => {
    if (modifiers2.includes("prepend")) {
      target2.parentNode.insertBefore(clone3, target2);
    } else if (modifiers2.includes("append")) {
      target2.parentNode.insertBefore(clone3, target2.nextSibling);
    } else {
      target2.appendChild(clone3);
    }
  };
  mutateDom(() => {
    placeInDom(clone2, target, modifiers);
    skipDuringClone(() => {
      initTree(clone2);
      clone2._x_ignore = true;
    })();
  });
  el._x_teleportPutBack = () => {
    let target2 = getTarget(expression);
    mutateDom(() => {
      placeInDom(el._x_teleport, target2, modifiers);
    });
  };
  cleanup2(() => clone2.remove());
});
var teleportContainerDuringClone = document.createElement("div");
function getTarget(expression) {
  let target = skipDuringClone(() => {
    return document.querySelector(expression);
  }, () => {
    return teleportContainerDuringClone;
  })();
  if (!target)
    warn(`Cannot find x-teleport element for selector: "${expression}"`);
  return target;
}
var handler = () => {
};
handler.inline = (el, { modifiers }, { cleanup: cleanup2 }) => {
  modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
  cleanup2(() => {
    modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
  });
};
directive("ignore", handler);
directive("effect", skipDuringClone((el, { expression }, { effect: effect3 }) => {
  effect3(evaluateLater(el, expression));
}));
function on(el, event, modifiers, callback) {
  let listenerTarget = el;
  let handler4 = (e) => callback(e);
  let options = {};
  let wrapHandler = (callback2, wrapper) => (e) => wrapper(callback2, e);
  if (modifiers.includes("dot"))
    event = dotSyntax(event);
  if (modifiers.includes("camel"))
    event = camelCase2(event);
  if (modifiers.includes("passive"))
    options.passive = true;
  if (modifiers.includes("capture"))
    options.capture = true;
  if (modifiers.includes("window"))
    listenerTarget = window;
  if (modifiers.includes("document"))
    listenerTarget = document;
  if (modifiers.includes("debounce")) {
    let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
    let wait = isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
    handler4 = debounce(handler4, wait);
  }
  if (modifiers.includes("throttle")) {
    let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
    let wait = isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
    handler4 = throttle(handler4, wait);
  }
  if (modifiers.includes("prevent"))
    handler4 = wrapHandler(handler4, (next2, e) => {
      e.preventDefault();
      next2(e);
    });
  if (modifiers.includes("stop"))
    handler4 = wrapHandler(handler4, (next2, e) => {
      e.stopPropagation();
      next2(e);
    });
  if (modifiers.includes("once")) {
    handler4 = wrapHandler(handler4, (next2, e) => {
      next2(e);
      listenerTarget.removeEventListener(event, handler4, options);
    });
  }
  if (modifiers.includes("away") || modifiers.includes("outside")) {
    listenerTarget = document;
    handler4 = wrapHandler(handler4, (next2, e) => {
      if (el.contains(e.target))
        return;
      if (e.target.isConnected === false)
        return;
      if (el.offsetWidth < 1 && el.offsetHeight < 1)
        return;
      if (el._x_isShown === false)
        return;
      next2(e);
    });
  }
  if (modifiers.includes("self"))
    handler4 = wrapHandler(handler4, (next2, e) => {
      e.target === el && next2(e);
    });
  handler4 = wrapHandler(handler4, (next2, e) => {
    if (isKeyEvent(event)) {
      if (isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) {
        return;
      }
    }
    next2(e);
  });
  listenerTarget.addEventListener(event, handler4, options);
  return () => {
    listenerTarget.removeEventListener(event, handler4, options);
  };
}
function dotSyntax(subject) {
  return subject.replace(/-/g, ".");
}
function camelCase2(subject) {
  return subject.toLowerCase().replace(/-(\w)/g, (match, char) => char.toUpperCase());
}
function isNumeric(subject) {
  return !Array.isArray(subject) && !isNaN(subject);
}
function kebabCase2(subject) {
  if ([" ", "_"].includes(
    subject
  ))
    return subject;
  return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function isKeyEvent(event) {
  return ["keydown", "keyup"].includes(event);
}
function isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
  let keyModifiers = modifiers.filter((i) => {
    return !["window", "document", "prevent", "stop", "once", "capture"].includes(i);
  });
  if (keyModifiers.includes("debounce")) {
    let debounceIndex = keyModifiers.indexOf("debounce");
    keyModifiers.splice(debounceIndex, isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
  }
  if (keyModifiers.includes("throttle")) {
    let debounceIndex = keyModifiers.indexOf("throttle");
    keyModifiers.splice(debounceIndex, isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
  }
  if (keyModifiers.length === 0)
    return false;
  if (keyModifiers.length === 1 && keyToModifiers(e.key).includes(keyModifiers[0]))
    return false;
  const systemKeyModifiers = ["ctrl", "shift", "alt", "meta", "cmd", "super"];
  const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier) => keyModifiers.includes(modifier));
  keyModifiers = keyModifiers.filter((i) => !selectedSystemKeyModifiers.includes(i));
  if (selectedSystemKeyModifiers.length > 0) {
    const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier) => {
      if (modifier === "cmd" || modifier === "super")
        modifier = "meta";
      return e[`${modifier}Key`];
    });
    if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
      if (keyToModifiers(e.key).includes(keyModifiers[0]))
        return false;
    }
  }
  return true;
}
function keyToModifiers(key) {
  if (!key)
    return [];
  key = kebabCase2(key);
  let modifierToKeyMap = {
    "ctrl": "control",
    "slash": "/",
    "space": " ",
    "spacebar": " ",
    "cmd": "meta",
    "esc": "escape",
    "up": "arrow-up",
    "down": "arrow-down",
    "left": "arrow-left",
    "right": "arrow-right",
    "period": ".",
    "comma": ",",
    "equal": "=",
    "minus": "-",
    "underscore": "_"
  };
  modifierToKeyMap[key] = key;
  return Object.keys(modifierToKeyMap).map((modifier) => {
    if (modifierToKeyMap[modifier] === key)
      return modifier;
  }).filter((modifier) => modifier);
}
directive("model", (el, { modifiers, expression }, { effect: effect3, cleanup: cleanup2 }) => {
  let scopeTarget = el;
  if (modifiers.includes("parent")) {
    scopeTarget = el.parentNode;
  }
  let evaluateGet = evaluateLater(scopeTarget, expression);
  let evaluateSet;
  if (typeof expression === "string") {
    evaluateSet = evaluateLater(scopeTarget, `${expression} = __placeholder`);
  } else if (typeof expression === "function" && typeof expression() === "string") {
    evaluateSet = evaluateLater(scopeTarget, `${expression()} = __placeholder`);
  } else {
    evaluateSet = () => {
    };
  }
  let getValue = () => {
    let result;
    evaluateGet((value) => result = value);
    return isGetterSetter(result) ? result.get() : result;
  };
  let setValue = (value) => {
    let result;
    evaluateGet((value2) => result = value2);
    if (isGetterSetter(result)) {
      result.set(value);
    } else {
      evaluateSet(() => {
      }, {
        scope: { "__placeholder": value }
      });
    }
  };
  if (typeof expression === "string" && el.type === "radio") {
    mutateDom(() => {
      if (!el.hasAttribute("name"))
        el.setAttribute("name", expression);
    });
  }
  var event = el.tagName.toLowerCase() === "select" || ["checkbox", "radio"].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
  let removeListener = isCloning ? () => {
  } : on(el, event, modifiers, (e) => {
    setValue(getInputValue(el, modifiers, e, getValue()));
  });
  if (modifiers.includes("fill")) {
    if ([void 0, null, ""].includes(getValue()) || el.type === "checkbox" && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) {
      setValue(
        getInputValue(el, modifiers, { target: el }, getValue())
      );
    }
  }
  if (!el._x_removeModelListeners)
    el._x_removeModelListeners = {};
  el._x_removeModelListeners["default"] = removeListener;
  cleanup2(() => el._x_removeModelListeners["default"]());
  if (el.form) {
    let removeResetListener = on(el.form, "reset", [], (e) => {
      nextTick(() => el._x_model && el._x_model.set(getInputValue(el, modifiers, { target: el }, getValue())));
    });
    cleanup2(() => removeResetListener());
  }
  el._x_model = {
    get() {
      return getValue();
    },
    set(value) {
      setValue(value);
    }
  };
  el._x_forceModelUpdate = (value) => {
    if (value === void 0 && typeof expression === "string" && expression.match(/\./))
      value = "";
    window.fromModel = true;
    mutateDom(() => bind(el, "value", value));
    delete window.fromModel;
  };
  effect3(() => {
    let value = getValue();
    if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el))
      return;
    el._x_forceModelUpdate(value);
  });
});
function getInputValue(el, modifiers, event, currentValue) {
  return mutateDom(() => {
    if (event instanceof CustomEvent && event.detail !== void 0)
      return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
    else if (el.type === "checkbox") {
      if (Array.isArray(currentValue)) {
        let newValue = null;
        if (modifiers.includes("number")) {
          newValue = safeParseNumber(event.target.value);
        } else if (modifiers.includes("boolean")) {
          newValue = safeParseBoolean(event.target.value);
        } else {
          newValue = event.target.value;
        }
        return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([newValue]) : currentValue.filter((el2) => !checkedAttrLooseCompare2(el2, newValue));
      } else {
        return event.target.checked;
      }
    } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
      if (modifiers.includes("number")) {
        return Array.from(event.target.selectedOptions).map((option) => {
          let rawValue = option.value || option.text;
          return safeParseNumber(rawValue);
        });
      } else if (modifiers.includes("boolean")) {
        return Array.from(event.target.selectedOptions).map((option) => {
          let rawValue = option.value || option.text;
          return safeParseBoolean(rawValue);
        });
      }
      return Array.from(event.target.selectedOptions).map((option) => {
        return option.value || option.text;
      });
    } else {
      let newValue;
      if (el.type === "radio") {
        if (event.target.checked) {
          newValue = event.target.value;
        } else {
          newValue = currentValue;
        }
      } else {
        newValue = event.target.value;
      }
      if (modifiers.includes("number")) {
        return safeParseNumber(newValue);
      } else if (modifiers.includes("boolean")) {
        return safeParseBoolean(newValue);
      } else if (modifiers.includes("trim")) {
        return newValue.trim();
      } else {
        return newValue;
      }
    }
  });
}
function safeParseNumber(rawValue) {
  let number = rawValue ? parseFloat(rawValue) : null;
  return isNumeric2(number) ? number : rawValue;
}
function checkedAttrLooseCompare2(valueA, valueB) {
  return valueA == valueB;
}
function isNumeric2(subject) {
  return !Array.isArray(subject) && !isNaN(subject);
}
function isGetterSetter(value) {
  return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
directive("cloak", (el) => queueMicrotask(() => mutateDom(() => el.removeAttribute(prefix("cloak")))));
addInitSelector(() => `[${prefix("init")}]`);
directive("init", skipDuringClone((el, { expression }, { evaluate: evaluate2 }) => {
  if (typeof expression === "string") {
    return !!expression.trim() && evaluate2(expression, {}, false);
  }
  return evaluate2(expression, {}, false);
}));
directive("text", (el, { expression }, { effect: effect3, evaluateLater: evaluateLater2 }) => {
  let evaluate2 = evaluateLater2(expression);
  effect3(() => {
    evaluate2((value) => {
      mutateDom(() => {
        el.textContent = value;
      });
    });
  });
});
directive("html", (el, { expression }, { effect: effect3, evaluateLater: evaluateLater2 }) => {
  let evaluate2 = evaluateLater2(expression);
  effect3(() => {
    evaluate2((value) => {
      mutateDom(() => {
        el.innerHTML = value;
        el._x_ignoreSelf = true;
        initTree(el);
        delete el._x_ignoreSelf;
      });
    });
  });
});
mapAttributes(startingWith(":", into(prefix("bind:"))));
var handler2 = (el, { value, modifiers, expression, original }, { effect: effect3, cleanup: cleanup2 }) => {
  if (!value) {
    let bindingProviders = {};
    injectBindingProviders(bindingProviders);
    let getBindings = evaluateLater(el, expression);
    getBindings((bindings) => {
      applyBindingsObject(el, bindings, original);
    }, { scope: bindingProviders });
    return;
  }
  if (value === "key")
    return storeKeyForXFor(el, expression);
  if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) {
    return;
  }
  let evaluate2 = evaluateLater(el, expression);
  effect3(() => evaluate2((result) => {
    if (result === void 0 && typeof expression === "string" && expression.match(/\./)) {
      result = "";
    }
    mutateDom(() => bind(el, value, result, modifiers));
  }));
  cleanup2(() => {
    el._x_undoAddedClasses && el._x_undoAddedClasses();
    el._x_undoAddedStyles && el._x_undoAddedStyles();
  });
};
handler2.inline = (el, { value, modifiers, expression }) => {
  if (!value)
    return;
  if (!el._x_inlineBindings)
    el._x_inlineBindings = {};
  el._x_inlineBindings[value] = { expression, extract: false };
};
directive("bind", handler2);
function storeKeyForXFor(el, expression) {
  el._x_keyExpression = expression;
}
addRootSelector(() => `[${prefix("data")}]`);
directive("data", (el, { expression }, { cleanup: cleanup2 }) => {
  if (shouldSkipRegisteringDataDuringClone(el))
    return;
  expression = expression === "" ? "{}" : expression;
  let magicContext = {};
  injectMagics(magicContext, el);
  let dataProviderContext = {};
  injectDataProviders(dataProviderContext, magicContext);
  let data2 = evaluate(el, expression, { scope: dataProviderContext });
  if (data2 === void 0 || data2 === true)
    data2 = {};
  injectMagics(data2, el);
  let reactiveData = reactive(data2);
  initInterceptors(reactiveData);
  let undo = addScopeToNode(el, reactiveData);
  reactiveData["init"] && evaluate(el, reactiveData["init"]);
  cleanup2(() => {
    reactiveData["destroy"] && evaluate(el, reactiveData["destroy"]);
    undo();
  });
});
interceptClone((from, to) => {
  if (from._x_dataStack) {
    to._x_dataStack = from._x_dataStack;
    to.setAttribute("data-has-alpine-state", true);
  }
});
function shouldSkipRegisteringDataDuringClone(el) {
  if (!isCloning)
    return false;
  if (isCloningLegacy)
    return true;
  return el.hasAttribute("data-has-alpine-state");
}
directive("show", (el, { modifiers, expression }, { effect: effect3 }) => {
  let evaluate2 = evaluateLater(el, expression);
  if (!el._x_doHide)
    el._x_doHide = () => {
      mutateDom(() => {
        el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
      });
    };
  if (!el._x_doShow)
    el._x_doShow = () => {
      mutateDom(() => {
        if (el.style.length === 1 && el.style.display === "none") {
          el.removeAttribute("style");
        } else {
          el.style.removeProperty("display");
        }
      });
    };
  let hide = () => {
    el._x_doHide();
    el._x_isShown = false;
  };
  let show = () => {
    el._x_doShow();
    el._x_isShown = true;
  };
  let clickAwayCompatibleShow = () => setTimeout(show);
  let toggle = once(
    (value) => value ? show() : hide(),
    (value) => {
      if (typeof el._x_toggleAndCascadeWithTransitions === "function") {
        el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
      } else {
        value ? clickAwayCompatibleShow() : hide();
      }
    }
  );
  let oldValue;
  let firstTime = true;
  effect3(() => evaluate2((value) => {
    if (!firstTime && value === oldValue)
      return;
    if (modifiers.includes("immediate"))
      value ? clickAwayCompatibleShow() : hide();
    toggle(value);
    oldValue = value;
    firstTime = false;
  }));
});
directive("for", (el, { expression }, { effect: effect3, cleanup: cleanup2 }) => {
  let iteratorNames = parseForExpression(expression);
  let evaluateItems = evaluateLater(el, iteratorNames.items);
  let evaluateKey = evaluateLater(
    el,
    // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index"
  );
  el._x_prevKeys = [];
  el._x_lookup = {};
  effect3(() => loop(el, iteratorNames, evaluateItems, evaluateKey));
  cleanup2(() => {
    Object.values(el._x_lookup).forEach((el2) => el2.remove());
    delete el._x_prevKeys;
    delete el._x_lookup;
  });
});
function loop(el, iteratorNames, evaluateItems, evaluateKey) {
  let isObject2 = (i) => typeof i === "object" && !Array.isArray(i);
  let templateEl = el;
  evaluateItems((items) => {
    if (isNumeric3(items) && items >= 0) {
      items = Array.from(Array(items).keys(), (i) => i + 1);
    }
    if (items === void 0)
      items = [];
    let lookup = el._x_lookup;
    let prevKeys = el._x_prevKeys;
    let scopes = [];
    let keys = [];
    if (isObject2(items)) {
      items = Object.entries(items).map(([key, value]) => {
        let scope2 = getIterationScopeVariables(iteratorNames, value, key, items);
        evaluateKey((value2) => {
          if (keys.includes(value2))
            warn("Duplicate key on x-for", el);
          keys.push(value2);
        }, { scope: { index: key, ...scope2 } });
        scopes.push(scope2);
      });
    } else {
      for (let i = 0; i < items.length; i++) {
        let scope2 = getIterationScopeVariables(iteratorNames, items[i], i, items);
        evaluateKey((value) => {
          if (keys.includes(value))
            warn("Duplicate key on x-for", el);
          keys.push(value);
        }, { scope: { index: i, ...scope2 } });
        scopes.push(scope2);
      }
    }
    let adds = [];
    let moves = [];
    let removes = [];
    let sames = [];
    for (let i = 0; i < prevKeys.length; i++) {
      let key = prevKeys[i];
      if (keys.indexOf(key) === -1)
        removes.push(key);
    }
    prevKeys = prevKeys.filter((key) => !removes.includes(key));
    let lastKey = "template";
    for (let i = 0; i < keys.length; i++) {
      let key = keys[i];
      let prevIndex = prevKeys.indexOf(key);
      if (prevIndex === -1) {
        prevKeys.splice(i, 0, key);
        adds.push([lastKey, i]);
      } else if (prevIndex !== i) {
        let keyInSpot = prevKeys.splice(i, 1)[0];
        let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
        prevKeys.splice(i, 0, keyForSpot);
        prevKeys.splice(prevIndex, 0, keyInSpot);
        moves.push([keyInSpot, keyForSpot]);
      } else {
        sames.push(key);
      }
      lastKey = key;
    }
    for (let i = 0; i < removes.length; i++) {
      let key = removes[i];
      if (!!lookup[key]._x_effects) {
        lookup[key]._x_effects.forEach(dequeueJob);
      }
      lookup[key].remove();
      lookup[key] = null;
      delete lookup[key];
    }
    for (let i = 0; i < moves.length; i++) {
      let [keyInSpot, keyForSpot] = moves[i];
      let elInSpot = lookup[keyInSpot];
      let elForSpot = lookup[keyForSpot];
      let marker = document.createElement("div");
      mutateDom(() => {
        if (!elForSpot)
          warn(`x-for ":key" is undefined or invalid`, templateEl, keyForSpot, lookup);
        elForSpot.after(marker);
        elInSpot.after(elForSpot);
        elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
        marker.before(elInSpot);
        elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
        marker.remove();
      });
      elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
    }
    for (let i = 0; i < adds.length; i++) {
      let [lastKey2, index2] = adds[i];
      let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
      if (lastEl._x_currentIfEl)
        lastEl = lastEl._x_currentIfEl;
      let scope2 = scopes[index2];
      let key = keys[index2];
      let clone2 = document.importNode(templateEl.content, true).firstElementChild;
      let reactiveScope = reactive(scope2);
      addScopeToNode(clone2, reactiveScope, templateEl);
      clone2._x_refreshXForScope = (newScope) => {
        Object.entries(newScope).forEach(([key2, value]) => {
          reactiveScope[key2] = value;
        });
      };
      mutateDom(() => {
        lastEl.after(clone2);
        skipDuringClone(() => initTree(clone2))();
      });
      if (typeof key === "object") {
        warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
      }
      lookup[key] = clone2;
    }
    for (let i = 0; i < sames.length; i++) {
      lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
    }
    templateEl._x_prevKeys = keys;
  });
}
function parseForExpression(expression) {
  let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
  let stripParensRE = /^\s*\(|\)\s*$/g;
  let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
  let inMatch = expression.match(forAliasRE);
  if (!inMatch)
    return;
  let res = {};
  res.items = inMatch[2].trim();
  let item = inMatch[1].replace(stripParensRE, "").trim();
  let iteratorMatch = item.match(forIteratorRE);
  if (iteratorMatch) {
    res.item = item.replace(forIteratorRE, "").trim();
    res.index = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.collection = iteratorMatch[2].trim();
    }
  } else {
    res.item = item;
  }
  return res;
}
function getIterationScopeVariables(iteratorNames, item, index2, items) {
  let scopeVariables = {};
  if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
    let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i) => i.trim());
    names.forEach((name, i) => {
      scopeVariables[name] = item[i];
    });
  } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
    let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i) => i.trim());
    names.forEach((name) => {
      scopeVariables[name] = item[name];
    });
  } else {
    scopeVariables[iteratorNames.item] = item;
  }
  if (iteratorNames.index)
    scopeVariables[iteratorNames.index] = index2;
  if (iteratorNames.collection)
    scopeVariables[iteratorNames.collection] = items;
  return scopeVariables;
}
function isNumeric3(subject) {
  return !Array.isArray(subject) && !isNaN(subject);
}
function handler3() {
}
handler3.inline = (el, { expression }, { cleanup: cleanup2 }) => {
  let root = closestRoot(el);
  if (!root._x_refs)
    root._x_refs = {};
  root._x_refs[expression] = el;
  cleanup2(() => delete root._x_refs[expression]);
};
directive("ref", handler3);
directive("if", (el, { expression }, { effect: effect3, cleanup: cleanup2 }) => {
  if (el.tagName.toLowerCase() !== "template")
    warn("x-if can only be used on a <template> tag", el);
  let evaluate2 = evaluateLater(el, expression);
  let show = () => {
    if (el._x_currentIfEl)
      return el._x_currentIfEl;
    let clone2 = el.content.cloneNode(true).firstElementChild;
    addScopeToNode(clone2, {}, el);
    mutateDom(() => {
      el.after(clone2);
      skipDuringClone(() => initTree(clone2))();
    });
    el._x_currentIfEl = clone2;
    el._x_undoIf = () => {
      walk(clone2, (node) => {
        if (!!node._x_effects) {
          node._x_effects.forEach(dequeueJob);
        }
      });
      clone2.remove();
      delete el._x_currentIfEl;
    };
    return clone2;
  };
  let hide = () => {
    if (!el._x_undoIf)
      return;
    el._x_undoIf();
    delete el._x_undoIf;
  };
  effect3(() => evaluate2((value) => {
    value ? show() : hide();
  }));
  cleanup2(() => el._x_undoIf && el._x_undoIf());
});
directive("id", (el, { expression }, { evaluate: evaluate2 }) => {
  let names = evaluate2(expression);
  names.forEach((name) => setIdRoot(el, name));
});
interceptClone((from, to) => {
  if (from._x_ids) {
    to._x_ids = from._x_ids;
  }
});
mapAttributes(startingWith("@", into(prefix("on:"))));
directive("on", skipDuringClone((el, { value, modifiers, expression }, { cleanup: cleanup2 }) => {
  let evaluate2 = expression ? evaluateLater(el, expression) : () => {
  };
  if (el.tagName.toLowerCase() === "template") {
    if (!el._x_forwardEvents)
      el._x_forwardEvents = [];
    if (!el._x_forwardEvents.includes(value))
      el._x_forwardEvents.push(value);
  }
  let removeListener = on(el, value, modifiers, (e) => {
    evaluate2(() => {
    }, { scope: { "$event": e }, params: [e] });
  });
  cleanup2(() => removeListener());
}));
warnMissingPluginDirective("Collapse", "collapse", "collapse");
warnMissingPluginDirective("Intersect", "intersect", "intersect");
warnMissingPluginDirective("Focus", "trap", "focus");
warnMissingPluginDirective("Mask", "mask", "mask");
function warnMissingPluginDirective(name, directiveName, slug) {
  directive(directiveName, (el) => warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
alpine_default.setEvaluator(normalEvaluator);
alpine_default.setReactivityEngine({ reactive: reactive2, effect: effect2, release: stop, raw: toRaw });
var src_default = alpine_default;
var module_default = src_default;
const module_esm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Alpine: src_default,
  default: module_default
}, Symbol.toStringTag, { value: "Module" }));
const choices_min = "";
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var choices = { exports: {} };
/*! choices.js v10.2.0 | © 2022 Josh Johnson | https://github.com/jshjohnson/Choices#readme */
(function(module, exports) {
  (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
  })(window, function() {
    return (
      /******/
      function() {
        var __webpack_modules__ = {
          /***/
          282: (
            /***/
            function(__unused_webpack_module, exports2, __webpack_require__2) {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.clearChoices = exports2.activateChoices = exports2.filterChoices = exports2.addChoice = void 0;
              var constants_1 = __webpack_require__2(883);
              var addChoice = function(_a) {
                var value = _a.value, label = _a.label, id = _a.id, groupId = _a.groupId, disabled = _a.disabled, elementId = _a.elementId, customProperties = _a.customProperties, placeholder = _a.placeholder, keyCode = _a.keyCode;
                return {
                  type: constants_1.ACTION_TYPES.ADD_CHOICE,
                  value,
                  label,
                  id,
                  groupId,
                  disabled,
                  elementId,
                  customProperties,
                  placeholder,
                  keyCode
                };
              };
              exports2.addChoice = addChoice;
              var filterChoices = function(results) {
                return {
                  type: constants_1.ACTION_TYPES.FILTER_CHOICES,
                  results
                };
              };
              exports2.filterChoices = filterChoices;
              var activateChoices = function(active) {
                if (active === void 0) {
                  active = true;
                }
                return {
                  type: constants_1.ACTION_TYPES.ACTIVATE_CHOICES,
                  active
                };
              };
              exports2.activateChoices = activateChoices;
              var clearChoices = function() {
                return {
                  type: constants_1.ACTION_TYPES.CLEAR_CHOICES
                };
              };
              exports2.clearChoices = clearChoices;
            }
          ),
          /***/
          783: (
            /***/
            function(__unused_webpack_module, exports2, __webpack_require__2) {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.addGroup = void 0;
              var constants_1 = __webpack_require__2(883);
              var addGroup = function(_a) {
                var value = _a.value, id = _a.id, active = _a.active, disabled = _a.disabled;
                return {
                  type: constants_1.ACTION_TYPES.ADD_GROUP,
                  value,
                  id,
                  active,
                  disabled
                };
              };
              exports2.addGroup = addGroup;
            }
          ),
          /***/
          464: (
            /***/
            function(__unused_webpack_module, exports2, __webpack_require__2) {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.highlightItem = exports2.removeItem = exports2.addItem = void 0;
              var constants_1 = __webpack_require__2(883);
              var addItem = function(_a) {
                var value = _a.value, label = _a.label, id = _a.id, choiceId = _a.choiceId, groupId = _a.groupId, customProperties = _a.customProperties, placeholder = _a.placeholder, keyCode = _a.keyCode;
                return {
                  type: constants_1.ACTION_TYPES.ADD_ITEM,
                  value,
                  label,
                  id,
                  choiceId,
                  groupId,
                  customProperties,
                  placeholder,
                  keyCode
                };
              };
              exports2.addItem = addItem;
              var removeItem = function(id, choiceId) {
                return {
                  type: constants_1.ACTION_TYPES.REMOVE_ITEM,
                  id,
                  choiceId
                };
              };
              exports2.removeItem = removeItem;
              var highlightItem = function(id, highlighted) {
                return {
                  type: constants_1.ACTION_TYPES.HIGHLIGHT_ITEM,
                  id,
                  highlighted
                };
              };
              exports2.highlightItem = highlightItem;
            }
          ),
          /***/
          137: (
            /***/
            function(__unused_webpack_module, exports2, __webpack_require__2) {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.setIsLoading = exports2.resetTo = exports2.clearAll = void 0;
              var constants_1 = __webpack_require__2(883);
              var clearAll = function() {
                return {
                  type: constants_1.ACTION_TYPES.CLEAR_ALL
                };
              };
              exports2.clearAll = clearAll;
              var resetTo = function(state) {
                return {
                  type: constants_1.ACTION_TYPES.RESET_TO,
                  state
                };
              };
              exports2.resetTo = resetTo;
              var setIsLoading = function(isLoading) {
                return {
                  type: constants_1.ACTION_TYPES.SET_IS_LOADING,
                  isLoading
                };
              };
              exports2.setIsLoading = setIsLoading;
            }
          ),
          /***/
          373: (
            /***/
            function(__unused_webpack_module, exports2, __webpack_require__2) {
              var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                if (pack || arguments.length === 2)
                  for (var i = 0, l = from.length, ar; i < l; i++) {
                    if (ar || !(i in from)) {
                      if (!ar)
                        ar = Array.prototype.slice.call(from, 0, i);
                      ar[i] = from[i];
                    }
                  }
                return to.concat(ar || Array.prototype.slice.call(from));
              };
              var __importDefault = this && this.__importDefault || function(mod) {
                return mod && mod.__esModule ? mod : {
                  "default": mod
                };
              };
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              var deepmerge_1 = __importDefault(__webpack_require__2(996));
              var fuse_js_1 = __importDefault(__webpack_require__2(221));
              var choices_1 = __webpack_require__2(282);
              var groups_1 = __webpack_require__2(783);
              var items_1 = __webpack_require__2(464);
              var misc_1 = __webpack_require__2(137);
              var components_1 = __webpack_require__2(520);
              var constants_1 = __webpack_require__2(883);
              var defaults_1 = __webpack_require__2(789);
              var utils_1 = __webpack_require__2(799);
              var reducers_1 = __webpack_require__2(655);
              var store_1 = __importDefault(__webpack_require__2(744));
              var templates_1 = __importDefault(__webpack_require__2(686));
              var IS_IE11 = "-ms-scroll-limit" in document.documentElement.style && "-ms-ime-align" in document.documentElement.style;
              var USER_DEFAULTS = {};
              var Choices2 = (
                /** @class */
                function() {
                  function Choices3(element, userConfig) {
                    if (element === void 0) {
                      element = "[data-choice]";
                    }
                    if (userConfig === void 0) {
                      userConfig = {};
                    }
                    var _this = this;
                    if (userConfig.allowHTML === void 0) {
                      console.warn("Deprecation warning: allowHTML will default to false in a future release. To render HTML in Choices, you will need to set it to true. Setting allowHTML will suppress this message.");
                    }
                    this.config = deepmerge_1.default.all(
                      [defaults_1.DEFAULT_CONFIG, Choices3.defaults.options, userConfig],
                      // When merging array configs, replace with a copy of the userConfig array,
                      // instead of concatenating with the default array
                      {
                        arrayMerge: function(_, sourceArray) {
                          return __spreadArray([], sourceArray, true);
                        }
                      }
                    );
                    var invalidConfigOptions = (0, utils_1.diff)(this.config, defaults_1.DEFAULT_CONFIG);
                    if (invalidConfigOptions.length) {
                      console.warn("Unknown config option(s) passed", invalidConfigOptions.join(", "));
                    }
                    var passedElement = typeof element === "string" ? document.querySelector(element) : element;
                    if (!(passedElement instanceof HTMLInputElement || passedElement instanceof HTMLSelectElement)) {
                      throw TypeError("Expected one of the following types text|select-one|select-multiple");
                    }
                    this._isTextElement = passedElement.type === constants_1.TEXT_TYPE;
                    this._isSelectOneElement = passedElement.type === constants_1.SELECT_ONE_TYPE;
                    this._isSelectMultipleElement = passedElement.type === constants_1.SELECT_MULTIPLE_TYPE;
                    this._isSelectElement = this._isSelectOneElement || this._isSelectMultipleElement;
                    this.config.searchEnabled = this._isSelectMultipleElement || this.config.searchEnabled;
                    if (!["auto", "always"].includes("".concat(this.config.renderSelectedChoices))) {
                      this.config.renderSelectedChoices = "auto";
                    }
                    if (userConfig.addItemFilter && typeof userConfig.addItemFilter !== "function") {
                      var re = userConfig.addItemFilter instanceof RegExp ? userConfig.addItemFilter : new RegExp(userConfig.addItemFilter);
                      this.config.addItemFilter = re.test.bind(re);
                    }
                    if (this._isTextElement) {
                      this.passedElement = new components_1.WrappedInput({
                        element: passedElement,
                        classNames: this.config.classNames,
                        delimiter: this.config.delimiter
                      });
                    } else {
                      this.passedElement = new components_1.WrappedSelect({
                        element: passedElement,
                        classNames: this.config.classNames,
                        template: function(data2) {
                          return _this._templates.option(data2);
                        }
                      });
                    }
                    this.initialised = false;
                    this._store = new store_1.default();
                    this._initialState = reducers_1.defaultState;
                    this._currentState = reducers_1.defaultState;
                    this._prevState = reducers_1.defaultState;
                    this._currentValue = "";
                    this._canSearch = !!this.config.searchEnabled;
                    this._isScrollingOnIe = false;
                    this._highlightPosition = 0;
                    this._wasTap = true;
                    this._placeholderValue = this._generatePlaceholderValue();
                    this._baseId = (0, utils_1.generateId)(this.passedElement.element, "choices-");
                    this._direction = this.passedElement.dir;
                    if (!this._direction) {
                      var elementDirection = window.getComputedStyle(this.passedElement.element).direction;
                      var documentDirection = window.getComputedStyle(document.documentElement).direction;
                      if (elementDirection !== documentDirection) {
                        this._direction = elementDirection;
                      }
                    }
                    this._idNames = {
                      itemChoice: "item-choice"
                    };
                    if (this._isSelectElement) {
                      this._presetGroups = this.passedElement.optionGroups;
                      this._presetOptions = this.passedElement.options;
                    }
                    this._presetChoices = this.config.choices;
                    this._presetItems = this.config.items;
                    if (this.passedElement.value && this._isTextElement) {
                      var splitValues = this.passedElement.value.split(this.config.delimiter);
                      this._presetItems = this._presetItems.concat(splitValues);
                    }
                    if (this.passedElement.options) {
                      this.passedElement.options.forEach(function(option) {
                        _this._presetChoices.push({
                          value: option.value,
                          label: option.innerHTML,
                          selected: !!option.selected,
                          disabled: option.disabled || option.parentNode.disabled,
                          placeholder: option.value === "" || option.hasAttribute("placeholder"),
                          customProperties: (0, utils_1.parseCustomProperties)(option.dataset.customProperties)
                        });
                      });
                    }
                    this._render = this._render.bind(this);
                    this._onFocus = this._onFocus.bind(this);
                    this._onBlur = this._onBlur.bind(this);
                    this._onKeyUp = this._onKeyUp.bind(this);
                    this._onKeyDown = this._onKeyDown.bind(this);
                    this._onClick = this._onClick.bind(this);
                    this._onTouchMove = this._onTouchMove.bind(this);
                    this._onTouchEnd = this._onTouchEnd.bind(this);
                    this._onMouseDown = this._onMouseDown.bind(this);
                    this._onMouseOver = this._onMouseOver.bind(this);
                    this._onFormReset = this._onFormReset.bind(this);
                    this._onSelectKey = this._onSelectKey.bind(this);
                    this._onEnterKey = this._onEnterKey.bind(this);
                    this._onEscapeKey = this._onEscapeKey.bind(this);
                    this._onDirectionKey = this._onDirectionKey.bind(this);
                    this._onDeleteKey = this._onDeleteKey.bind(this);
                    if (this.passedElement.isActive) {
                      if (!this.config.silent) {
                        console.warn("Trying to initialise Choices on element already initialised", {
                          element
                        });
                      }
                      this.initialised = true;
                      return;
                    }
                    this.init();
                  }
                  Object.defineProperty(Choices3, "defaults", {
                    get: function() {
                      return Object.preventExtensions({
                        get options() {
                          return USER_DEFAULTS;
                        },
                        get templates() {
                          return templates_1.default;
                        }
                      });
                    },
                    enumerable: false,
                    configurable: true
                  });
                  Choices3.prototype.init = function() {
                    if (this.initialised) {
                      return;
                    }
                    this._createTemplates();
                    this._createElements();
                    this._createStructure();
                    this._store.subscribe(this._render);
                    this._render();
                    this._addEventListeners();
                    var shouldDisable = !this.config.addItems || this.passedElement.element.hasAttribute("disabled");
                    if (shouldDisable) {
                      this.disable();
                    }
                    this.initialised = true;
                    var callbackOnInit = this.config.callbackOnInit;
                    if (callbackOnInit && typeof callbackOnInit === "function") {
                      callbackOnInit.call(this);
                    }
                  };
                  Choices3.prototype.destroy = function() {
                    if (!this.initialised) {
                      return;
                    }
                    this._removeEventListeners();
                    this.passedElement.reveal();
                    this.containerOuter.unwrap(this.passedElement.element);
                    this.clearStore();
                    if (this._isSelectElement) {
                      this.passedElement.options = this._presetOptions;
                    }
                    this._templates = templates_1.default;
                    this.initialised = false;
                  };
                  Choices3.prototype.enable = function() {
                    if (this.passedElement.isDisabled) {
                      this.passedElement.enable();
                    }
                    if (this.containerOuter.isDisabled) {
                      this._addEventListeners();
                      this.input.enable();
                      this.containerOuter.enable();
                    }
                    return this;
                  };
                  Choices3.prototype.disable = function() {
                    if (!this.passedElement.isDisabled) {
                      this.passedElement.disable();
                    }
                    if (!this.containerOuter.isDisabled) {
                      this._removeEventListeners();
                      this.input.disable();
                      this.containerOuter.disable();
                    }
                    return this;
                  };
                  Choices3.prototype.highlightItem = function(item, runEvent) {
                    if (runEvent === void 0) {
                      runEvent = true;
                    }
                    if (!item || !item.id) {
                      return this;
                    }
                    var id = item.id, _a = item.groupId, groupId = _a === void 0 ? -1 : _a, _b = item.value, value = _b === void 0 ? "" : _b, _c = item.label, label = _c === void 0 ? "" : _c;
                    var group = groupId >= 0 ? this._store.getGroupById(groupId) : null;
                    this._store.dispatch((0, items_1.highlightItem)(id, true));
                    if (runEvent) {
                      this.passedElement.triggerEvent(constants_1.EVENTS.highlightItem, {
                        id,
                        value,
                        label,
                        groupValue: group && group.value ? group.value : null
                      });
                    }
                    return this;
                  };
                  Choices3.prototype.unhighlightItem = function(item) {
                    if (!item || !item.id) {
                      return this;
                    }
                    var id = item.id, _a = item.groupId, groupId = _a === void 0 ? -1 : _a, _b = item.value, value = _b === void 0 ? "" : _b, _c = item.label, label = _c === void 0 ? "" : _c;
                    var group = groupId >= 0 ? this._store.getGroupById(groupId) : null;
                    this._store.dispatch((0, items_1.highlightItem)(id, false));
                    this.passedElement.triggerEvent(constants_1.EVENTS.highlightItem, {
                      id,
                      value,
                      label,
                      groupValue: group && group.value ? group.value : null
                    });
                    return this;
                  };
                  Choices3.prototype.highlightAll = function() {
                    var _this = this;
                    this._store.items.forEach(function(item) {
                      return _this.highlightItem(item);
                    });
                    return this;
                  };
                  Choices3.prototype.unhighlightAll = function() {
                    var _this = this;
                    this._store.items.forEach(function(item) {
                      return _this.unhighlightItem(item);
                    });
                    return this;
                  };
                  Choices3.prototype.removeActiveItemsByValue = function(value) {
                    var _this = this;
                    this._store.activeItems.filter(function(item) {
                      return item.value === value;
                    }).forEach(function(item) {
                      return _this._removeItem(item);
                    });
                    return this;
                  };
                  Choices3.prototype.removeActiveItems = function(excludedId) {
                    var _this = this;
                    this._store.activeItems.filter(function(_a) {
                      var id = _a.id;
                      return id !== excludedId;
                    }).forEach(function(item) {
                      return _this._removeItem(item);
                    });
                    return this;
                  };
                  Choices3.prototype.removeHighlightedItems = function(runEvent) {
                    var _this = this;
                    if (runEvent === void 0) {
                      runEvent = false;
                    }
                    this._store.highlightedActiveItems.forEach(function(item) {
                      _this._removeItem(item);
                      if (runEvent) {
                        _this._triggerChange(item.value);
                      }
                    });
                    return this;
                  };
                  Choices3.prototype.showDropdown = function(preventInputFocus) {
                    var _this = this;
                    if (this.dropdown.isActive) {
                      return this;
                    }
                    requestAnimationFrame(function() {
                      _this.dropdown.show();
                      _this.containerOuter.open(_this.dropdown.distanceFromTopWindow);
                      if (!preventInputFocus && _this._canSearch) {
                        _this.input.focus();
                      }
                      _this.passedElement.triggerEvent(constants_1.EVENTS.showDropdown, {});
                    });
                    return this;
                  };
                  Choices3.prototype.hideDropdown = function(preventInputBlur) {
                    var _this = this;
                    if (!this.dropdown.isActive) {
                      return this;
                    }
                    requestAnimationFrame(function() {
                      _this.dropdown.hide();
                      _this.containerOuter.close();
                      if (!preventInputBlur && _this._canSearch) {
                        _this.input.removeActiveDescendant();
                        _this.input.blur();
                      }
                      _this.passedElement.triggerEvent(constants_1.EVENTS.hideDropdown, {});
                    });
                    return this;
                  };
                  Choices3.prototype.getValue = function(valueOnly) {
                    if (valueOnly === void 0) {
                      valueOnly = false;
                    }
                    var values = this._store.activeItems.reduce(function(selectedItems, item) {
                      var itemValue = valueOnly ? item.value : item;
                      selectedItems.push(itemValue);
                      return selectedItems;
                    }, []);
                    return this._isSelectOneElement ? values[0] : values;
                  };
                  Choices3.prototype.setValue = function(items) {
                    var _this = this;
                    if (!this.initialised) {
                      return this;
                    }
                    items.forEach(function(value) {
                      return _this._setChoiceOrItem(value);
                    });
                    return this;
                  };
                  Choices3.prototype.setChoiceByValue = function(value) {
                    var _this = this;
                    if (!this.initialised || this._isTextElement) {
                      return this;
                    }
                    var choiceValue = Array.isArray(value) ? value : [value];
                    choiceValue.forEach(function(val) {
                      return _this._findAndSelectChoiceByValue(val);
                    });
                    return this;
                  };
                  Choices3.prototype.setChoices = function(choicesArrayOrFetcher, value, label, replaceChoices) {
                    var _this = this;
                    if (choicesArrayOrFetcher === void 0) {
                      choicesArrayOrFetcher = [];
                    }
                    if (value === void 0) {
                      value = "value";
                    }
                    if (label === void 0) {
                      label = "label";
                    }
                    if (replaceChoices === void 0) {
                      replaceChoices = false;
                    }
                    if (!this.initialised) {
                      throw new ReferenceError("setChoices was called on a non-initialized instance of Choices");
                    }
                    if (!this._isSelectElement) {
                      throw new TypeError("setChoices can't be used with INPUT based Choices");
                    }
                    if (typeof value !== "string" || !value) {
                      throw new TypeError("value parameter must be a name of 'value' field in passed objects");
                    }
                    if (replaceChoices) {
                      this.clearChoices();
                    }
                    if (typeof choicesArrayOrFetcher === "function") {
                      var fetcher_1 = choicesArrayOrFetcher(this);
                      if (typeof Promise === "function" && fetcher_1 instanceof Promise) {
                        return new Promise(function(resolve) {
                          return requestAnimationFrame(resolve);
                        }).then(function() {
                          return _this._handleLoadingState(true);
                        }).then(function() {
                          return fetcher_1;
                        }).then(function(data2) {
                          return _this.setChoices(data2, value, label, replaceChoices);
                        }).catch(function(err) {
                          if (!_this.config.silent) {
                            console.error(err);
                          }
                        }).then(function() {
                          return _this._handleLoadingState(false);
                        }).then(function() {
                          return _this;
                        });
                      }
                      if (!Array.isArray(fetcher_1)) {
                        throw new TypeError(".setChoices first argument function must return either array of choices or Promise, got: ".concat(typeof fetcher_1));
                      }
                      return this.setChoices(fetcher_1, value, label, false);
                    }
                    if (!Array.isArray(choicesArrayOrFetcher)) {
                      throw new TypeError(".setChoices must be called either with array of choices with a function resulting into Promise of array of choices");
                    }
                    this.containerOuter.removeLoadingState();
                    this._startLoading();
                    choicesArrayOrFetcher.forEach(function(groupOrChoice) {
                      if (groupOrChoice.choices) {
                        _this._addGroup({
                          id: groupOrChoice.id ? parseInt("".concat(groupOrChoice.id), 10) : null,
                          group: groupOrChoice,
                          valueKey: value,
                          labelKey: label
                        });
                      } else {
                        var choice = groupOrChoice;
                        _this._addChoice({
                          value: choice[value],
                          label: choice[label],
                          isSelected: !!choice.selected,
                          isDisabled: !!choice.disabled,
                          placeholder: !!choice.placeholder,
                          customProperties: choice.customProperties
                        });
                      }
                    });
                    this._stopLoading();
                    return this;
                  };
                  Choices3.prototype.clearChoices = function() {
                    this._store.dispatch((0, choices_1.clearChoices)());
                    return this;
                  };
                  Choices3.prototype.clearStore = function() {
                    this._store.dispatch((0, misc_1.clearAll)());
                    return this;
                  };
                  Choices3.prototype.clearInput = function() {
                    var shouldSetInputWidth = !this._isSelectOneElement;
                    this.input.clear(shouldSetInputWidth);
                    if (!this._isTextElement && this._canSearch) {
                      this._isSearching = false;
                      this._store.dispatch((0, choices_1.activateChoices)(true));
                    }
                    return this;
                  };
                  Choices3.prototype._render = function() {
                    if (this._store.isLoading()) {
                      return;
                    }
                    this._currentState = this._store.state;
                    var stateChanged = this._currentState.choices !== this._prevState.choices || this._currentState.groups !== this._prevState.groups || this._currentState.items !== this._prevState.items;
                    var shouldRenderChoices = this._isSelectElement;
                    var shouldRenderItems = this._currentState.items !== this._prevState.items;
                    if (!stateChanged) {
                      return;
                    }
                    if (shouldRenderChoices) {
                      this._renderChoices();
                    }
                    if (shouldRenderItems) {
                      this._renderItems();
                    }
                    this._prevState = this._currentState;
                  };
                  Choices3.prototype._renderChoices = function() {
                    var _this = this;
                    var _a = this._store, activeGroups = _a.activeGroups, activeChoices = _a.activeChoices;
                    var choiceListFragment = document.createDocumentFragment();
                    this.choiceList.clear();
                    if (this.config.resetScrollPosition) {
                      requestAnimationFrame(function() {
                        return _this.choiceList.scrollToTop();
                      });
                    }
                    if (activeGroups.length >= 1 && !this._isSearching) {
                      var activePlaceholders = activeChoices.filter(function(activeChoice) {
                        return activeChoice.placeholder === true && activeChoice.groupId === -1;
                      });
                      if (activePlaceholders.length >= 1) {
                        choiceListFragment = this._createChoicesFragment(activePlaceholders, choiceListFragment);
                      }
                      choiceListFragment = this._createGroupsFragment(activeGroups, activeChoices, choiceListFragment);
                    } else if (activeChoices.length >= 1) {
                      choiceListFragment = this._createChoicesFragment(activeChoices, choiceListFragment);
                    }
                    if (choiceListFragment.childNodes && choiceListFragment.childNodes.length > 0) {
                      var activeItems = this._store.activeItems;
                      var canAddItem = this._canAddItem(activeItems, this.input.value);
                      if (canAddItem.response) {
                        this.choiceList.append(choiceListFragment);
                        this._highlightChoice();
                      } else {
                        var notice = this._getTemplate("notice", canAddItem.notice);
                        this.choiceList.append(notice);
                      }
                    } else {
                      var dropdownItem = void 0;
                      var notice = void 0;
                      if (this._isSearching) {
                        notice = typeof this.config.noResultsText === "function" ? this.config.noResultsText() : this.config.noResultsText;
                        dropdownItem = this._getTemplate("notice", notice, "no-results");
                      } else {
                        notice = typeof this.config.noChoicesText === "function" ? this.config.noChoicesText() : this.config.noChoicesText;
                        dropdownItem = this._getTemplate("notice", notice, "no-choices");
                      }
                      this.choiceList.append(dropdownItem);
                    }
                  };
                  Choices3.prototype._renderItems = function() {
                    var activeItems = this._store.activeItems || [];
                    this.itemList.clear();
                    var itemListFragment = this._createItemsFragment(activeItems);
                    if (itemListFragment.childNodes) {
                      this.itemList.append(itemListFragment);
                    }
                  };
                  Choices3.prototype._createGroupsFragment = function(groups, choices2, fragment) {
                    var _this = this;
                    if (fragment === void 0) {
                      fragment = document.createDocumentFragment();
                    }
                    var getGroupChoices = function(group) {
                      return choices2.filter(function(choice) {
                        if (_this._isSelectOneElement) {
                          return choice.groupId === group.id;
                        }
                        return choice.groupId === group.id && (_this.config.renderSelectedChoices === "always" || !choice.selected);
                      });
                    };
                    if (this.config.shouldSort) {
                      groups.sort(this.config.sorter);
                    }
                    groups.forEach(function(group) {
                      var groupChoices = getGroupChoices(group);
                      if (groupChoices.length >= 1) {
                        var dropdownGroup = _this._getTemplate("choiceGroup", group);
                        fragment.appendChild(dropdownGroup);
                        _this._createChoicesFragment(groupChoices, fragment, true);
                      }
                    });
                    return fragment;
                  };
                  Choices3.prototype._createChoicesFragment = function(choices2, fragment, withinGroup) {
                    var _this = this;
                    if (fragment === void 0) {
                      fragment = document.createDocumentFragment();
                    }
                    if (withinGroup === void 0) {
                      withinGroup = false;
                    }
                    var _a = this.config, renderSelectedChoices = _a.renderSelectedChoices, searchResultLimit = _a.searchResultLimit, renderChoiceLimit = _a.renderChoiceLimit;
                    var filter2 = this._isSearching ? utils_1.sortByScore : this.config.sorter;
                    var appendChoice = function(choice) {
                      var shouldRender = renderSelectedChoices === "auto" ? _this._isSelectOneElement || !choice.selected : true;
                      if (shouldRender) {
                        var dropdownItem = _this._getTemplate("choice", choice, _this.config.itemSelectText);
                        fragment.appendChild(dropdownItem);
                      }
                    };
                    var rendererableChoices = choices2;
                    if (renderSelectedChoices === "auto" && !this._isSelectOneElement) {
                      rendererableChoices = choices2.filter(function(choice) {
                        return !choice.selected;
                      });
                    }
                    var _b = rendererableChoices.reduce(function(acc, choice) {
                      if (choice.placeholder) {
                        acc.placeholderChoices.push(choice);
                      } else {
                        acc.normalChoices.push(choice);
                      }
                      return acc;
                    }, {
                      placeholderChoices: [],
                      normalChoices: []
                    }), placeholderChoices = _b.placeholderChoices, normalChoices = _b.normalChoices;
                    if (this.config.shouldSort || this._isSearching) {
                      normalChoices.sort(filter2);
                    }
                    var choiceLimit = rendererableChoices.length;
                    var sortedChoices = this._isSelectOneElement ? __spreadArray(__spreadArray([], placeholderChoices, true), normalChoices, true) : normalChoices;
                    if (this._isSearching) {
                      choiceLimit = searchResultLimit;
                    } else if (renderChoiceLimit && renderChoiceLimit > 0 && !withinGroup) {
                      choiceLimit = renderChoiceLimit;
                    }
                    for (var i = 0; i < choiceLimit; i += 1) {
                      if (sortedChoices[i]) {
                        appendChoice(sortedChoices[i]);
                      }
                    }
                    return fragment;
                  };
                  Choices3.prototype._createItemsFragment = function(items, fragment) {
                    var _this = this;
                    if (fragment === void 0) {
                      fragment = document.createDocumentFragment();
                    }
                    var _a = this.config, shouldSortItems = _a.shouldSortItems, sorter = _a.sorter, removeItemButton = _a.removeItemButton;
                    if (shouldSortItems && !this._isSelectOneElement) {
                      items.sort(sorter);
                    }
                    if (this._isTextElement) {
                      this.passedElement.value = items.map(function(_a2) {
                        var value = _a2.value;
                        return value;
                      }).join(this.config.delimiter);
                    } else {
                      this.passedElement.options = items;
                    }
                    var addItemToFragment = function(item) {
                      var listItem = _this._getTemplate("item", item, removeItemButton);
                      fragment.appendChild(listItem);
                    };
                    items.forEach(addItemToFragment);
                    return fragment;
                  };
                  Choices3.prototype._triggerChange = function(value) {
                    if (value === void 0 || value === null) {
                      return;
                    }
                    this.passedElement.triggerEvent(constants_1.EVENTS.change, {
                      value
                    });
                  };
                  Choices3.prototype._selectPlaceholderChoice = function(placeholderChoice) {
                    this._addItem({
                      value: placeholderChoice.value,
                      label: placeholderChoice.label,
                      choiceId: placeholderChoice.id,
                      groupId: placeholderChoice.groupId,
                      placeholder: placeholderChoice.placeholder
                    });
                    this._triggerChange(placeholderChoice.value);
                  };
                  Choices3.prototype._handleButtonAction = function(activeItems, element) {
                    if (!activeItems || !element || !this.config.removeItems || !this.config.removeItemButton) {
                      return;
                    }
                    var itemId = element.parentNode && element.parentNode.dataset.id;
                    var itemToRemove = itemId && activeItems.find(function(item) {
                      return item.id === parseInt(itemId, 10);
                    });
                    if (!itemToRemove) {
                      return;
                    }
                    this._removeItem(itemToRemove);
                    this._triggerChange(itemToRemove.value);
                    if (this._isSelectOneElement && this._store.placeholderChoice) {
                      this._selectPlaceholderChoice(this._store.placeholderChoice);
                    }
                  };
                  Choices3.prototype._handleItemAction = function(activeItems, element, hasShiftKey) {
                    var _this = this;
                    if (hasShiftKey === void 0) {
                      hasShiftKey = false;
                    }
                    if (!activeItems || !element || !this.config.removeItems || this._isSelectOneElement) {
                      return;
                    }
                    var passedId = element.dataset.id;
                    activeItems.forEach(function(item) {
                      if (item.id === parseInt("".concat(passedId), 10) && !item.highlighted) {
                        _this.highlightItem(item);
                      } else if (!hasShiftKey && item.highlighted) {
                        _this.unhighlightItem(item);
                      }
                    });
                    this.input.focus();
                  };
                  Choices3.prototype._handleChoiceAction = function(activeItems, element) {
                    if (!activeItems || !element) {
                      return;
                    }
                    var id = element.dataset.id;
                    var choice = id && this._store.getChoiceById(id);
                    if (!choice) {
                      return;
                    }
                    var passedKeyCode = activeItems[0] && activeItems[0].keyCode ? activeItems[0].keyCode : void 0;
                    var hasActiveDropdown = this.dropdown.isActive;
                    choice.keyCode = passedKeyCode;
                    this.passedElement.triggerEvent(constants_1.EVENTS.choice, {
                      choice
                    });
                    if (!choice.selected && !choice.disabled) {
                      var canAddItem = this._canAddItem(activeItems, choice.value);
                      if (canAddItem.response) {
                        this._addItem({
                          value: choice.value,
                          label: choice.label,
                          choiceId: choice.id,
                          groupId: choice.groupId,
                          customProperties: choice.customProperties,
                          placeholder: choice.placeholder,
                          keyCode: choice.keyCode
                        });
                        this._triggerChange(choice.value);
                      }
                    }
                    this.clearInput();
                    if (hasActiveDropdown && this._isSelectOneElement) {
                      this.hideDropdown(true);
                      this.containerOuter.focus();
                    }
                  };
                  Choices3.prototype._handleBackspace = function(activeItems) {
                    if (!this.config.removeItems || !activeItems) {
                      return;
                    }
                    var lastItem = activeItems[activeItems.length - 1];
                    var hasHighlightedItems = activeItems.some(function(item) {
                      return item.highlighted;
                    });
                    if (this.config.editItems && !hasHighlightedItems && lastItem) {
                      this.input.value = lastItem.value;
                      this.input.setWidth();
                      this._removeItem(lastItem);
                      this._triggerChange(lastItem.value);
                    } else {
                      if (!hasHighlightedItems) {
                        this.highlightItem(lastItem, false);
                      }
                      this.removeHighlightedItems(true);
                    }
                  };
                  Choices3.prototype._startLoading = function() {
                    this._store.dispatch((0, misc_1.setIsLoading)(true));
                  };
                  Choices3.prototype._stopLoading = function() {
                    this._store.dispatch((0, misc_1.setIsLoading)(false));
                  };
                  Choices3.prototype._handleLoadingState = function(setLoading) {
                    if (setLoading === void 0) {
                      setLoading = true;
                    }
                    var placeholderItem = this.itemList.getChild(".".concat(this.config.classNames.placeholder));
                    if (setLoading) {
                      this.disable();
                      this.containerOuter.addLoadingState();
                      if (this._isSelectOneElement) {
                        if (!placeholderItem) {
                          placeholderItem = this._getTemplate("placeholder", this.config.loadingText);
                          if (placeholderItem) {
                            this.itemList.append(placeholderItem);
                          }
                        } else {
                          placeholderItem.innerHTML = this.config.loadingText;
                        }
                      } else {
                        this.input.placeholder = this.config.loadingText;
                      }
                    } else {
                      this.enable();
                      this.containerOuter.removeLoadingState();
                      if (this._isSelectOneElement) {
                        if (placeholderItem) {
                          placeholderItem.innerHTML = this._placeholderValue || "";
                        }
                      } else {
                        this.input.placeholder = this._placeholderValue || "";
                      }
                    }
                  };
                  Choices3.prototype._handleSearch = function(value) {
                    if (!this.input.isFocussed) {
                      return;
                    }
                    var choices2 = this._store.choices;
                    var _a = this.config, searchFloor = _a.searchFloor, searchChoices = _a.searchChoices;
                    var hasUnactiveChoices = choices2.some(function(option) {
                      return !option.active;
                    });
                    if (value !== null && typeof value !== "undefined" && value.length >= searchFloor) {
                      var resultCount = searchChoices ? this._searchChoices(value) : 0;
                      this.passedElement.triggerEvent(constants_1.EVENTS.search, {
                        value,
                        resultCount
                      });
                    } else if (hasUnactiveChoices) {
                      this._isSearching = false;
                      this._store.dispatch((0, choices_1.activateChoices)(true));
                    }
                  };
                  Choices3.prototype._canAddItem = function(activeItems, value) {
                    var canAddItem = true;
                    var notice = typeof this.config.addItemText === "function" ? this.config.addItemText(value) : this.config.addItemText;
                    if (!this._isSelectOneElement) {
                      var isDuplicateValue = (0, utils_1.existsInArray)(activeItems, value);
                      if (this.config.maxItemCount > 0 && this.config.maxItemCount <= activeItems.length) {
                        canAddItem = false;
                        notice = typeof this.config.maxItemText === "function" ? this.config.maxItemText(this.config.maxItemCount) : this.config.maxItemText;
                      }
                      if (!this.config.duplicateItemsAllowed && isDuplicateValue && canAddItem) {
                        canAddItem = false;
                        notice = typeof this.config.uniqueItemText === "function" ? this.config.uniqueItemText(value) : this.config.uniqueItemText;
                      }
                      if (this._isTextElement && this.config.addItems && canAddItem && typeof this.config.addItemFilter === "function" && !this.config.addItemFilter(value)) {
                        canAddItem = false;
                        notice = typeof this.config.customAddItemText === "function" ? this.config.customAddItemText(value) : this.config.customAddItemText;
                      }
                    }
                    return {
                      response: canAddItem,
                      notice
                    };
                  };
                  Choices3.prototype._searchChoices = function(value) {
                    var newValue = typeof value === "string" ? value.trim() : value;
                    var currentValue = typeof this._currentValue === "string" ? this._currentValue.trim() : this._currentValue;
                    if (newValue.length < 1 && newValue === "".concat(currentValue, " ")) {
                      return 0;
                    }
                    var haystack = this._store.searchableChoices;
                    var needle = newValue;
                    var options = Object.assign(this.config.fuseOptions, {
                      keys: __spreadArray([], this.config.searchFields, true),
                      includeMatches: true
                    });
                    var fuse = new fuse_js_1.default(haystack, options);
                    var results = fuse.search(needle);
                    this._currentValue = newValue;
                    this._highlightPosition = 0;
                    this._isSearching = true;
                    this._store.dispatch((0, choices_1.filterChoices)(results));
                    return results.length;
                  };
                  Choices3.prototype._addEventListeners = function() {
                    var documentElement = document.documentElement;
                    documentElement.addEventListener("touchend", this._onTouchEnd, true);
                    this.containerOuter.element.addEventListener("keydown", this._onKeyDown, true);
                    this.containerOuter.element.addEventListener("mousedown", this._onMouseDown, true);
                    documentElement.addEventListener("click", this._onClick, {
                      passive: true
                    });
                    documentElement.addEventListener("touchmove", this._onTouchMove, {
                      passive: true
                    });
                    this.dropdown.element.addEventListener("mouseover", this._onMouseOver, {
                      passive: true
                    });
                    if (this._isSelectOneElement) {
                      this.containerOuter.element.addEventListener("focus", this._onFocus, {
                        passive: true
                      });
                      this.containerOuter.element.addEventListener("blur", this._onBlur, {
                        passive: true
                      });
                    }
                    this.input.element.addEventListener("keyup", this._onKeyUp, {
                      passive: true
                    });
                    this.input.element.addEventListener("focus", this._onFocus, {
                      passive: true
                    });
                    this.input.element.addEventListener("blur", this._onBlur, {
                      passive: true
                    });
                    if (this.input.element.form) {
                      this.input.element.form.addEventListener("reset", this._onFormReset, {
                        passive: true
                      });
                    }
                    this.input.addEventListeners();
                  };
                  Choices3.prototype._removeEventListeners = function() {
                    var documentElement = document.documentElement;
                    documentElement.removeEventListener("touchend", this._onTouchEnd, true);
                    this.containerOuter.element.removeEventListener("keydown", this._onKeyDown, true);
                    this.containerOuter.element.removeEventListener("mousedown", this._onMouseDown, true);
                    documentElement.removeEventListener("click", this._onClick);
                    documentElement.removeEventListener("touchmove", this._onTouchMove);
                    this.dropdown.element.removeEventListener("mouseover", this._onMouseOver);
                    if (this._isSelectOneElement) {
                      this.containerOuter.element.removeEventListener("focus", this._onFocus);
                      this.containerOuter.element.removeEventListener("blur", this._onBlur);
                    }
                    this.input.element.removeEventListener("keyup", this._onKeyUp);
                    this.input.element.removeEventListener("focus", this._onFocus);
                    this.input.element.removeEventListener("blur", this._onBlur);
                    if (this.input.element.form) {
                      this.input.element.form.removeEventListener("reset", this._onFormReset);
                    }
                    this.input.removeEventListeners();
                  };
                  Choices3.prototype._onKeyDown = function(event) {
                    var keyCode = event.keyCode;
                    var activeItems = this._store.activeItems;
                    var hasFocusedInput = this.input.isFocussed;
                    var hasActiveDropdown = this.dropdown.isActive;
                    var hasItems = this.itemList.hasChildren();
                    var keyString = String.fromCharCode(keyCode);
                    var wasPrintableChar = /[^\x00-\x1F]/.test(keyString);
                    var BACK_KEY = constants_1.KEY_CODES.BACK_KEY, DELETE_KEY = constants_1.KEY_CODES.DELETE_KEY, ENTER_KEY = constants_1.KEY_CODES.ENTER_KEY, A_KEY = constants_1.KEY_CODES.A_KEY, ESC_KEY = constants_1.KEY_CODES.ESC_KEY, UP_KEY = constants_1.KEY_CODES.UP_KEY, DOWN_KEY = constants_1.KEY_CODES.DOWN_KEY, PAGE_UP_KEY = constants_1.KEY_CODES.PAGE_UP_KEY, PAGE_DOWN_KEY = constants_1.KEY_CODES.PAGE_DOWN_KEY;
                    if (!this._isTextElement && !hasActiveDropdown && wasPrintableChar) {
                      this.showDropdown();
                      if (!this.input.isFocussed) {
                        this.input.value += event.key.toLowerCase();
                      }
                    }
                    switch (keyCode) {
                      case A_KEY:
                        return this._onSelectKey(event, hasItems);
                      case ENTER_KEY:
                        return this._onEnterKey(event, activeItems, hasActiveDropdown);
                      case ESC_KEY:
                        return this._onEscapeKey(hasActiveDropdown);
                      case UP_KEY:
                      case PAGE_UP_KEY:
                      case DOWN_KEY:
                      case PAGE_DOWN_KEY:
                        return this._onDirectionKey(event, hasActiveDropdown);
                      case DELETE_KEY:
                      case BACK_KEY:
                        return this._onDeleteKey(event, activeItems, hasFocusedInput);
                    }
                  };
                  Choices3.prototype._onKeyUp = function(_a) {
                    var target = _a.target, keyCode = _a.keyCode;
                    var value = this.input.value;
                    var activeItems = this._store.activeItems;
                    var canAddItem = this._canAddItem(activeItems, value);
                    var backKey = constants_1.KEY_CODES.BACK_KEY, deleteKey = constants_1.KEY_CODES.DELETE_KEY;
                    if (this._isTextElement) {
                      var canShowDropdownNotice = canAddItem.notice && value;
                      if (canShowDropdownNotice) {
                        var dropdownItem = this._getTemplate("notice", canAddItem.notice);
                        this.dropdown.element.innerHTML = dropdownItem.outerHTML;
                        this.showDropdown(true);
                      } else {
                        this.hideDropdown(true);
                      }
                    } else {
                      var wasRemovalKeyCode = keyCode === backKey || keyCode === deleteKey;
                      var userHasRemovedValue = wasRemovalKeyCode && target && !target.value;
                      var canReactivateChoices = !this._isTextElement && this._isSearching;
                      var canSearch = this._canSearch && canAddItem.response;
                      if (userHasRemovedValue && canReactivateChoices) {
                        this._isSearching = false;
                        this._store.dispatch((0, choices_1.activateChoices)(true));
                      } else if (canSearch) {
                        this._handleSearch(this.input.rawValue);
                      }
                    }
                    this._canSearch = this.config.searchEnabled;
                  };
                  Choices3.prototype._onSelectKey = function(event, hasItems) {
                    var ctrlKey = event.ctrlKey, metaKey = event.metaKey;
                    var hasCtrlDownKeyPressed = ctrlKey || metaKey;
                    if (hasCtrlDownKeyPressed && hasItems) {
                      this._canSearch = false;
                      var shouldHightlightAll = this.config.removeItems && !this.input.value && this.input.element === document.activeElement;
                      if (shouldHightlightAll) {
                        this.highlightAll();
                      }
                    }
                  };
                  Choices3.prototype._onEnterKey = function(event, activeItems, hasActiveDropdown) {
                    var target = event.target;
                    var enterKey = constants_1.KEY_CODES.ENTER_KEY;
                    var targetWasButton = target && target.hasAttribute("data-button");
                    if (this._isTextElement && target && target.value) {
                      var value = this.input.value;
                      var canAddItem = this._canAddItem(activeItems, value);
                      if (canAddItem.response) {
                        this.hideDropdown(true);
                        this._addItem({
                          value
                        });
                        this._triggerChange(value);
                        this.clearInput();
                      }
                    }
                    if (targetWasButton) {
                      this._handleButtonAction(activeItems, target);
                      event.preventDefault();
                    }
                    if (hasActiveDropdown) {
                      var highlightedChoice = this.dropdown.getChild(".".concat(this.config.classNames.highlightedState));
                      if (highlightedChoice) {
                        if (activeItems[0]) {
                          activeItems[0].keyCode = enterKey;
                        }
                        this._handleChoiceAction(activeItems, highlightedChoice);
                      }
                      event.preventDefault();
                    } else if (this._isSelectOneElement) {
                      this.showDropdown();
                      event.preventDefault();
                    }
                  };
                  Choices3.prototype._onEscapeKey = function(hasActiveDropdown) {
                    if (hasActiveDropdown) {
                      this.hideDropdown(true);
                      this.containerOuter.focus();
                    }
                  };
                  Choices3.prototype._onDirectionKey = function(event, hasActiveDropdown) {
                    var keyCode = event.keyCode, metaKey = event.metaKey;
                    var downKey = constants_1.KEY_CODES.DOWN_KEY, pageUpKey = constants_1.KEY_CODES.PAGE_UP_KEY, pageDownKey = constants_1.KEY_CODES.PAGE_DOWN_KEY;
                    if (hasActiveDropdown || this._isSelectOneElement) {
                      this.showDropdown();
                      this._canSearch = false;
                      var directionInt = keyCode === downKey || keyCode === pageDownKey ? 1 : -1;
                      var skipKey = metaKey || keyCode === pageDownKey || keyCode === pageUpKey;
                      var selectableChoiceIdentifier = "[data-choice-selectable]";
                      var nextEl = void 0;
                      if (skipKey) {
                        if (directionInt > 0) {
                          nextEl = this.dropdown.element.querySelector("".concat(selectableChoiceIdentifier, ":last-of-type"));
                        } else {
                          nextEl = this.dropdown.element.querySelector(selectableChoiceIdentifier);
                        }
                      } else {
                        var currentEl = this.dropdown.element.querySelector(".".concat(this.config.classNames.highlightedState));
                        if (currentEl) {
                          nextEl = (0, utils_1.getAdjacentEl)(currentEl, selectableChoiceIdentifier, directionInt);
                        } else {
                          nextEl = this.dropdown.element.querySelector(selectableChoiceIdentifier);
                        }
                      }
                      if (nextEl) {
                        if (!(0, utils_1.isScrolledIntoView)(nextEl, this.choiceList.element, directionInt)) {
                          this.choiceList.scrollToChildElement(nextEl, directionInt);
                        }
                        this._highlightChoice(nextEl);
                      }
                      event.preventDefault();
                    }
                  };
                  Choices3.prototype._onDeleteKey = function(event, activeItems, hasFocusedInput) {
                    var target = event.target;
                    if (!this._isSelectOneElement && !target.value && hasFocusedInput) {
                      this._handleBackspace(activeItems);
                      event.preventDefault();
                    }
                  };
                  Choices3.prototype._onTouchMove = function() {
                    if (this._wasTap) {
                      this._wasTap = false;
                    }
                  };
                  Choices3.prototype._onTouchEnd = function(event) {
                    var target = (event || event.touches[0]).target;
                    var touchWasWithinContainer = this._wasTap && this.containerOuter.element.contains(target);
                    if (touchWasWithinContainer) {
                      var containerWasExactTarget = target === this.containerOuter.element || target === this.containerInner.element;
                      if (containerWasExactTarget) {
                        if (this._isTextElement) {
                          this.input.focus();
                        } else if (this._isSelectMultipleElement) {
                          this.showDropdown();
                        }
                      }
                      event.stopPropagation();
                    }
                    this._wasTap = true;
                  };
                  Choices3.prototype._onMouseDown = function(event) {
                    var target = event.target;
                    if (!(target instanceof HTMLElement)) {
                      return;
                    }
                    if (IS_IE11 && this.choiceList.element.contains(target)) {
                      var firstChoice = this.choiceList.element.firstElementChild;
                      var isOnScrollbar = this._direction === "ltr" ? event.offsetX >= firstChoice.offsetWidth : event.offsetX < firstChoice.offsetLeft;
                      this._isScrollingOnIe = isOnScrollbar;
                    }
                    if (target === this.input.element) {
                      return;
                    }
                    var item = target.closest("[data-button],[data-item],[data-choice]");
                    if (item instanceof HTMLElement) {
                      var hasShiftKey = event.shiftKey;
                      var activeItems = this._store.activeItems;
                      var dataset = item.dataset;
                      if ("button" in dataset) {
                        this._handleButtonAction(activeItems, item);
                      } else if ("item" in dataset) {
                        this._handleItemAction(activeItems, item, hasShiftKey);
                      } else if ("choice" in dataset) {
                        this._handleChoiceAction(activeItems, item);
                      }
                    }
                    event.preventDefault();
                  };
                  Choices3.prototype._onMouseOver = function(_a) {
                    var target = _a.target;
                    if (target instanceof HTMLElement && "choice" in target.dataset) {
                      this._highlightChoice(target);
                    }
                  };
                  Choices3.prototype._onClick = function(_a) {
                    var target = _a.target;
                    var clickWasWithinContainer = this.containerOuter.element.contains(target);
                    if (clickWasWithinContainer) {
                      if (!this.dropdown.isActive && !this.containerOuter.isDisabled) {
                        if (this._isTextElement) {
                          if (document.activeElement !== this.input.element) {
                            this.input.focus();
                          }
                        } else {
                          this.showDropdown();
                          this.containerOuter.focus();
                        }
                      } else if (this._isSelectOneElement && target !== this.input.element && !this.dropdown.element.contains(target)) {
                        this.hideDropdown();
                      }
                    } else {
                      var hasHighlightedItems = this._store.highlightedActiveItems.length > 0;
                      if (hasHighlightedItems) {
                        this.unhighlightAll();
                      }
                      this.containerOuter.removeFocusState();
                      this.hideDropdown(true);
                    }
                  };
                  Choices3.prototype._onFocus = function(_a) {
                    var _b;
                    var _this = this;
                    var target = _a.target;
                    var focusWasWithinContainer = target && this.containerOuter.element.contains(target);
                    if (!focusWasWithinContainer) {
                      return;
                    }
                    var focusActions = (_b = {}, _b[constants_1.TEXT_TYPE] = function() {
                      if (target === _this.input.element) {
                        _this.containerOuter.addFocusState();
                      }
                    }, _b[constants_1.SELECT_ONE_TYPE] = function() {
                      _this.containerOuter.addFocusState();
                      if (target === _this.input.element) {
                        _this.showDropdown(true);
                      }
                    }, _b[constants_1.SELECT_MULTIPLE_TYPE] = function() {
                      if (target === _this.input.element) {
                        _this.showDropdown(true);
                        _this.containerOuter.addFocusState();
                      }
                    }, _b);
                    focusActions[this.passedElement.element.type]();
                  };
                  Choices3.prototype._onBlur = function(_a) {
                    var _b;
                    var _this = this;
                    var target = _a.target;
                    var blurWasWithinContainer = target && this.containerOuter.element.contains(target);
                    if (blurWasWithinContainer && !this._isScrollingOnIe) {
                      var activeItems = this._store.activeItems;
                      var hasHighlightedItems_1 = activeItems.some(function(item) {
                        return item.highlighted;
                      });
                      var blurActions = (_b = {}, _b[constants_1.TEXT_TYPE] = function() {
                        if (target === _this.input.element) {
                          _this.containerOuter.removeFocusState();
                          if (hasHighlightedItems_1) {
                            _this.unhighlightAll();
                          }
                          _this.hideDropdown(true);
                        }
                      }, _b[constants_1.SELECT_ONE_TYPE] = function() {
                        _this.containerOuter.removeFocusState();
                        if (target === _this.input.element || target === _this.containerOuter.element && !_this._canSearch) {
                          _this.hideDropdown(true);
                        }
                      }, _b[constants_1.SELECT_MULTIPLE_TYPE] = function() {
                        if (target === _this.input.element) {
                          _this.containerOuter.removeFocusState();
                          _this.hideDropdown(true);
                          if (hasHighlightedItems_1) {
                            _this.unhighlightAll();
                          }
                        }
                      }, _b);
                      blurActions[this.passedElement.element.type]();
                    } else {
                      this._isScrollingOnIe = false;
                      this.input.element.focus();
                    }
                  };
                  Choices3.prototype._onFormReset = function() {
                    this._store.dispatch((0, misc_1.resetTo)(this._initialState));
                  };
                  Choices3.prototype._highlightChoice = function(el) {
                    var _this = this;
                    if (el === void 0) {
                      el = null;
                    }
                    var choices2 = Array.from(this.dropdown.element.querySelectorAll("[data-choice-selectable]"));
                    if (!choices2.length) {
                      return;
                    }
                    var passedEl = el;
                    var highlightedChoices = Array.from(this.dropdown.element.querySelectorAll(".".concat(this.config.classNames.highlightedState)));
                    highlightedChoices.forEach(function(choice) {
                      choice.classList.remove(_this.config.classNames.highlightedState);
                      choice.setAttribute("aria-selected", "false");
                    });
                    if (passedEl) {
                      this._highlightPosition = choices2.indexOf(passedEl);
                    } else {
                      if (choices2.length > this._highlightPosition) {
                        passedEl = choices2[this._highlightPosition];
                      } else {
                        passedEl = choices2[choices2.length - 1];
                      }
                      if (!passedEl) {
                        passedEl = choices2[0];
                      }
                    }
                    passedEl.classList.add(this.config.classNames.highlightedState);
                    passedEl.setAttribute("aria-selected", "true");
                    this.passedElement.triggerEvent(constants_1.EVENTS.highlightChoice, {
                      el: passedEl
                    });
                    if (this.dropdown.isActive) {
                      this.input.setActiveDescendant(passedEl.id);
                      this.containerOuter.setActiveDescendant(passedEl.id);
                    }
                  };
                  Choices3.prototype._addItem = function(_a) {
                    var value = _a.value, _b = _a.label, label = _b === void 0 ? null : _b, _c = _a.choiceId, choiceId = _c === void 0 ? -1 : _c, _d = _a.groupId, groupId = _d === void 0 ? -1 : _d, _e = _a.customProperties, customProperties = _e === void 0 ? {} : _e, _f = _a.placeholder, placeholder = _f === void 0 ? false : _f, _g = _a.keyCode, keyCode = _g === void 0 ? -1 : _g;
                    var passedValue = typeof value === "string" ? value.trim() : value;
                    var items = this._store.items;
                    var passedLabel = label || passedValue;
                    var passedOptionId = choiceId || -1;
                    var group = groupId >= 0 ? this._store.getGroupById(groupId) : null;
                    var id = items ? items.length + 1 : 1;
                    if (this.config.prependValue) {
                      passedValue = this.config.prependValue + passedValue.toString();
                    }
                    if (this.config.appendValue) {
                      passedValue += this.config.appendValue.toString();
                    }
                    this._store.dispatch((0, items_1.addItem)({
                      value: passedValue,
                      label: passedLabel,
                      id,
                      choiceId: passedOptionId,
                      groupId,
                      customProperties,
                      placeholder,
                      keyCode
                    }));
                    if (this._isSelectOneElement) {
                      this.removeActiveItems(id);
                    }
                    this.passedElement.triggerEvent(constants_1.EVENTS.addItem, {
                      id,
                      value: passedValue,
                      label: passedLabel,
                      customProperties,
                      groupValue: group && group.value ? group.value : null,
                      keyCode
                    });
                  };
                  Choices3.prototype._removeItem = function(item) {
                    var id = item.id, value = item.value, label = item.label, customProperties = item.customProperties, choiceId = item.choiceId, groupId = item.groupId;
                    var group = groupId && groupId >= 0 ? this._store.getGroupById(groupId) : null;
                    if (!id || !choiceId) {
                      return;
                    }
                    this._store.dispatch((0, items_1.removeItem)(id, choiceId));
                    this.passedElement.triggerEvent(constants_1.EVENTS.removeItem, {
                      id,
                      value,
                      label,
                      customProperties,
                      groupValue: group && group.value ? group.value : null
                    });
                  };
                  Choices3.prototype._addChoice = function(_a) {
                    var value = _a.value, _b = _a.label, label = _b === void 0 ? null : _b, _c = _a.isSelected, isSelected = _c === void 0 ? false : _c, _d = _a.isDisabled, isDisabled = _d === void 0 ? false : _d, _e = _a.groupId, groupId = _e === void 0 ? -1 : _e, _f = _a.customProperties, customProperties = _f === void 0 ? {} : _f, _g = _a.placeholder, placeholder = _g === void 0 ? false : _g, _h = _a.keyCode, keyCode = _h === void 0 ? -1 : _h;
                    if (typeof value === "undefined" || value === null) {
                      return;
                    }
                    var choices2 = this._store.choices;
                    var choiceLabel = label || value;
                    var choiceId = choices2 ? choices2.length + 1 : 1;
                    var choiceElementId = "".concat(this._baseId, "-").concat(this._idNames.itemChoice, "-").concat(choiceId);
                    this._store.dispatch((0, choices_1.addChoice)({
                      id: choiceId,
                      groupId,
                      elementId: choiceElementId,
                      value,
                      label: choiceLabel,
                      disabled: isDisabled,
                      customProperties,
                      placeholder,
                      keyCode
                    }));
                    if (isSelected) {
                      this._addItem({
                        value,
                        label: choiceLabel,
                        choiceId,
                        customProperties,
                        placeholder,
                        keyCode
                      });
                    }
                  };
                  Choices3.prototype._addGroup = function(_a) {
                    var _this = this;
                    var group = _a.group, id = _a.id, _b = _a.valueKey, valueKey = _b === void 0 ? "value" : _b, _c = _a.labelKey, labelKey = _c === void 0 ? "label" : _c;
                    var groupChoices = (0, utils_1.isType)("Object", group) ? group.choices : Array.from(group.getElementsByTagName("OPTION"));
                    var groupId = id || Math.floor((/* @__PURE__ */ new Date()).valueOf() * Math.random());
                    var isDisabled = group.disabled ? group.disabled : false;
                    if (groupChoices) {
                      this._store.dispatch((0, groups_1.addGroup)({
                        value: group.label,
                        id: groupId,
                        active: true,
                        disabled: isDisabled
                      }));
                      var addGroupChoices = function(choice) {
                        var isOptDisabled = choice.disabled || choice.parentNode && choice.parentNode.disabled;
                        _this._addChoice({
                          value: choice[valueKey],
                          label: (0, utils_1.isType)("Object", choice) ? choice[labelKey] : choice.innerHTML,
                          isSelected: choice.selected,
                          isDisabled: isOptDisabled,
                          groupId,
                          customProperties: choice.customProperties,
                          placeholder: choice.placeholder
                        });
                      };
                      groupChoices.forEach(addGroupChoices);
                    } else {
                      this._store.dispatch((0, groups_1.addGroup)({
                        value: group.label,
                        id: group.id,
                        active: false,
                        disabled: group.disabled
                      }));
                    }
                  };
                  Choices3.prototype._getTemplate = function(template) {
                    var _a;
                    var args = [];
                    for (var _i = 1; _i < arguments.length; _i++) {
                      args[_i - 1] = arguments[_i];
                    }
                    return (_a = this._templates[template]).call.apply(_a, __spreadArray([this, this.config], args, false));
                  };
                  Choices3.prototype._createTemplates = function() {
                    var callbackOnCreateTemplates = this.config.callbackOnCreateTemplates;
                    var userTemplates = {};
                    if (callbackOnCreateTemplates && typeof callbackOnCreateTemplates === "function") {
                      userTemplates = callbackOnCreateTemplates.call(this, utils_1.strToEl);
                    }
                    this._templates = (0, deepmerge_1.default)(templates_1.default, userTemplates);
                  };
                  Choices3.prototype._createElements = function() {
                    this.containerOuter = new components_1.Container({
                      element: this._getTemplate("containerOuter", this._direction, this._isSelectElement, this._isSelectOneElement, this.config.searchEnabled, this.passedElement.element.type, this.config.labelId),
                      classNames: this.config.classNames,
                      type: this.passedElement.element.type,
                      position: this.config.position
                    });
                    this.containerInner = new components_1.Container({
                      element: this._getTemplate("containerInner"),
                      classNames: this.config.classNames,
                      type: this.passedElement.element.type,
                      position: this.config.position
                    });
                    this.input = new components_1.Input({
                      element: this._getTemplate("input", this._placeholderValue),
                      classNames: this.config.classNames,
                      type: this.passedElement.element.type,
                      preventPaste: !this.config.paste
                    });
                    this.choiceList = new components_1.List({
                      element: this._getTemplate("choiceList", this._isSelectOneElement)
                    });
                    this.itemList = new components_1.List({
                      element: this._getTemplate("itemList", this._isSelectOneElement)
                    });
                    this.dropdown = new components_1.Dropdown({
                      element: this._getTemplate("dropdown"),
                      classNames: this.config.classNames,
                      type: this.passedElement.element.type
                    });
                  };
                  Choices3.prototype._createStructure = function() {
                    this.passedElement.conceal();
                    this.containerInner.wrap(this.passedElement.element);
                    this.containerOuter.wrap(this.containerInner.element);
                    if (this._isSelectOneElement) {
                      this.input.placeholder = this.config.searchPlaceholderValue || "";
                    } else if (this._placeholderValue) {
                      this.input.placeholder = this._placeholderValue;
                      this.input.setWidth();
                    }
                    this.containerOuter.element.appendChild(this.containerInner.element);
                    this.containerOuter.element.appendChild(this.dropdown.element);
                    this.containerInner.element.appendChild(this.itemList.element);
                    if (!this._isTextElement) {
                      this.dropdown.element.appendChild(this.choiceList.element);
                    }
                    if (!this._isSelectOneElement) {
                      this.containerInner.element.appendChild(this.input.element);
                    } else if (this.config.searchEnabled) {
                      this.dropdown.element.insertBefore(this.input.element, this.dropdown.element.firstChild);
                    }
                    if (this._isSelectElement) {
                      this._highlightPosition = 0;
                      this._isSearching = false;
                      this._startLoading();
                      if (this._presetGroups.length) {
                        this._addPredefinedGroups(this._presetGroups);
                      } else {
                        this._addPredefinedChoices(this._presetChoices);
                      }
                      this._stopLoading();
                    }
                    if (this._isTextElement) {
                      this._addPredefinedItems(this._presetItems);
                    }
                  };
                  Choices3.prototype._addPredefinedGroups = function(groups) {
                    var _this = this;
                    var placeholderChoice = this.passedElement.placeholderOption;
                    if (placeholderChoice && placeholderChoice.parentNode && placeholderChoice.parentNode.tagName === "SELECT") {
                      this._addChoice({
                        value: placeholderChoice.value,
                        label: placeholderChoice.innerHTML,
                        isSelected: placeholderChoice.selected,
                        isDisabled: placeholderChoice.disabled,
                        placeholder: true
                      });
                    }
                    groups.forEach(function(group) {
                      return _this._addGroup({
                        group,
                        id: group.id || null
                      });
                    });
                  };
                  Choices3.prototype._addPredefinedChoices = function(choices2) {
                    var _this = this;
                    if (this.config.shouldSort) {
                      choices2.sort(this.config.sorter);
                    }
                    var hasSelectedChoice = choices2.some(function(choice) {
                      return choice.selected;
                    });
                    var firstEnabledChoiceIndex = choices2.findIndex(function(choice) {
                      return choice.disabled === void 0 || !choice.disabled;
                    });
                    choices2.forEach(function(choice, index2) {
                      var _a = choice.value, value = _a === void 0 ? "" : _a, label = choice.label, customProperties = choice.customProperties, placeholder = choice.placeholder;
                      if (_this._isSelectElement) {
                        if (choice.choices) {
                          _this._addGroup({
                            group: choice,
                            id: choice.id || null
                          });
                        } else {
                          var shouldPreselect = _this._isSelectOneElement && !hasSelectedChoice && index2 === firstEnabledChoiceIndex;
                          var isSelected = shouldPreselect ? true : choice.selected;
                          var isDisabled = choice.disabled;
                          _this._addChoice({
                            value,
                            label,
                            isSelected: !!isSelected,
                            isDisabled: !!isDisabled,
                            placeholder: !!placeholder,
                            customProperties
                          });
                        }
                      } else {
                        _this._addChoice({
                          value,
                          label,
                          isSelected: !!choice.selected,
                          isDisabled: !!choice.disabled,
                          placeholder: !!choice.placeholder,
                          customProperties
                        });
                      }
                    });
                  };
                  Choices3.prototype._addPredefinedItems = function(items) {
                    var _this = this;
                    items.forEach(function(item) {
                      if (typeof item === "object" && item.value) {
                        _this._addItem({
                          value: item.value,
                          label: item.label,
                          choiceId: item.id,
                          customProperties: item.customProperties,
                          placeholder: item.placeholder
                        });
                      }
                      if (typeof item === "string") {
                        _this._addItem({
                          value: item
                        });
                      }
                    });
                  };
                  Choices3.prototype._setChoiceOrItem = function(item) {
                    var _this = this;
                    var itemType = (0, utils_1.getType)(item).toLowerCase();
                    var handleType = {
                      object: function() {
                        if (!item.value) {
                          return;
                        }
                        if (!_this._isTextElement) {
                          _this._addChoice({
                            value: item.value,
                            label: item.label,
                            isSelected: true,
                            isDisabled: false,
                            customProperties: item.customProperties,
                            placeholder: item.placeholder
                          });
                        } else {
                          _this._addItem({
                            value: item.value,
                            label: item.label,
                            choiceId: item.id,
                            customProperties: item.customProperties,
                            placeholder: item.placeholder
                          });
                        }
                      },
                      string: function() {
                        if (!_this._isTextElement) {
                          _this._addChoice({
                            value: item,
                            label: item,
                            isSelected: true,
                            isDisabled: false
                          });
                        } else {
                          _this._addItem({
                            value: item
                          });
                        }
                      }
                    };
                    handleType[itemType]();
                  };
                  Choices3.prototype._findAndSelectChoiceByValue = function(value) {
                    var _this = this;
                    var choices2 = this._store.choices;
                    var foundChoice = choices2.find(function(choice) {
                      return _this.config.valueComparer(choice.value, value);
                    });
                    if (foundChoice && !foundChoice.selected) {
                      this._addItem({
                        value: foundChoice.value,
                        label: foundChoice.label,
                        choiceId: foundChoice.id,
                        groupId: foundChoice.groupId,
                        customProperties: foundChoice.customProperties,
                        placeholder: foundChoice.placeholder,
                        keyCode: foundChoice.keyCode
                      });
                    }
                  };
                  Choices3.prototype._generatePlaceholderValue = function() {
                    if (this._isSelectElement && this.passedElement.placeholderOption) {
                      var placeholderOption = this.passedElement.placeholderOption;
                      return placeholderOption ? placeholderOption.text : null;
                    }
                    var _a = this.config, placeholder = _a.placeholder, placeholderValue = _a.placeholderValue;
                    var dataset = this.passedElement.element.dataset;
                    if (placeholder) {
                      if (placeholderValue) {
                        return placeholderValue;
                      }
                      if (dataset.placeholder) {
                        return dataset.placeholder;
                      }
                    }
                    return null;
                  };
                  return Choices3;
                }()
              );
              exports2["default"] = Choices2;
            }
          ),
          /***/
          613: (
            /***/
            function(__unused_webpack_module, exports2, __webpack_require__2) {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              var utils_1 = __webpack_require__2(799);
              var constants_1 = __webpack_require__2(883);
              var Container = (
                /** @class */
                function() {
                  function Container2(_a) {
                    var element = _a.element, type = _a.type, classNames = _a.classNames, position = _a.position;
                    this.element = element;
                    this.classNames = classNames;
                    this.type = type;
                    this.position = position;
                    this.isOpen = false;
                    this.isFlipped = false;
                    this.isFocussed = false;
                    this.isDisabled = false;
                    this.isLoading = false;
                    this._onFocus = this._onFocus.bind(this);
                    this._onBlur = this._onBlur.bind(this);
                  }
                  Container2.prototype.addEventListeners = function() {
                    this.element.addEventListener("focus", this._onFocus);
                    this.element.addEventListener("blur", this._onBlur);
                  };
                  Container2.prototype.removeEventListeners = function() {
                    this.element.removeEventListener("focus", this._onFocus);
                    this.element.removeEventListener("blur", this._onBlur);
                  };
                  Container2.prototype.shouldFlip = function(dropdownPos) {
                    if (typeof dropdownPos !== "number") {
                      return false;
                    }
                    var shouldFlip = false;
                    if (this.position === "auto") {
                      shouldFlip = !window.matchMedia("(min-height: ".concat(dropdownPos + 1, "px)")).matches;
                    } else if (this.position === "top") {
                      shouldFlip = true;
                    }
                    return shouldFlip;
                  };
                  Container2.prototype.setActiveDescendant = function(activeDescendantID) {
                    this.element.setAttribute("aria-activedescendant", activeDescendantID);
                  };
                  Container2.prototype.removeActiveDescendant = function() {
                    this.element.removeAttribute("aria-activedescendant");
                  };
                  Container2.prototype.open = function(dropdownPos) {
                    this.element.classList.add(this.classNames.openState);
                    this.element.setAttribute("aria-expanded", "true");
                    this.isOpen = true;
                    if (this.shouldFlip(dropdownPos)) {
                      this.element.classList.add(this.classNames.flippedState);
                      this.isFlipped = true;
                    }
                  };
                  Container2.prototype.close = function() {
                    this.element.classList.remove(this.classNames.openState);
                    this.element.setAttribute("aria-expanded", "false");
                    this.removeActiveDescendant();
                    this.isOpen = false;
                    if (this.isFlipped) {
                      this.element.classList.remove(this.classNames.flippedState);
                      this.isFlipped = false;
                    }
                  };
                  Container2.prototype.focus = function() {
                    if (!this.isFocussed) {
                      this.element.focus();
                    }
                  };
                  Container2.prototype.addFocusState = function() {
                    this.element.classList.add(this.classNames.focusState);
                  };
                  Container2.prototype.removeFocusState = function() {
                    this.element.classList.remove(this.classNames.focusState);
                  };
                  Container2.prototype.enable = function() {
                    this.element.classList.remove(this.classNames.disabledState);
                    this.element.removeAttribute("aria-disabled");
                    if (this.type === constants_1.SELECT_ONE_TYPE) {
                      this.element.setAttribute("tabindex", "0");
                    }
                    this.isDisabled = false;
                  };
                  Container2.prototype.disable = function() {
                    this.element.classList.add(this.classNames.disabledState);
                    this.element.setAttribute("aria-disabled", "true");
                    if (this.type === constants_1.SELECT_ONE_TYPE) {
                      this.element.setAttribute("tabindex", "-1");
                    }
                    this.isDisabled = true;
                  };
                  Container2.prototype.wrap = function(element) {
                    (0, utils_1.wrap)(element, this.element);
                  };
                  Container2.prototype.unwrap = function(element) {
                    if (this.element.parentNode) {
                      this.element.parentNode.insertBefore(element, this.element);
                      this.element.parentNode.removeChild(this.element);
                    }
                  };
                  Container2.prototype.addLoadingState = function() {
                    this.element.classList.add(this.classNames.loadingState);
                    this.element.setAttribute("aria-busy", "true");
                    this.isLoading = true;
                  };
                  Container2.prototype.removeLoadingState = function() {
                    this.element.classList.remove(this.classNames.loadingState);
                    this.element.removeAttribute("aria-busy");
                    this.isLoading = false;
                  };
                  Container2.prototype._onFocus = function() {
                    this.isFocussed = true;
                  };
                  Container2.prototype._onBlur = function() {
                    this.isFocussed = false;
                  };
                  return Container2;
                }()
              );
              exports2["default"] = Container;
            }
          ),
          /***/
          217: (
            /***/
            function(__unused_webpack_module, exports2) {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              var Dropdown = (
                /** @class */
                function() {
                  function Dropdown2(_a) {
                    var element = _a.element, type = _a.type, classNames = _a.classNames;
                    this.element = element;
                    this.classNames = classNames;
                    this.type = type;
                    this.isActive = false;
                  }
                  Object.defineProperty(Dropdown2.prototype, "distanceFromTopWindow", {
                    /**
                     * Bottom position of dropdown in viewport coordinates
                     */
                    get: function() {
                      return this.element.getBoundingClientRect().bottom;
                    },
                    enumerable: false,
                    configurable: true
                  });
                  Dropdown2.prototype.getChild = function(selector) {
                    return this.element.querySelector(selector);
                  };
                  Dropdown2.prototype.show = function() {
                    this.element.classList.add(this.classNames.activeState);
                    this.element.setAttribute("aria-expanded", "true");
                    this.isActive = true;
                    return this;
                  };
                  Dropdown2.prototype.hide = function() {
                    this.element.classList.remove(this.classNames.activeState);
                    this.element.setAttribute("aria-expanded", "false");
                    this.isActive = false;
                    return this;
                  };
                  return Dropdown2;
                }()
              );
              exports2["default"] = Dropdown;
            }
          ),
          /***/
          520: (
            /***/
            function(__unused_webpack_module, exports2, __webpack_require__2) {
              var __importDefault = this && this.__importDefault || function(mod) {
                return mod && mod.__esModule ? mod : {
                  "default": mod
                };
              };
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.WrappedSelect = exports2.WrappedInput = exports2.List = exports2.Input = exports2.Container = exports2.Dropdown = void 0;
              var dropdown_1 = __importDefault(__webpack_require__2(217));
              exports2.Dropdown = dropdown_1.default;
              var container_1 = __importDefault(__webpack_require__2(613));
              exports2.Container = container_1.default;
              var input_1 = __importDefault(__webpack_require__2(11));
              exports2.Input = input_1.default;
              var list_1 = __importDefault(__webpack_require__2(624));
              exports2.List = list_1.default;
              var wrapped_input_1 = __importDefault(__webpack_require__2(541));
              exports2.WrappedInput = wrapped_input_1.default;
              var wrapped_select_1 = __importDefault(__webpack_require__2(982));
              exports2.WrappedSelect = wrapped_select_1.default;
            }
          ),
          /***/
          11: (
            /***/
            function(__unused_webpack_module, exports2, __webpack_require__2) {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              var utils_1 = __webpack_require__2(799);
              var constants_1 = __webpack_require__2(883);
              var Input = (
                /** @class */
                function() {
                  function Input2(_a) {
                    var element = _a.element, type = _a.type, classNames = _a.classNames, preventPaste = _a.preventPaste;
                    this.element = element;
                    this.type = type;
                    this.classNames = classNames;
                    this.preventPaste = preventPaste;
                    this.isFocussed = this.element.isEqualNode(document.activeElement);
                    this.isDisabled = element.disabled;
                    this._onPaste = this._onPaste.bind(this);
                    this._onInput = this._onInput.bind(this);
                    this._onFocus = this._onFocus.bind(this);
                    this._onBlur = this._onBlur.bind(this);
                  }
                  Object.defineProperty(Input2.prototype, "placeholder", {
                    set: function(placeholder) {
                      this.element.placeholder = placeholder;
                    },
                    enumerable: false,
                    configurable: true
                  });
                  Object.defineProperty(Input2.prototype, "value", {
                    get: function() {
                      return (0, utils_1.sanitise)(this.element.value);
                    },
                    set: function(value) {
                      this.element.value = value;
                    },
                    enumerable: false,
                    configurable: true
                  });
                  Object.defineProperty(Input2.prototype, "rawValue", {
                    get: function() {
                      return this.element.value;
                    },
                    enumerable: false,
                    configurable: true
                  });
                  Input2.prototype.addEventListeners = function() {
                    this.element.addEventListener("paste", this._onPaste);
                    this.element.addEventListener("input", this._onInput, {
                      passive: true
                    });
                    this.element.addEventListener("focus", this._onFocus, {
                      passive: true
                    });
                    this.element.addEventListener("blur", this._onBlur, {
                      passive: true
                    });
                  };
                  Input2.prototype.removeEventListeners = function() {
                    this.element.removeEventListener("input", this._onInput);
                    this.element.removeEventListener("paste", this._onPaste);
                    this.element.removeEventListener("focus", this._onFocus);
                    this.element.removeEventListener("blur", this._onBlur);
                  };
                  Input2.prototype.enable = function() {
                    this.element.removeAttribute("disabled");
                    this.isDisabled = false;
                  };
                  Input2.prototype.disable = function() {
                    this.element.setAttribute("disabled", "");
                    this.isDisabled = true;
                  };
                  Input2.prototype.focus = function() {
                    if (!this.isFocussed) {
                      this.element.focus();
                    }
                  };
                  Input2.prototype.blur = function() {
                    if (this.isFocussed) {
                      this.element.blur();
                    }
                  };
                  Input2.prototype.clear = function(setWidth) {
                    if (setWidth === void 0) {
                      setWidth = true;
                    }
                    if (this.element.value) {
                      this.element.value = "";
                    }
                    if (setWidth) {
                      this.setWidth();
                    }
                    return this;
                  };
                  Input2.prototype.setWidth = function() {
                    var _a = this.element, style = _a.style, value = _a.value, placeholder = _a.placeholder;
                    style.minWidth = "".concat(placeholder.length + 1, "ch");
                    style.width = "".concat(value.length + 1, "ch");
                  };
                  Input2.prototype.setActiveDescendant = function(activeDescendantID) {
                    this.element.setAttribute("aria-activedescendant", activeDescendantID);
                  };
                  Input2.prototype.removeActiveDescendant = function() {
                    this.element.removeAttribute("aria-activedescendant");
                  };
                  Input2.prototype._onInput = function() {
                    if (this.type !== constants_1.SELECT_ONE_TYPE) {
                      this.setWidth();
                    }
                  };
                  Input2.prototype._onPaste = function(event) {
                    if (this.preventPaste) {
                      event.preventDefault();
                    }
                  };
                  Input2.prototype._onFocus = function() {
                    this.isFocussed = true;
                  };
                  Input2.prototype._onBlur = function() {
                    this.isFocussed = false;
                  };
                  return Input2;
                }()
              );
              exports2["default"] = Input;
            }
          ),
          /***/
          624: (
            /***/
            function(__unused_webpack_module, exports2, __webpack_require__2) {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              var constants_1 = __webpack_require__2(883);
              var List = (
                /** @class */
                function() {
                  function List2(_a) {
                    var element = _a.element;
                    this.element = element;
                    this.scrollPos = this.element.scrollTop;
                    this.height = this.element.offsetHeight;
                  }
                  List2.prototype.clear = function() {
                    this.element.innerHTML = "";
                  };
                  List2.prototype.append = function(node) {
                    this.element.appendChild(node);
                  };
                  List2.prototype.getChild = function(selector) {
                    return this.element.querySelector(selector);
                  };
                  List2.prototype.hasChildren = function() {
                    return this.element.hasChildNodes();
                  };
                  List2.prototype.scrollToTop = function() {
                    this.element.scrollTop = 0;
                  };
                  List2.prototype.scrollToChildElement = function(element, direction) {
                    var _this = this;
                    if (!element) {
                      return;
                    }
                    var listHeight = this.element.offsetHeight;
                    var listScrollPosition = this.element.scrollTop + listHeight;
                    var elementHeight = element.offsetHeight;
                    var elementPos = element.offsetTop + elementHeight;
                    var destination = direction > 0 ? this.element.scrollTop + elementPos - listScrollPosition : element.offsetTop;
                    requestAnimationFrame(function() {
                      _this._animateScroll(destination, direction);
                    });
                  };
                  List2.prototype._scrollDown = function(scrollPos, strength, destination) {
                    var easing = (destination - scrollPos) / strength;
                    var distance = easing > 1 ? easing : 1;
                    this.element.scrollTop = scrollPos + distance;
                  };
                  List2.prototype._scrollUp = function(scrollPos, strength, destination) {
                    var easing = (scrollPos - destination) / strength;
                    var distance = easing > 1 ? easing : 1;
                    this.element.scrollTop = scrollPos - distance;
                  };
                  List2.prototype._animateScroll = function(destination, direction) {
                    var _this = this;
                    var strength = constants_1.SCROLLING_SPEED;
                    var choiceListScrollTop = this.element.scrollTop;
                    var continueAnimation = false;
                    if (direction > 0) {
                      this._scrollDown(choiceListScrollTop, strength, destination);
                      if (choiceListScrollTop < destination) {
                        continueAnimation = true;
                      }
                    } else {
                      this._scrollUp(choiceListScrollTop, strength, destination);
                      if (choiceListScrollTop > destination) {
                        continueAnimation = true;
                      }
                    }
                    if (continueAnimation) {
                      requestAnimationFrame(function() {
                        _this._animateScroll(destination, direction);
                      });
                    }
                  };
                  return List2;
                }()
              );
              exports2["default"] = List;
            }
          ),
          /***/
          730: (
            /***/
            function(__unused_webpack_module, exports2, __webpack_require__2) {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              var utils_1 = __webpack_require__2(799);
              var WrappedElement = (
                /** @class */
                function() {
                  function WrappedElement2(_a) {
                    var element = _a.element, classNames = _a.classNames;
                    this.element = element;
                    this.classNames = classNames;
                    if (!(element instanceof HTMLInputElement) && !(element instanceof HTMLSelectElement)) {
                      throw new TypeError("Invalid element passed");
                    }
                    this.isDisabled = false;
                  }
                  Object.defineProperty(WrappedElement2.prototype, "isActive", {
                    get: function() {
                      return this.element.dataset.choice === "active";
                    },
                    enumerable: false,
                    configurable: true
                  });
                  Object.defineProperty(WrappedElement2.prototype, "dir", {
                    get: function() {
                      return this.element.dir;
                    },
                    enumerable: false,
                    configurable: true
                  });
                  Object.defineProperty(WrappedElement2.prototype, "value", {
                    get: function() {
                      return this.element.value;
                    },
                    set: function(value) {
                      this.element.value = value;
                    },
                    enumerable: false,
                    configurable: true
                  });
                  WrappedElement2.prototype.conceal = function() {
                    this.element.classList.add(this.classNames.input);
                    this.element.hidden = true;
                    this.element.tabIndex = -1;
                    var origStyle = this.element.getAttribute("style");
                    if (origStyle) {
                      this.element.setAttribute("data-choice-orig-style", origStyle);
                    }
                    this.element.setAttribute("data-choice", "active");
                  };
                  WrappedElement2.prototype.reveal = function() {
                    this.element.classList.remove(this.classNames.input);
                    this.element.hidden = false;
                    this.element.removeAttribute("tabindex");
                    var origStyle = this.element.getAttribute("data-choice-orig-style");
                    if (origStyle) {
                      this.element.removeAttribute("data-choice-orig-style");
                      this.element.setAttribute("style", origStyle);
                    } else {
                      this.element.removeAttribute("style");
                    }
                    this.element.removeAttribute("data-choice");
                    this.element.value = this.element.value;
                  };
                  WrappedElement2.prototype.enable = function() {
                    this.element.removeAttribute("disabled");
                    this.element.disabled = false;
                    this.isDisabled = false;
                  };
                  WrappedElement2.prototype.disable = function() {
                    this.element.setAttribute("disabled", "");
                    this.element.disabled = true;
                    this.isDisabled = true;
                  };
                  WrappedElement2.prototype.triggerEvent = function(eventType, data2) {
                    (0, utils_1.dispatchEvent)(this.element, eventType, data2);
                  };
                  return WrappedElement2;
                }()
              );
              exports2["default"] = WrappedElement;
            }
          ),
          /***/
          541: (
            /***/
            function(__unused_webpack_module, exports2, __webpack_require__2) {
              var __extends = this && this.__extends || function() {
                var extendStatics = function(d, b) {
                  extendStatics = Object.setPrototypeOf || {
                    __proto__: []
                  } instanceof Array && function(d2, b2) {
                    d2.__proto__ = b2;
                  } || function(d2, b2) {
                    for (var p in b2)
                      if (Object.prototype.hasOwnProperty.call(b2, p))
                        d2[p] = b2[p];
                  };
                  return extendStatics(d, b);
                };
                return function(d, b) {
                  if (typeof b !== "function" && b !== null)
                    throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                  extendStatics(d, b);
                  function __() {
                    this.constructor = d;
                  }
                  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
              }();
              var __importDefault = this && this.__importDefault || function(mod) {
                return mod && mod.__esModule ? mod : {
                  "default": mod
                };
              };
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              var wrapped_element_1 = __importDefault(__webpack_require__2(730));
              var WrappedInput = (
                /** @class */
                function(_super) {
                  __extends(WrappedInput2, _super);
                  function WrappedInput2(_a) {
                    var element = _a.element, classNames = _a.classNames, delimiter = _a.delimiter;
                    var _this = _super.call(this, {
                      element,
                      classNames
                    }) || this;
                    _this.delimiter = delimiter;
                    return _this;
                  }
                  Object.defineProperty(WrappedInput2.prototype, "value", {
                    get: function() {
                      return this.element.value;
                    },
                    set: function(value) {
                      this.element.setAttribute("value", value);
                      this.element.value = value;
                    },
                    enumerable: false,
                    configurable: true
                  });
                  return WrappedInput2;
                }(wrapped_element_1.default)
              );
              exports2["default"] = WrappedInput;
            }
          ),
          /***/
          982: (
            /***/
            function(__unused_webpack_module, exports2, __webpack_require__2) {
              var __extends = this && this.__extends || function() {
                var extendStatics = function(d, b) {
                  extendStatics = Object.setPrototypeOf || {
                    __proto__: []
                  } instanceof Array && function(d2, b2) {
                    d2.__proto__ = b2;
                  } || function(d2, b2) {
                    for (var p in b2)
                      if (Object.prototype.hasOwnProperty.call(b2, p))
                        d2[p] = b2[p];
                  };
                  return extendStatics(d, b);
                };
                return function(d, b) {
                  if (typeof b !== "function" && b !== null)
                    throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                  extendStatics(d, b);
                  function __() {
                    this.constructor = d;
                  }
                  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
              }();
              var __importDefault = this && this.__importDefault || function(mod) {
                return mod && mod.__esModule ? mod : {
                  "default": mod
                };
              };
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              var wrapped_element_1 = __importDefault(__webpack_require__2(730));
              var WrappedSelect = (
                /** @class */
                function(_super) {
                  __extends(WrappedSelect2, _super);
                  function WrappedSelect2(_a) {
                    var element = _a.element, classNames = _a.classNames, template = _a.template;
                    var _this = _super.call(this, {
                      element,
                      classNames
                    }) || this;
                    _this.template = template;
                    return _this;
                  }
                  Object.defineProperty(WrappedSelect2.prototype, "placeholderOption", {
                    get: function() {
                      return this.element.querySelector('option[value=""]') || // Backward compatibility layer for the non-standard placeholder attribute supported in older versions.
                      this.element.querySelector("option[placeholder]");
                    },
                    enumerable: false,
                    configurable: true
                  });
                  Object.defineProperty(WrappedSelect2.prototype, "optionGroups", {
                    get: function() {
                      return Array.from(this.element.getElementsByTagName("OPTGROUP"));
                    },
                    enumerable: false,
                    configurable: true
                  });
                  Object.defineProperty(WrappedSelect2.prototype, "options", {
                    get: function() {
                      return Array.from(this.element.options);
                    },
                    set: function(options) {
                      var _this = this;
                      var fragment = document.createDocumentFragment();
                      var addOptionToFragment = function(data2) {
                        var option = _this.template(data2);
                        fragment.appendChild(option);
                      };
                      options.forEach(function(optionData) {
                        return addOptionToFragment(optionData);
                      });
                      this.appendDocFragment(fragment);
                    },
                    enumerable: false,
                    configurable: true
                  });
                  WrappedSelect2.prototype.appendDocFragment = function(fragment) {
                    this.element.innerHTML = "";
                    this.element.appendChild(fragment);
                  };
                  return WrappedSelect2;
                }(wrapped_element_1.default)
              );
              exports2["default"] = WrappedSelect;
            }
          ),
          /***/
          883: (
            /***/
            function(__unused_webpack_module, exports2) {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.SCROLLING_SPEED = exports2.SELECT_MULTIPLE_TYPE = exports2.SELECT_ONE_TYPE = exports2.TEXT_TYPE = exports2.KEY_CODES = exports2.ACTION_TYPES = exports2.EVENTS = void 0;
              exports2.EVENTS = {
                showDropdown: "showDropdown",
                hideDropdown: "hideDropdown",
                change: "change",
                choice: "choice",
                search: "search",
                addItem: "addItem",
                removeItem: "removeItem",
                highlightItem: "highlightItem",
                highlightChoice: "highlightChoice",
                unhighlightItem: "unhighlightItem"
              };
              exports2.ACTION_TYPES = {
                ADD_CHOICE: "ADD_CHOICE",
                FILTER_CHOICES: "FILTER_CHOICES",
                ACTIVATE_CHOICES: "ACTIVATE_CHOICES",
                CLEAR_CHOICES: "CLEAR_CHOICES",
                ADD_GROUP: "ADD_GROUP",
                ADD_ITEM: "ADD_ITEM",
                REMOVE_ITEM: "REMOVE_ITEM",
                HIGHLIGHT_ITEM: "HIGHLIGHT_ITEM",
                CLEAR_ALL: "CLEAR_ALL",
                RESET_TO: "RESET_TO",
                SET_IS_LOADING: "SET_IS_LOADING"
              };
              exports2.KEY_CODES = {
                BACK_KEY: 46,
                DELETE_KEY: 8,
                ENTER_KEY: 13,
                A_KEY: 65,
                ESC_KEY: 27,
                UP_KEY: 38,
                DOWN_KEY: 40,
                PAGE_UP_KEY: 33,
                PAGE_DOWN_KEY: 34
              };
              exports2.TEXT_TYPE = "text";
              exports2.SELECT_ONE_TYPE = "select-one";
              exports2.SELECT_MULTIPLE_TYPE = "select-multiple";
              exports2.SCROLLING_SPEED = 4;
            }
          ),
          /***/
          789: (
            /***/
            function(__unused_webpack_module, exports2, __webpack_require__2) {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.DEFAULT_CONFIG = exports2.DEFAULT_CLASSNAMES = void 0;
              var utils_1 = __webpack_require__2(799);
              exports2.DEFAULT_CLASSNAMES = {
                containerOuter: "choices",
                containerInner: "choices__inner",
                input: "choices__input",
                inputCloned: "choices__input--cloned",
                list: "choices__list",
                listItems: "choices__list--multiple",
                listSingle: "choices__list--single",
                listDropdown: "choices__list--dropdown",
                item: "choices__item",
                itemSelectable: "choices__item--selectable",
                itemDisabled: "choices__item--disabled",
                itemChoice: "choices__item--choice",
                placeholder: "choices__placeholder",
                group: "choices__group",
                groupHeading: "choices__heading",
                button: "choices__button",
                activeState: "is-active",
                focusState: "is-focused",
                openState: "is-open",
                disabledState: "is-disabled",
                highlightedState: "is-highlighted",
                selectedState: "is-selected",
                flippedState: "is-flipped",
                loadingState: "is-loading",
                noResults: "has-no-results",
                noChoices: "has-no-choices"
              };
              exports2.DEFAULT_CONFIG = {
                items: [],
                choices: [],
                silent: false,
                renderChoiceLimit: -1,
                maxItemCount: -1,
                addItems: true,
                addItemFilter: null,
                removeItems: true,
                removeItemButton: false,
                editItems: false,
                allowHTML: true,
                duplicateItemsAllowed: true,
                delimiter: ",",
                paste: true,
                searchEnabled: true,
                searchChoices: true,
                searchFloor: 1,
                searchResultLimit: 4,
                searchFields: ["label", "value"],
                position: "auto",
                resetScrollPosition: true,
                shouldSort: true,
                shouldSortItems: false,
                sorter: utils_1.sortByAlpha,
                placeholder: true,
                placeholderValue: null,
                searchPlaceholderValue: null,
                prependValue: null,
                appendValue: null,
                renderSelectedChoices: "auto",
                loadingText: "Loading...",
                noResultsText: "No results found",
                noChoicesText: "No choices to choose from",
                itemSelectText: "Press to select",
                uniqueItemText: "Only unique values can be added",
                customAddItemText: "Only values matching specific conditions can be added",
                addItemText: function(value) {
                  return 'Press Enter to add <b>"'.concat((0, utils_1.sanitise)(value), '"</b>');
                },
                maxItemText: function(maxItemCount) {
                  return "Only ".concat(maxItemCount, " values can be added");
                },
                valueComparer: function(value1, value2) {
                  return value1 === value2;
                },
                fuseOptions: {
                  includeScore: true
                },
                labelId: "",
                callbackOnInit: null,
                callbackOnCreateTemplates: null,
                classNames: exports2.DEFAULT_CLASSNAMES
              };
            }
          ),
          /***/
          18: (
            /***/
            function(__unused_webpack_module, exports2) {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
            }
          ),
          /***/
          978: (
            /***/
            function(__unused_webpack_module, exports2) {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
            }
          ),
          /***/
          948: (
            /***/
            function(__unused_webpack_module, exports2) {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
            }
          ),
          /***/
          359: (
            /***/
            function(__unused_webpack_module, exports2) {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
            }
          ),
          /***/
          285: (
            /***/
            function(__unused_webpack_module, exports2) {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
            }
          ),
          /***/
          533: (
            /***/
            function(__unused_webpack_module, exports2) {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
            }
          ),
          /***/
          187: (
            /***/
            function(__unused_webpack_module, exports2, __webpack_require__2) {
              var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
                if (k2 === void 0)
                  k2 = k;
                var desc = Object.getOwnPropertyDescriptor(m, k);
                if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                  desc = {
                    enumerable: true,
                    get: function() {
                      return m[k];
                    }
                  };
                }
                Object.defineProperty(o, k2, desc);
              } : function(o, m, k, k2) {
                if (k2 === void 0)
                  k2 = k;
                o[k2] = m[k];
              });
              var __exportStar = this && this.__exportStar || function(m, exports3) {
                for (var p in m)
                  if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p))
                    __createBinding(exports3, m, p);
              };
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              __exportStar(__webpack_require__2(18), exports2);
              __exportStar(__webpack_require__2(978), exports2);
              __exportStar(__webpack_require__2(948), exports2);
              __exportStar(__webpack_require__2(359), exports2);
              __exportStar(__webpack_require__2(285), exports2);
              __exportStar(__webpack_require__2(533), exports2);
              __exportStar(__webpack_require__2(287), exports2);
              __exportStar(__webpack_require__2(132), exports2);
              __exportStar(__webpack_require__2(837), exports2);
              __exportStar(__webpack_require__2(598), exports2);
              __exportStar(__webpack_require__2(369), exports2);
              __exportStar(__webpack_require__2(37), exports2);
              __exportStar(__webpack_require__2(47), exports2);
              __exportStar(__webpack_require__2(923), exports2);
              __exportStar(__webpack_require__2(876), exports2);
            }
          ),
          /***/
          287: (
            /***/
            function(__unused_webpack_module, exports2) {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
            }
          ),
          /***/
          132: (
            /***/
            function(__unused_webpack_module, exports2) {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
            }
          ),
          /***/
          837: (
            /***/
            function(__unused_webpack_module, exports2) {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
            }
          ),
          /***/
          598: (
            /***/
            function(__unused_webpack_module, exports2) {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
            }
          ),
          /***/
          37: (
            /***/
            function(__unused_webpack_module, exports2) {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
            }
          ),
          /***/
          369: (
            /***/
            function(__unused_webpack_module, exports2) {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
            }
          ),
          /***/
          47: (
            /***/
            function(__unused_webpack_module, exports2) {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
            }
          ),
          /***/
          923: (
            /***/
            function(__unused_webpack_module, exports2) {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
            }
          ),
          /***/
          876: (
            /***/
            function(__unused_webpack_module, exports2) {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
            }
          ),
          /***/
          799: (
            /***/
            function(__unused_webpack_module, exports2) {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.parseCustomProperties = exports2.diff = exports2.cloneObject = exports2.existsInArray = exports2.dispatchEvent = exports2.sortByScore = exports2.sortByAlpha = exports2.strToEl = exports2.sanitise = exports2.isScrolledIntoView = exports2.getAdjacentEl = exports2.wrap = exports2.isType = exports2.getType = exports2.generateId = exports2.generateChars = exports2.getRandomNumber = void 0;
              var getRandomNumber = function(min, max) {
                return Math.floor(Math.random() * (max - min) + min);
              };
              exports2.getRandomNumber = getRandomNumber;
              var generateChars = function(length) {
                return Array.from({
                  length
                }, function() {
                  return (0, exports2.getRandomNumber)(0, 36).toString(36);
                }).join("");
              };
              exports2.generateChars = generateChars;
              var generateId = function(element, prefix2) {
                var id = element.id || element.name && "".concat(element.name, "-").concat((0, exports2.generateChars)(2)) || (0, exports2.generateChars)(4);
                id = id.replace(/(:|\.|\[|\]|,)/g, "");
                id = "".concat(prefix2, "-").concat(id);
                return id;
              };
              exports2.generateId = generateId;
              var getType = function(obj) {
                return Object.prototype.toString.call(obj).slice(8, -1);
              };
              exports2.getType = getType;
              var isType = function(type, obj) {
                return obj !== void 0 && obj !== null && (0, exports2.getType)(obj) === type;
              };
              exports2.isType = isType;
              var wrap = function(element, wrapper) {
                if (wrapper === void 0) {
                  wrapper = document.createElement("div");
                }
                if (element.parentNode) {
                  if (element.nextSibling) {
                    element.parentNode.insertBefore(wrapper, element.nextSibling);
                  } else {
                    element.parentNode.appendChild(wrapper);
                  }
                }
                return wrapper.appendChild(element);
              };
              exports2.wrap = wrap;
              var getAdjacentEl = function(startEl, selector, direction) {
                if (direction === void 0) {
                  direction = 1;
                }
                var prop = "".concat(direction > 0 ? "next" : "previous", "ElementSibling");
                var sibling = startEl[prop];
                while (sibling) {
                  if (sibling.matches(selector)) {
                    return sibling;
                  }
                  sibling = sibling[prop];
                }
                return sibling;
              };
              exports2.getAdjacentEl = getAdjacentEl;
              var isScrolledIntoView = function(element, parent2, direction) {
                if (direction === void 0) {
                  direction = 1;
                }
                if (!element) {
                  return false;
                }
                var isVisible;
                if (direction > 0) {
                  isVisible = parent2.scrollTop + parent2.offsetHeight >= element.offsetTop + element.offsetHeight;
                } else {
                  isVisible = element.offsetTop >= parent2.scrollTop;
                }
                return isVisible;
              };
              exports2.isScrolledIntoView = isScrolledIntoView;
              var sanitise = function(value) {
                if (typeof value !== "string") {
                  return value;
                }
                return value.replace(/&/g, "&amp;").replace(/>/g, "&gt;").replace(/</g, "&lt;").replace(/"/g, "&quot;");
              };
              exports2.sanitise = sanitise;
              exports2.strToEl = function() {
                var tmpEl = document.createElement("div");
                return function(str) {
                  var cleanedInput = str.trim();
                  tmpEl.innerHTML = cleanedInput;
                  var firldChild = tmpEl.children[0];
                  while (tmpEl.firstChild) {
                    tmpEl.removeChild(tmpEl.firstChild);
                  }
                  return firldChild;
                };
              }();
              var sortByAlpha = function(_a, _b) {
                var value = _a.value, _c = _a.label, label = _c === void 0 ? value : _c;
                var value2 = _b.value, _d = _b.label, label2 = _d === void 0 ? value2 : _d;
                return label.localeCompare(label2, [], {
                  sensitivity: "base",
                  ignorePunctuation: true,
                  numeric: true
                });
              };
              exports2.sortByAlpha = sortByAlpha;
              var sortByScore = function(a, b) {
                var _a = a.score, scoreA = _a === void 0 ? 0 : _a;
                var _b = b.score, scoreB = _b === void 0 ? 0 : _b;
                return scoreA - scoreB;
              };
              exports2.sortByScore = sortByScore;
              var dispatchEvent = function(element, type, customArgs) {
                if (customArgs === void 0) {
                  customArgs = null;
                }
                var event = new CustomEvent(type, {
                  detail: customArgs,
                  bubbles: true,
                  cancelable: true
                });
                return element.dispatchEvent(event);
              };
              exports2.dispatchEvent = dispatchEvent;
              var existsInArray = function(array, value, key) {
                if (key === void 0) {
                  key = "value";
                }
                return array.some(function(item) {
                  if (typeof value === "string") {
                    return item[key] === value.trim();
                  }
                  return item[key] === value;
                });
              };
              exports2.existsInArray = existsInArray;
              var cloneObject = function(obj) {
                return JSON.parse(JSON.stringify(obj));
              };
              exports2.cloneObject = cloneObject;
              var diff = function(a, b) {
                var aKeys = Object.keys(a).sort();
                var bKeys = Object.keys(b).sort();
                return aKeys.filter(function(i) {
                  return bKeys.indexOf(i) < 0;
                });
              };
              exports2.diff = diff;
              var parseCustomProperties = function(customProperties) {
                if (typeof customProperties !== "undefined") {
                  try {
                    return JSON.parse(customProperties);
                  } catch (e) {
                    return customProperties;
                  }
                }
                return {};
              };
              exports2.parseCustomProperties = parseCustomProperties;
            }
          ),
          /***/
          273: (
            /***/
            function(__unused_webpack_module, exports2) {
              var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                if (pack || arguments.length === 2)
                  for (var i = 0, l = from.length, ar; i < l; i++) {
                    if (ar || !(i in from)) {
                      if (!ar)
                        ar = Array.prototype.slice.call(from, 0, i);
                      ar[i] = from[i];
                    }
                  }
                return to.concat(ar || Array.prototype.slice.call(from));
              };
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.defaultState = void 0;
              exports2.defaultState = [];
              function choices2(state, action) {
                if (state === void 0) {
                  state = exports2.defaultState;
                }
                if (action === void 0) {
                  action = {};
                }
                switch (action.type) {
                  case "ADD_CHOICE": {
                    var addChoiceAction = action;
                    var choice = {
                      id: addChoiceAction.id,
                      elementId: addChoiceAction.elementId,
                      groupId: addChoiceAction.groupId,
                      value: addChoiceAction.value,
                      label: addChoiceAction.label || addChoiceAction.value,
                      disabled: addChoiceAction.disabled || false,
                      selected: false,
                      active: true,
                      score: 9999,
                      customProperties: addChoiceAction.customProperties,
                      placeholder: addChoiceAction.placeholder || false
                    };
                    return __spreadArray(__spreadArray([], state, true), [choice], false);
                  }
                  case "ADD_ITEM": {
                    var addItemAction_1 = action;
                    if (addItemAction_1.choiceId > -1) {
                      return state.map(function(obj) {
                        var choice2 = obj;
                        if (choice2.id === parseInt("".concat(addItemAction_1.choiceId), 10)) {
                          choice2.selected = true;
                        }
                        return choice2;
                      });
                    }
                    return state;
                  }
                  case "REMOVE_ITEM": {
                    var removeItemAction_1 = action;
                    if (removeItemAction_1.choiceId && removeItemAction_1.choiceId > -1) {
                      return state.map(function(obj) {
                        var choice2 = obj;
                        if (choice2.id === parseInt("".concat(removeItemAction_1.choiceId), 10)) {
                          choice2.selected = false;
                        }
                        return choice2;
                      });
                    }
                    return state;
                  }
                  case "FILTER_CHOICES": {
                    var filterChoicesAction_1 = action;
                    return state.map(function(obj) {
                      var choice2 = obj;
                      choice2.active = filterChoicesAction_1.results.some(function(_a) {
                        var item = _a.item, score = _a.score;
                        if (item.id === choice2.id) {
                          choice2.score = score;
                          return true;
                        }
                        return false;
                      });
                      return choice2;
                    });
                  }
                  case "ACTIVATE_CHOICES": {
                    var activateChoicesAction_1 = action;
                    return state.map(function(obj) {
                      var choice2 = obj;
                      choice2.active = activateChoicesAction_1.active;
                      return choice2;
                    });
                  }
                  case "CLEAR_CHOICES": {
                    return exports2.defaultState;
                  }
                  default: {
                    return state;
                  }
                }
              }
              exports2["default"] = choices2;
            }
          ),
          /***/
          871: (
            /***/
            function(__unused_webpack_module, exports2) {
              var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                if (pack || arguments.length === 2)
                  for (var i = 0, l = from.length, ar; i < l; i++) {
                    if (ar || !(i in from)) {
                      if (!ar)
                        ar = Array.prototype.slice.call(from, 0, i);
                      ar[i] = from[i];
                    }
                  }
                return to.concat(ar || Array.prototype.slice.call(from));
              };
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.defaultState = void 0;
              exports2.defaultState = [];
              function groups(state, action) {
                if (state === void 0) {
                  state = exports2.defaultState;
                }
                if (action === void 0) {
                  action = {};
                }
                switch (action.type) {
                  case "ADD_GROUP": {
                    var addGroupAction = action;
                    return __spreadArray(__spreadArray([], state, true), [{
                      id: addGroupAction.id,
                      value: addGroupAction.value,
                      active: addGroupAction.active,
                      disabled: addGroupAction.disabled
                    }], false);
                  }
                  case "CLEAR_CHOICES": {
                    return [];
                  }
                  default: {
                    return state;
                  }
                }
              }
              exports2["default"] = groups;
            }
          ),
          /***/
          655: (
            /***/
            function(__unused_webpack_module, exports2, __webpack_require__2) {
              var __importDefault = this && this.__importDefault || function(mod) {
                return mod && mod.__esModule ? mod : {
                  "default": mod
                };
              };
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.defaultState = void 0;
              var redux_1 = __webpack_require__2(791);
              var items_1 = __importDefault(__webpack_require__2(52));
              var groups_1 = __importDefault(__webpack_require__2(871));
              var choices_1 = __importDefault(__webpack_require__2(273));
              var loading_1 = __importDefault(__webpack_require__2(502));
              var utils_1 = __webpack_require__2(799);
              exports2.defaultState = {
                groups: [],
                items: [],
                choices: [],
                loading: false
              };
              var appReducer = (0, redux_1.combineReducers)({
                items: items_1.default,
                groups: groups_1.default,
                choices: choices_1.default,
                loading: loading_1.default
              });
              var rootReducer = function(passedState, action) {
                var state = passedState;
                if (action.type === "CLEAR_ALL") {
                  state = exports2.defaultState;
                } else if (action.type === "RESET_TO") {
                  return (0, utils_1.cloneObject)(action.state);
                }
                return appReducer(state, action);
              };
              exports2["default"] = rootReducer;
            }
          ),
          /***/
          52: (
            /***/
            function(__unused_webpack_module, exports2) {
              var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                if (pack || arguments.length === 2)
                  for (var i = 0, l = from.length, ar; i < l; i++) {
                    if (ar || !(i in from)) {
                      if (!ar)
                        ar = Array.prototype.slice.call(from, 0, i);
                      ar[i] = from[i];
                    }
                  }
                return to.concat(ar || Array.prototype.slice.call(from));
              };
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.defaultState = void 0;
              exports2.defaultState = [];
              function items(state, action) {
                if (state === void 0) {
                  state = exports2.defaultState;
                }
                if (action === void 0) {
                  action = {};
                }
                switch (action.type) {
                  case "ADD_ITEM": {
                    var addItemAction = action;
                    var newState = __spreadArray(__spreadArray([], state, true), [{
                      id: addItemAction.id,
                      choiceId: addItemAction.choiceId,
                      groupId: addItemAction.groupId,
                      value: addItemAction.value,
                      label: addItemAction.label,
                      active: true,
                      highlighted: false,
                      customProperties: addItemAction.customProperties,
                      placeholder: addItemAction.placeholder || false,
                      keyCode: null
                    }], false);
                    return newState.map(function(obj) {
                      var item = obj;
                      item.highlighted = false;
                      return item;
                    });
                  }
                  case "REMOVE_ITEM": {
                    return state.map(function(obj) {
                      var item = obj;
                      if (item.id === action.id) {
                        item.active = false;
                      }
                      return item;
                    });
                  }
                  case "HIGHLIGHT_ITEM": {
                    var highlightItemAction_1 = action;
                    return state.map(function(obj) {
                      var item = obj;
                      if (item.id === highlightItemAction_1.id) {
                        item.highlighted = highlightItemAction_1.highlighted;
                      }
                      return item;
                    });
                  }
                  default: {
                    return state;
                  }
                }
              }
              exports2["default"] = items;
            }
          ),
          /***/
          502: (
            /***/
            function(__unused_webpack_module, exports2) {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              exports2.defaultState = void 0;
              exports2.defaultState = false;
              var general = function(state, action) {
                if (state === void 0) {
                  state = exports2.defaultState;
                }
                if (action === void 0) {
                  action = {};
                }
                switch (action.type) {
                  case "SET_IS_LOADING": {
                    return action.isLoading;
                  }
                  default: {
                    return state;
                  }
                }
              };
              exports2["default"] = general;
            }
          ),
          /***/
          744: (
            /***/
            function(__unused_webpack_module, exports2, __webpack_require__2) {
              var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                if (pack || arguments.length === 2)
                  for (var i = 0, l = from.length, ar; i < l; i++) {
                    if (ar || !(i in from)) {
                      if (!ar)
                        ar = Array.prototype.slice.call(from, 0, i);
                      ar[i] = from[i];
                    }
                  }
                return to.concat(ar || Array.prototype.slice.call(from));
              };
              var __importDefault = this && this.__importDefault || function(mod) {
                return mod && mod.__esModule ? mod : {
                  "default": mod
                };
              };
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              var redux_1 = __webpack_require__2(791);
              var index_1 = __importDefault(__webpack_require__2(655));
              var Store = (
                /** @class */
                function() {
                  function Store2() {
                    this._store = (0, redux_1.createStore)(index_1.default, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
                  }
                  Store2.prototype.subscribe = function(onChange) {
                    this._store.subscribe(onChange);
                  };
                  Store2.prototype.dispatch = function(action) {
                    this._store.dispatch(action);
                  };
                  Object.defineProperty(Store2.prototype, "state", {
                    /**
                     * Get store object (wrapping Redux method)
                     */
                    get: function() {
                      return this._store.getState();
                    },
                    enumerable: false,
                    configurable: true
                  });
                  Object.defineProperty(Store2.prototype, "items", {
                    /**
                     * Get items from store
                     */
                    get: function() {
                      return this.state.items;
                    },
                    enumerable: false,
                    configurable: true
                  });
                  Object.defineProperty(Store2.prototype, "activeItems", {
                    /**
                     * Get active items from store
                     */
                    get: function() {
                      return this.items.filter(function(item) {
                        return item.active === true;
                      });
                    },
                    enumerable: false,
                    configurable: true
                  });
                  Object.defineProperty(Store2.prototype, "highlightedActiveItems", {
                    /**
                     * Get highlighted items from store
                     */
                    get: function() {
                      return this.items.filter(function(item) {
                        return item.active && item.highlighted;
                      });
                    },
                    enumerable: false,
                    configurable: true
                  });
                  Object.defineProperty(Store2.prototype, "choices", {
                    /**
                     * Get choices from store
                     */
                    get: function() {
                      return this.state.choices;
                    },
                    enumerable: false,
                    configurable: true
                  });
                  Object.defineProperty(Store2.prototype, "activeChoices", {
                    /**
                     * Get active choices from store
                     */
                    get: function() {
                      return this.choices.filter(function(choice) {
                        return choice.active === true;
                      });
                    },
                    enumerable: false,
                    configurable: true
                  });
                  Object.defineProperty(Store2.prototype, "selectableChoices", {
                    /**
                     * Get selectable choices from store
                     */
                    get: function() {
                      return this.choices.filter(function(choice) {
                        return choice.disabled !== true;
                      });
                    },
                    enumerable: false,
                    configurable: true
                  });
                  Object.defineProperty(Store2.prototype, "searchableChoices", {
                    /**
                     * Get choices that can be searched (excluding placeholders)
                     */
                    get: function() {
                      return this.selectableChoices.filter(function(choice) {
                        return choice.placeholder !== true;
                      });
                    },
                    enumerable: false,
                    configurable: true
                  });
                  Object.defineProperty(Store2.prototype, "placeholderChoice", {
                    /**
                     * Get placeholder choice from store
                     */
                    get: function() {
                      return __spreadArray([], this.choices, true).reverse().find(function(choice) {
                        return choice.placeholder === true;
                      });
                    },
                    enumerable: false,
                    configurable: true
                  });
                  Object.defineProperty(Store2.prototype, "groups", {
                    /**
                     * Get groups from store
                     */
                    get: function() {
                      return this.state.groups;
                    },
                    enumerable: false,
                    configurable: true
                  });
                  Object.defineProperty(Store2.prototype, "activeGroups", {
                    /**
                     * Get active groups from store
                     */
                    get: function() {
                      var _a = this, groups = _a.groups, choices2 = _a.choices;
                      return groups.filter(function(group) {
                        var isActive = group.active === true && group.disabled === false;
                        var hasActiveOptions = choices2.some(function(choice) {
                          return choice.active === true && choice.disabled === false;
                        });
                        return isActive && hasActiveOptions;
                      }, []);
                    },
                    enumerable: false,
                    configurable: true
                  });
                  Store2.prototype.isLoading = function() {
                    return this.state.loading;
                  };
                  Store2.prototype.getChoiceById = function(id) {
                    return this.activeChoices.find(function(choice) {
                      return choice.id === parseInt(id, 10);
                    });
                  };
                  Store2.prototype.getGroupById = function(id) {
                    return this.groups.find(function(group) {
                      return group.id === id;
                    });
                  };
                  return Store2;
                }()
              );
              exports2["default"] = Store;
            }
          ),
          /***/
          686: (
            /***/
            function(__unused_webpack_module, exports2) {
              Object.defineProperty(exports2, "__esModule", {
                value: true
              });
              var templates = {
                containerOuter: function(_a, dir, isSelectElement, isSelectOneElement, searchEnabled, passedElementType, labelId) {
                  var containerOuter = _a.classNames.containerOuter;
                  var div = Object.assign(document.createElement("div"), {
                    className: containerOuter
                  });
                  div.dataset.type = passedElementType;
                  if (dir) {
                    div.dir = dir;
                  }
                  if (isSelectOneElement) {
                    div.tabIndex = 0;
                  }
                  if (isSelectElement) {
                    div.setAttribute("role", searchEnabled ? "combobox" : "listbox");
                    if (searchEnabled) {
                      div.setAttribute("aria-autocomplete", "list");
                    }
                  }
                  div.setAttribute("aria-haspopup", "true");
                  div.setAttribute("aria-expanded", "false");
                  if (labelId) {
                    div.setAttribute("aria-labelledby", labelId);
                  }
                  return div;
                },
                containerInner: function(_a) {
                  var containerInner = _a.classNames.containerInner;
                  return Object.assign(document.createElement("div"), {
                    className: containerInner
                  });
                },
                itemList: function(_a, isSelectOneElement) {
                  var _b = _a.classNames, list = _b.list, listSingle = _b.listSingle, listItems = _b.listItems;
                  return Object.assign(document.createElement("div"), {
                    className: "".concat(list, " ").concat(isSelectOneElement ? listSingle : listItems)
                  });
                },
                placeholder: function(_a, value) {
                  var _b;
                  var allowHTML = _a.allowHTML, placeholder = _a.classNames.placeholder;
                  return Object.assign(document.createElement("div"), (_b = {
                    className: placeholder
                  }, _b[allowHTML ? "innerHTML" : "innerText"] = value, _b));
                },
                item: function(_a, _b, removeItemButton) {
                  var _c, _d;
                  var allowHTML = _a.allowHTML, _e = _a.classNames, item = _e.item, button = _e.button, highlightedState = _e.highlightedState, itemSelectable = _e.itemSelectable, placeholder = _e.placeholder;
                  var id = _b.id, value = _b.value, label = _b.label, customProperties = _b.customProperties, active = _b.active, disabled = _b.disabled, highlighted = _b.highlighted, isPlaceholder = _b.placeholder;
                  var div = Object.assign(document.createElement("div"), (_c = {
                    className: item
                  }, _c[allowHTML ? "innerHTML" : "innerText"] = label, _c));
                  Object.assign(div.dataset, {
                    item: "",
                    id,
                    value,
                    customProperties
                  });
                  if (active) {
                    div.setAttribute("aria-selected", "true");
                  }
                  if (disabled) {
                    div.setAttribute("aria-disabled", "true");
                  }
                  if (isPlaceholder) {
                    div.classList.add(placeholder);
                  }
                  div.classList.add(highlighted ? highlightedState : itemSelectable);
                  if (removeItemButton) {
                    if (disabled) {
                      div.classList.remove(itemSelectable);
                    }
                    div.dataset.deletable = "";
                    var REMOVE_ITEM_TEXT = "Remove item";
                    var removeButton = Object.assign(document.createElement("button"), (_d = {
                      type: "button",
                      className: button
                    }, _d[allowHTML ? "innerHTML" : "innerText"] = REMOVE_ITEM_TEXT, _d));
                    removeButton.setAttribute("aria-label", "".concat(REMOVE_ITEM_TEXT, ": '").concat(value, "'"));
                    removeButton.dataset.button = "";
                    div.appendChild(removeButton);
                  }
                  return div;
                },
                choiceList: function(_a, isSelectOneElement) {
                  var list = _a.classNames.list;
                  var div = Object.assign(document.createElement("div"), {
                    className: list
                  });
                  if (!isSelectOneElement) {
                    div.setAttribute("aria-multiselectable", "true");
                  }
                  div.setAttribute("role", "listbox");
                  return div;
                },
                choiceGroup: function(_a, _b) {
                  var _c;
                  var allowHTML = _a.allowHTML, _d = _a.classNames, group = _d.group, groupHeading = _d.groupHeading, itemDisabled = _d.itemDisabled;
                  var id = _b.id, value = _b.value, disabled = _b.disabled;
                  var div = Object.assign(document.createElement("div"), {
                    className: "".concat(group, " ").concat(disabled ? itemDisabled : "")
                  });
                  div.setAttribute("role", "group");
                  Object.assign(div.dataset, {
                    group: "",
                    id,
                    value
                  });
                  if (disabled) {
                    div.setAttribute("aria-disabled", "true");
                  }
                  div.appendChild(Object.assign(document.createElement("div"), (_c = {
                    className: groupHeading
                  }, _c[allowHTML ? "innerHTML" : "innerText"] = value, _c)));
                  return div;
                },
                choice: function(_a, _b, selectText) {
                  var _c;
                  var allowHTML = _a.allowHTML, _d = _a.classNames, item = _d.item, itemChoice = _d.itemChoice, itemSelectable = _d.itemSelectable, selectedState = _d.selectedState, itemDisabled = _d.itemDisabled, placeholder = _d.placeholder;
                  var id = _b.id, value = _b.value, label = _b.label, groupId = _b.groupId, elementId = _b.elementId, isDisabled = _b.disabled, isSelected = _b.selected, isPlaceholder = _b.placeholder;
                  var div = Object.assign(document.createElement("div"), (_c = {
                    id: elementId
                  }, _c[allowHTML ? "innerHTML" : "innerText"] = label, _c.className = "".concat(item, " ").concat(itemChoice), _c));
                  if (isSelected) {
                    div.classList.add(selectedState);
                  }
                  if (isPlaceholder) {
                    div.classList.add(placeholder);
                  }
                  div.setAttribute("role", groupId && groupId > 0 ? "treeitem" : "option");
                  Object.assign(div.dataset, {
                    choice: "",
                    id,
                    value,
                    selectText
                  });
                  if (isDisabled) {
                    div.classList.add(itemDisabled);
                    div.dataset.choiceDisabled = "";
                    div.setAttribute("aria-disabled", "true");
                  } else {
                    div.classList.add(itemSelectable);
                    div.dataset.choiceSelectable = "";
                  }
                  return div;
                },
                input: function(_a, placeholderValue) {
                  var _b = _a.classNames, input = _b.input, inputCloned = _b.inputCloned;
                  var inp = Object.assign(document.createElement("input"), {
                    type: "search",
                    name: "search_terms",
                    className: "".concat(input, " ").concat(inputCloned),
                    autocomplete: "off",
                    autocapitalize: "off",
                    spellcheck: false
                  });
                  inp.setAttribute("role", "textbox");
                  inp.setAttribute("aria-autocomplete", "list");
                  inp.setAttribute("aria-label", placeholderValue);
                  return inp;
                },
                dropdown: function(_a) {
                  var _b = _a.classNames, list = _b.list, listDropdown = _b.listDropdown;
                  var div = document.createElement("div");
                  div.classList.add(list, listDropdown);
                  div.setAttribute("aria-expanded", "false");
                  return div;
                },
                notice: function(_a, innerText, type) {
                  var _b;
                  var allowHTML = _a.allowHTML, _c = _a.classNames, item = _c.item, itemChoice = _c.itemChoice, noResults = _c.noResults, noChoices = _c.noChoices;
                  if (type === void 0) {
                    type = "";
                  }
                  var classes2 = [item, itemChoice];
                  if (type === "no-choices") {
                    classes2.push(noChoices);
                  } else if (type === "no-results") {
                    classes2.push(noResults);
                  }
                  return Object.assign(document.createElement("div"), (_b = {}, _b[allowHTML ? "innerHTML" : "innerText"] = innerText, _b.className = classes2.join(" "), _b));
                },
                option: function(_a) {
                  var label = _a.label, value = _a.value, customProperties = _a.customProperties, active = _a.active, disabled = _a.disabled;
                  var opt = new Option(label, value, false, active);
                  if (customProperties) {
                    opt.dataset.customProperties = "".concat(customProperties);
                  }
                  opt.disabled = !!disabled;
                  return opt;
                }
              };
              exports2["default"] = templates;
            }
          ),
          /***/
          996: (
            /***/
            function(module2) {
              var isMergeableObject = function isMergeableObject2(value) {
                return isNonNullObject(value) && !isSpecial(value);
              };
              function isNonNullObject(value) {
                return !!value && typeof value === "object";
              }
              function isSpecial(value) {
                var stringValue = Object.prototype.toString.call(value);
                return stringValue === "[object RegExp]" || stringValue === "[object Date]" || isReactElement(value);
              }
              var canUseSymbol = typeof Symbol === "function" && Symbol.for;
              var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for("react.element") : 60103;
              function isReactElement(value) {
                return value.$$typeof === REACT_ELEMENT_TYPE;
              }
              function emptyTarget(val) {
                return Array.isArray(val) ? [] : {};
              }
              function cloneUnlessOtherwiseSpecified(value, options) {
                return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
              }
              function defaultArrayMerge(target, source, options) {
                return target.concat(source).map(function(element) {
                  return cloneUnlessOtherwiseSpecified(element, options);
                });
              }
              function getMergeFunction(key, options) {
                if (!options.customMerge) {
                  return deepmerge;
                }
                var customMerge = options.customMerge(key);
                return typeof customMerge === "function" ? customMerge : deepmerge;
              }
              function getEnumerableOwnPropertySymbols(target) {
                return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
                  return target.propertyIsEnumerable(symbol);
                }) : [];
              }
              function getKeys(target) {
                return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
              }
              function propertyIsOnObject(object, property) {
                try {
                  return property in object;
                } catch (_) {
                  return false;
                }
              }
              function propertyIsUnsafe(target, key) {
                return propertyIsOnObject(target, key) && !(Object.hasOwnProperty.call(target, key) && Object.propertyIsEnumerable.call(target, key));
              }
              function mergeObject(target, source, options) {
                var destination = {};
                if (options.isMergeableObject(target)) {
                  getKeys(target).forEach(function(key) {
                    destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
                  });
                }
                getKeys(source).forEach(function(key) {
                  if (propertyIsUnsafe(target, key)) {
                    return;
                  }
                  if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
                    destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
                  } else {
                    destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
                  }
                });
                return destination;
              }
              function deepmerge(target, source, options) {
                options = options || {};
                options.arrayMerge = options.arrayMerge || defaultArrayMerge;
                options.isMergeableObject = options.isMergeableObject || isMergeableObject;
                options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
                var sourceIsArray = Array.isArray(source);
                var targetIsArray = Array.isArray(target);
                var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
                if (!sourceAndTargetTypesMatch) {
                  return cloneUnlessOtherwiseSpecified(source, options);
                } else if (sourceIsArray) {
                  return options.arrayMerge(target, source, options);
                } else {
                  return mergeObject(target, source, options);
                }
              }
              deepmerge.all = function deepmergeAll(array, options) {
                if (!Array.isArray(array)) {
                  throw new Error("first argument should be an array");
                }
                return array.reduce(function(prev2, next2) {
                  return deepmerge(prev2, next2, options);
                }, {});
              };
              var deepmerge_1 = deepmerge;
              module2.exports = deepmerge_1;
            }
          ),
          /***/
          221: (
            /***/
            function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
              __webpack_require__2.r(__webpack_exports__2);
              __webpack_require__2.d(__webpack_exports__2, {
                /* harmony export */
                "default": function() {
                  return (
                    /* binding */
                    Fuse
                  );
                }
                /* harmony export */
              });
              function isArray2(value) {
                return !Array.isArray ? getTag(value) === "[object Array]" : Array.isArray(value);
              }
              const INFINITY = 1 / 0;
              function baseToString(value) {
                if (typeof value == "string") {
                  return value;
                }
                let result = value + "";
                return result == "0" && 1 / value == -INFINITY ? "-0" : result;
              }
              function toString(value) {
                return value == null ? "" : baseToString(value);
              }
              function isString2(value) {
                return typeof value === "string";
              }
              function isNumber(value) {
                return typeof value === "number";
              }
              function isBoolean(value) {
                return value === true || value === false || isObjectLike(value) && getTag(value) == "[object Boolean]";
              }
              function isObject2(value) {
                return typeof value === "object";
              }
              function isObjectLike(value) {
                return isObject2(value) && value !== null;
              }
              function isDefined(value) {
                return value !== void 0 && value !== null;
              }
              function isBlank(value) {
                return !value.trim().length;
              }
              function getTag(value) {
                return value == null ? value === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(value);
              }
              const INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
              const LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key) => `Invalid value for key ${key}`;
              const PATTERN_LENGTH_TOO_LARGE = (max) => `Pattern length exceeds max of ${max}.`;
              const MISSING_KEY_PROPERTY = (name) => `Missing ${name} property in key`;
              const INVALID_KEY_WEIGHT_VALUE = (key) => `Property 'weight' in key '${key}' must be a positive integer`;
              const hasOwn2 = Object.prototype.hasOwnProperty;
              class KeyStore {
                constructor(keys) {
                  this._keys = [];
                  this._keyMap = {};
                  let totalWeight = 0;
                  keys.forEach((key) => {
                    let obj = createKey(key);
                    totalWeight += obj.weight;
                    this._keys.push(obj);
                    this._keyMap[obj.id] = obj;
                    totalWeight += obj.weight;
                  });
                  this._keys.forEach((key) => {
                    key.weight /= totalWeight;
                  });
                }
                get(keyId) {
                  return this._keyMap[keyId];
                }
                keys() {
                  return this._keys;
                }
                toJSON() {
                  return JSON.stringify(this._keys);
                }
              }
              function createKey(key) {
                let path = null;
                let id = null;
                let src = null;
                let weight = 1;
                let getFn = null;
                if (isString2(key) || isArray2(key)) {
                  src = key;
                  path = createKeyPath(key);
                  id = createKeyId(key);
                } else {
                  if (!hasOwn2.call(key, "name")) {
                    throw new Error(MISSING_KEY_PROPERTY("name"));
                  }
                  const name = key.name;
                  src = name;
                  if (hasOwn2.call(key, "weight")) {
                    weight = key.weight;
                    if (weight <= 0) {
                      throw new Error(INVALID_KEY_WEIGHT_VALUE(name));
                    }
                  }
                  path = createKeyPath(name);
                  id = createKeyId(name);
                  getFn = key.getFn;
                }
                return { path, id, weight, src, getFn };
              }
              function createKeyPath(key) {
                return isArray2(key) ? key : key.split(".");
              }
              function createKeyId(key) {
                return isArray2(key) ? key.join(".") : key;
              }
              function get3(obj, path) {
                let list = [];
                let arr = false;
                const deepGet = (obj2, path2, index2) => {
                  if (!isDefined(obj2)) {
                    return;
                  }
                  if (!path2[index2]) {
                    list.push(obj2);
                  } else {
                    let key = path2[index2];
                    const value = obj2[key];
                    if (!isDefined(value)) {
                      return;
                    }
                    if (index2 === path2.length - 1 && (isString2(value) || isNumber(value) || isBoolean(value))) {
                      list.push(toString(value));
                    } else if (isArray2(value)) {
                      arr = true;
                      for (let i = 0, len = value.length; i < len; i += 1) {
                        deepGet(value[i], path2, index2 + 1);
                      }
                    } else if (path2.length) {
                      deepGet(value, path2, index2 + 1);
                    }
                  }
                };
                deepGet(obj, isString2(path) ? path.split(".") : path, 0);
                return arr ? list : list[0];
              }
              const MatchOptions = {
                // Whether the matches should be included in the result set. When `true`, each record in the result
                // set will include the indices of the matched characters.
                // These can consequently be used for highlighting purposes.
                includeMatches: false,
                // When `true`, the matching function will continue to the end of a search pattern even if
                // a perfect match has already been located in the string.
                findAllMatches: false,
                // Minimum number of characters that must be matched before a result is considered a match
                minMatchCharLength: 1
              };
              const BasicOptions = {
                // When `true`, the algorithm continues searching to the end of the input even if a perfect
                // match is found before the end of the same input.
                isCaseSensitive: false,
                // When true, the matching function will continue to the end of a search pattern even if
                includeScore: false,
                // List of properties that will be searched. This also supports nested properties.
                keys: [],
                // Whether to sort the result list, by score
                shouldSort: true,
                // Default sort function: sort by ascending score, ascending index
                sortFn: (a, b) => a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
              };
              const FuzzyOptions = {
                // Approximately where in the text is the pattern expected to be found?
                location: 0,
                // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
                // (of both letters and location), a threshold of '1.0' would match anything.
                threshold: 0.6,
                // Determines how close the match must be to the fuzzy location (specified above).
                // An exact letter match which is 'distance' characters away from the fuzzy location
                // would score as a complete mismatch. A distance of '0' requires the match be at
                // the exact location specified, a threshold of '1000' would require a perfect match
                // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
                distance: 100
              };
              const AdvancedOptions = {
                // When `true`, it enables the use of unix-like search commands
                useExtendedSearch: false,
                // The get function to use when fetching an object's properties.
                // The default will search nested paths *ie foo.bar.baz*
                getFn: get3,
                // When `true`, search will ignore `location` and `distance`, so it won't matter
                // where in the string the pattern appears.
                // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
                ignoreLocation: false,
                // When `true`, the calculation for the relevance score (used for sorting) will
                // ignore the field-length norm.
                // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
                ignoreFieldNorm: false,
                // The weight to determine how much field length norm effects scoring.
                fieldNormWeight: 1
              };
              var Config = {
                ...BasicOptions,
                ...MatchOptions,
                ...FuzzyOptions,
                ...AdvancedOptions
              };
              const SPACE = /[^ ]+/g;
              function norm(weight = 1, mantissa = 3) {
                const cache = /* @__PURE__ */ new Map();
                const m = Math.pow(10, mantissa);
                return {
                  get(value) {
                    const numTokens = value.match(SPACE).length;
                    if (cache.has(numTokens)) {
                      return cache.get(numTokens);
                    }
                    const norm2 = 1 / Math.pow(numTokens, 0.5 * weight);
                    const n = parseFloat(Math.round(norm2 * m) / m);
                    cache.set(numTokens, n);
                    return n;
                  },
                  clear() {
                    cache.clear();
                  }
                };
              }
              class FuseIndex {
                constructor({
                  getFn = Config.getFn,
                  fieldNormWeight = Config.fieldNormWeight
                } = {}) {
                  this.norm = norm(fieldNormWeight, 3);
                  this.getFn = getFn;
                  this.isCreated = false;
                  this.setIndexRecords();
                }
                setSources(docs = []) {
                  this.docs = docs;
                }
                setIndexRecords(records = []) {
                  this.records = records;
                }
                setKeys(keys = []) {
                  this.keys = keys;
                  this._keysMap = {};
                  keys.forEach((key, idx) => {
                    this._keysMap[key.id] = idx;
                  });
                }
                create() {
                  if (this.isCreated || !this.docs.length) {
                    return;
                  }
                  this.isCreated = true;
                  if (isString2(this.docs[0])) {
                    this.docs.forEach((doc, docIndex) => {
                      this._addString(doc, docIndex);
                    });
                  } else {
                    this.docs.forEach((doc, docIndex) => {
                      this._addObject(doc, docIndex);
                    });
                  }
                  this.norm.clear();
                }
                // Adds a doc to the end of the index
                add(doc) {
                  const idx = this.size();
                  if (isString2(doc)) {
                    this._addString(doc, idx);
                  } else {
                    this._addObject(doc, idx);
                  }
                }
                // Removes the doc at the specified index of the index
                removeAt(idx) {
                  this.records.splice(idx, 1);
                  for (let i = idx, len = this.size(); i < len; i += 1) {
                    this.records[i].i -= 1;
                  }
                }
                getValueForItemAtKeyId(item, keyId) {
                  return item[this._keysMap[keyId]];
                }
                size() {
                  return this.records.length;
                }
                _addString(doc, docIndex) {
                  if (!isDefined(doc) || isBlank(doc)) {
                    return;
                  }
                  let record = {
                    v: doc,
                    i: docIndex,
                    n: this.norm.get(doc)
                  };
                  this.records.push(record);
                }
                _addObject(doc, docIndex) {
                  let record = { i: docIndex, $: {} };
                  this.keys.forEach((key, keyIndex) => {
                    let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
                    if (!isDefined(value)) {
                      return;
                    }
                    if (isArray2(value)) {
                      let subRecords = [];
                      const stack = [{ nestedArrIndex: -1, value }];
                      while (stack.length) {
                        const { nestedArrIndex, value: value2 } = stack.pop();
                        if (!isDefined(value2)) {
                          continue;
                        }
                        if (isString2(value2) && !isBlank(value2)) {
                          let subRecord = {
                            v: value2,
                            i: nestedArrIndex,
                            n: this.norm.get(value2)
                          };
                          subRecords.push(subRecord);
                        } else if (isArray2(value2)) {
                          value2.forEach((item, k) => {
                            stack.push({
                              nestedArrIndex: k,
                              value: item
                            });
                          });
                        } else
                          ;
                      }
                      record.$[keyIndex] = subRecords;
                    } else if (isString2(value) && !isBlank(value)) {
                      let subRecord = {
                        v: value,
                        n: this.norm.get(value)
                      };
                      record.$[keyIndex] = subRecord;
                    }
                  });
                  this.records.push(record);
                }
                toJSON() {
                  return {
                    keys: this.keys,
                    records: this.records
                  };
                }
              }
              function createIndex(keys, docs, { getFn = Config.getFn, fieldNormWeight = Config.fieldNormWeight } = {}) {
                const myIndex = new FuseIndex({ getFn, fieldNormWeight });
                myIndex.setKeys(keys.map(createKey));
                myIndex.setSources(docs);
                myIndex.create();
                return myIndex;
              }
              function parseIndex(data2, { getFn = Config.getFn, fieldNormWeight = Config.fieldNormWeight } = {}) {
                const { keys, records } = data2;
                const myIndex = new FuseIndex({ getFn, fieldNormWeight });
                myIndex.setKeys(keys);
                myIndex.setIndexRecords(records);
                return myIndex;
              }
              function computeScore$1(pattern, {
                errors = 0,
                currentLocation = 0,
                expectedLocation = 0,
                distance = Config.distance,
                ignoreLocation = Config.ignoreLocation
              } = {}) {
                const accuracy = errors / pattern.length;
                if (ignoreLocation) {
                  return accuracy;
                }
                const proximity = Math.abs(expectedLocation - currentLocation);
                if (!distance) {
                  return proximity ? 1 : accuracy;
                }
                return accuracy + proximity / distance;
              }
              function convertMaskToIndices(matchmask = [], minMatchCharLength = Config.minMatchCharLength) {
                let indices = [];
                let start2 = -1;
                let end = -1;
                let i = 0;
                for (let len = matchmask.length; i < len; i += 1) {
                  let match = matchmask[i];
                  if (match && start2 === -1) {
                    start2 = i;
                  } else if (!match && start2 !== -1) {
                    end = i - 1;
                    if (end - start2 + 1 >= minMatchCharLength) {
                      indices.push([start2, end]);
                    }
                    start2 = -1;
                  }
                }
                if (matchmask[i - 1] && i - start2 >= minMatchCharLength) {
                  indices.push([start2, i - 1]);
                }
                return indices;
              }
              const MAX_BITS = 32;
              function search(text2, pattern, patternAlphabet, {
                location = Config.location,
                distance = Config.distance,
                threshold = Config.threshold,
                findAllMatches = Config.findAllMatches,
                minMatchCharLength = Config.minMatchCharLength,
                includeMatches = Config.includeMatches,
                ignoreLocation = Config.ignoreLocation
              } = {}) {
                if (pattern.length > MAX_BITS) {
                  throw new Error(PATTERN_LENGTH_TOO_LARGE(MAX_BITS));
                }
                const patternLen = pattern.length;
                const textLen = text2.length;
                const expectedLocation = Math.max(0, Math.min(location, textLen));
                let currentThreshold = threshold;
                let bestLocation = expectedLocation;
                const computeMatches = minMatchCharLength > 1 || includeMatches;
                const matchMask = computeMatches ? Array(textLen) : [];
                let index2;
                while ((index2 = text2.indexOf(pattern, bestLocation)) > -1) {
                  let score = computeScore$1(pattern, {
                    currentLocation: index2,
                    expectedLocation,
                    distance,
                    ignoreLocation
                  });
                  currentThreshold = Math.min(score, currentThreshold);
                  bestLocation = index2 + patternLen;
                  if (computeMatches) {
                    let i = 0;
                    while (i < patternLen) {
                      matchMask[index2 + i] = 1;
                      i += 1;
                    }
                  }
                }
                bestLocation = -1;
                let lastBitArr = [];
                let finalScore = 1;
                let binMax = patternLen + textLen;
                const mask = 1 << patternLen - 1;
                for (let i = 0; i < patternLen; i += 1) {
                  let binMin = 0;
                  let binMid = binMax;
                  while (binMin < binMid) {
                    const score2 = computeScore$1(pattern, {
                      errors: i,
                      currentLocation: expectedLocation + binMid,
                      expectedLocation,
                      distance,
                      ignoreLocation
                    });
                    if (score2 <= currentThreshold) {
                      binMin = binMid;
                    } else {
                      binMax = binMid;
                    }
                    binMid = Math.floor((binMax - binMin) / 2 + binMin);
                  }
                  binMax = binMid;
                  let start2 = Math.max(1, expectedLocation - binMid + 1);
                  let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
                  let bitArr = Array(finish + 2);
                  bitArr[finish + 1] = (1 << i) - 1;
                  for (let j = finish; j >= start2; j -= 1) {
                    let currentLocation = j - 1;
                    let charMatch = patternAlphabet[text2.charAt(currentLocation)];
                    if (computeMatches) {
                      matchMask[currentLocation] = +!!charMatch;
                    }
                    bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
                    if (i) {
                      bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
                    }
                    if (bitArr[j] & mask) {
                      finalScore = computeScore$1(pattern, {
                        errors: i,
                        currentLocation,
                        expectedLocation,
                        distance,
                        ignoreLocation
                      });
                      if (finalScore <= currentThreshold) {
                        currentThreshold = finalScore;
                        bestLocation = currentLocation;
                        if (bestLocation <= expectedLocation) {
                          break;
                        }
                        start2 = Math.max(1, 2 * expectedLocation - bestLocation);
                      }
                    }
                  }
                  const score = computeScore$1(pattern, {
                    errors: i + 1,
                    currentLocation: expectedLocation,
                    expectedLocation,
                    distance,
                    ignoreLocation
                  });
                  if (score > currentThreshold) {
                    break;
                  }
                  lastBitArr = bitArr;
                }
                const result = {
                  isMatch: bestLocation >= 0,
                  // Count exact matches (those with a score of 0) to be "almost" exact
                  score: Math.max(1e-3, finalScore)
                };
                if (computeMatches) {
                  const indices = convertMaskToIndices(matchMask, minMatchCharLength);
                  if (!indices.length) {
                    result.isMatch = false;
                  } else if (includeMatches) {
                    result.indices = indices;
                  }
                }
                return result;
              }
              function createPatternAlphabet(pattern) {
                let mask = {};
                for (let i = 0, len = pattern.length; i < len; i += 1) {
                  const char = pattern.charAt(i);
                  mask[char] = (mask[char] || 0) | 1 << len - i - 1;
                }
                return mask;
              }
              class BitapSearch {
                constructor(pattern, {
                  location = Config.location,
                  threshold = Config.threshold,
                  distance = Config.distance,
                  includeMatches = Config.includeMatches,
                  findAllMatches = Config.findAllMatches,
                  minMatchCharLength = Config.minMatchCharLength,
                  isCaseSensitive = Config.isCaseSensitive,
                  ignoreLocation = Config.ignoreLocation
                } = {}) {
                  this.options = {
                    location,
                    threshold,
                    distance,
                    includeMatches,
                    findAllMatches,
                    minMatchCharLength,
                    isCaseSensitive,
                    ignoreLocation
                  };
                  this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
                  this.chunks = [];
                  if (!this.pattern.length) {
                    return;
                  }
                  const addChunk = (pattern2, startIndex) => {
                    this.chunks.push({
                      pattern: pattern2,
                      alphabet: createPatternAlphabet(pattern2),
                      startIndex
                    });
                  };
                  const len = this.pattern.length;
                  if (len > MAX_BITS) {
                    let i = 0;
                    const remainder = len % MAX_BITS;
                    const end = len - remainder;
                    while (i < end) {
                      addChunk(this.pattern.substr(i, MAX_BITS), i);
                      i += MAX_BITS;
                    }
                    if (remainder) {
                      const startIndex = len - MAX_BITS;
                      addChunk(this.pattern.substr(startIndex), startIndex);
                    }
                  } else {
                    addChunk(this.pattern, 0);
                  }
                }
                searchIn(text2) {
                  const { isCaseSensitive, includeMatches } = this.options;
                  if (!isCaseSensitive) {
                    text2 = text2.toLowerCase();
                  }
                  if (this.pattern === text2) {
                    let result2 = {
                      isMatch: true,
                      score: 0
                    };
                    if (includeMatches) {
                      result2.indices = [[0, text2.length - 1]];
                    }
                    return result2;
                  }
                  const {
                    location,
                    distance,
                    threshold,
                    findAllMatches,
                    minMatchCharLength,
                    ignoreLocation
                  } = this.options;
                  let allIndices = [];
                  let totalScore = 0;
                  let hasMatches = false;
                  this.chunks.forEach(({ pattern, alphabet, startIndex }) => {
                    const { isMatch, score, indices } = search(text2, pattern, alphabet, {
                      location: location + startIndex,
                      distance,
                      threshold,
                      findAllMatches,
                      minMatchCharLength,
                      includeMatches,
                      ignoreLocation
                    });
                    if (isMatch) {
                      hasMatches = true;
                    }
                    totalScore += score;
                    if (isMatch && indices) {
                      allIndices = [...allIndices, ...indices];
                    }
                  });
                  let result = {
                    isMatch: hasMatches,
                    score: hasMatches ? totalScore / this.chunks.length : 1
                  };
                  if (hasMatches && includeMatches) {
                    result.indices = allIndices;
                  }
                  return result;
                }
              }
              class BaseMatch {
                constructor(pattern) {
                  this.pattern = pattern;
                }
                static isMultiMatch(pattern) {
                  return getMatch(pattern, this.multiRegex);
                }
                static isSingleMatch(pattern) {
                  return getMatch(pattern, this.singleRegex);
                }
                search() {
                }
              }
              function getMatch(pattern, exp) {
                const matches = pattern.match(exp);
                return matches ? matches[1] : null;
              }
              class ExactMatch extends BaseMatch {
                constructor(pattern) {
                  super(pattern);
                }
                static get type() {
                  return "exact";
                }
                static get multiRegex() {
                  return /^="(.*)"$/;
                }
                static get singleRegex() {
                  return /^=(.*)$/;
                }
                search(text2) {
                  const isMatch = text2 === this.pattern;
                  return {
                    isMatch,
                    score: isMatch ? 0 : 1,
                    indices: [0, this.pattern.length - 1]
                  };
                }
              }
              class InverseExactMatch extends BaseMatch {
                constructor(pattern) {
                  super(pattern);
                }
                static get type() {
                  return "inverse-exact";
                }
                static get multiRegex() {
                  return /^!"(.*)"$/;
                }
                static get singleRegex() {
                  return /^!(.*)$/;
                }
                search(text2) {
                  const index2 = text2.indexOf(this.pattern);
                  const isMatch = index2 === -1;
                  return {
                    isMatch,
                    score: isMatch ? 0 : 1,
                    indices: [0, text2.length - 1]
                  };
                }
              }
              class PrefixExactMatch extends BaseMatch {
                constructor(pattern) {
                  super(pattern);
                }
                static get type() {
                  return "prefix-exact";
                }
                static get multiRegex() {
                  return /^\^"(.*)"$/;
                }
                static get singleRegex() {
                  return /^\^(.*)$/;
                }
                search(text2) {
                  const isMatch = text2.startsWith(this.pattern);
                  return {
                    isMatch,
                    score: isMatch ? 0 : 1,
                    indices: [0, this.pattern.length - 1]
                  };
                }
              }
              class InversePrefixExactMatch extends BaseMatch {
                constructor(pattern) {
                  super(pattern);
                }
                static get type() {
                  return "inverse-prefix-exact";
                }
                static get multiRegex() {
                  return /^!\^"(.*)"$/;
                }
                static get singleRegex() {
                  return /^!\^(.*)$/;
                }
                search(text2) {
                  const isMatch = !text2.startsWith(this.pattern);
                  return {
                    isMatch,
                    score: isMatch ? 0 : 1,
                    indices: [0, text2.length - 1]
                  };
                }
              }
              class SuffixExactMatch extends BaseMatch {
                constructor(pattern) {
                  super(pattern);
                }
                static get type() {
                  return "suffix-exact";
                }
                static get multiRegex() {
                  return /^"(.*)"\$$/;
                }
                static get singleRegex() {
                  return /^(.*)\$$/;
                }
                search(text2) {
                  const isMatch = text2.endsWith(this.pattern);
                  return {
                    isMatch,
                    score: isMatch ? 0 : 1,
                    indices: [text2.length - this.pattern.length, text2.length - 1]
                  };
                }
              }
              class InverseSuffixExactMatch extends BaseMatch {
                constructor(pattern) {
                  super(pattern);
                }
                static get type() {
                  return "inverse-suffix-exact";
                }
                static get multiRegex() {
                  return /^!"(.*)"\$$/;
                }
                static get singleRegex() {
                  return /^!(.*)\$$/;
                }
                search(text2) {
                  const isMatch = !text2.endsWith(this.pattern);
                  return {
                    isMatch,
                    score: isMatch ? 0 : 1,
                    indices: [0, text2.length - 1]
                  };
                }
              }
              class FuzzyMatch extends BaseMatch {
                constructor(pattern, {
                  location = Config.location,
                  threshold = Config.threshold,
                  distance = Config.distance,
                  includeMatches = Config.includeMatches,
                  findAllMatches = Config.findAllMatches,
                  minMatchCharLength = Config.minMatchCharLength,
                  isCaseSensitive = Config.isCaseSensitive,
                  ignoreLocation = Config.ignoreLocation
                } = {}) {
                  super(pattern);
                  this._bitapSearch = new BitapSearch(pattern, {
                    location,
                    threshold,
                    distance,
                    includeMatches,
                    findAllMatches,
                    minMatchCharLength,
                    isCaseSensitive,
                    ignoreLocation
                  });
                }
                static get type() {
                  return "fuzzy";
                }
                static get multiRegex() {
                  return /^"(.*)"$/;
                }
                static get singleRegex() {
                  return /^(.*)$/;
                }
                search(text2) {
                  return this._bitapSearch.searchIn(text2);
                }
              }
              class IncludeMatch extends BaseMatch {
                constructor(pattern) {
                  super(pattern);
                }
                static get type() {
                  return "include";
                }
                static get multiRegex() {
                  return /^'"(.*)"$/;
                }
                static get singleRegex() {
                  return /^'(.*)$/;
                }
                search(text2) {
                  let location = 0;
                  let index2;
                  const indices = [];
                  const patternLen = this.pattern.length;
                  while ((index2 = text2.indexOf(this.pattern, location)) > -1) {
                    location = index2 + patternLen;
                    indices.push([index2, location - 1]);
                  }
                  const isMatch = !!indices.length;
                  return {
                    isMatch,
                    score: isMatch ? 0 : 1,
                    indices
                  };
                }
              }
              const searchers = [
                ExactMatch,
                IncludeMatch,
                PrefixExactMatch,
                InversePrefixExactMatch,
                InverseSuffixExactMatch,
                SuffixExactMatch,
                InverseExactMatch,
                FuzzyMatch
              ];
              const searchersLen = searchers.length;
              const SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
              const OR_TOKEN = "|";
              function parseQuery(pattern, options = {}) {
                return pattern.split(OR_TOKEN).map((item) => {
                  let query = item.trim().split(SPACE_RE).filter((item2) => item2 && !!item2.trim());
                  let results = [];
                  for (let i = 0, len = query.length; i < len; i += 1) {
                    const queryItem = query[i];
                    let found = false;
                    let idx = -1;
                    while (!found && ++idx < searchersLen) {
                      const searcher = searchers[idx];
                      let token = searcher.isMultiMatch(queryItem);
                      if (token) {
                        results.push(new searcher(token, options));
                        found = true;
                      }
                    }
                    if (found) {
                      continue;
                    }
                    idx = -1;
                    while (++idx < searchersLen) {
                      const searcher = searchers[idx];
                      let token = searcher.isSingleMatch(queryItem);
                      if (token) {
                        results.push(new searcher(token, options));
                        break;
                      }
                    }
                  }
                  return results;
                });
              }
              const MultiMatchSet = /* @__PURE__ */ new Set([FuzzyMatch.type, IncludeMatch.type]);
              class ExtendedSearch {
                constructor(pattern, {
                  isCaseSensitive = Config.isCaseSensitive,
                  includeMatches = Config.includeMatches,
                  minMatchCharLength = Config.minMatchCharLength,
                  ignoreLocation = Config.ignoreLocation,
                  findAllMatches = Config.findAllMatches,
                  location = Config.location,
                  threshold = Config.threshold,
                  distance = Config.distance
                } = {}) {
                  this.query = null;
                  this.options = {
                    isCaseSensitive,
                    includeMatches,
                    minMatchCharLength,
                    findAllMatches,
                    ignoreLocation,
                    location,
                    threshold,
                    distance
                  };
                  this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
                  this.query = parseQuery(this.pattern, this.options);
                }
                static condition(_, options) {
                  return options.useExtendedSearch;
                }
                searchIn(text2) {
                  const query = this.query;
                  if (!query) {
                    return {
                      isMatch: false,
                      score: 1
                    };
                  }
                  const { includeMatches, isCaseSensitive } = this.options;
                  text2 = isCaseSensitive ? text2 : text2.toLowerCase();
                  let numMatches = 0;
                  let allIndices = [];
                  let totalScore = 0;
                  for (let i = 0, qLen = query.length; i < qLen; i += 1) {
                    const searchers2 = query[i];
                    allIndices.length = 0;
                    numMatches = 0;
                    for (let j = 0, pLen = searchers2.length; j < pLen; j += 1) {
                      const searcher = searchers2[j];
                      const { isMatch, indices, score } = searcher.search(text2);
                      if (isMatch) {
                        numMatches += 1;
                        totalScore += score;
                        if (includeMatches) {
                          const type = searcher.constructor.type;
                          if (MultiMatchSet.has(type)) {
                            allIndices = [...allIndices, ...indices];
                          } else {
                            allIndices.push(indices);
                          }
                        }
                      } else {
                        totalScore = 0;
                        numMatches = 0;
                        allIndices.length = 0;
                        break;
                      }
                    }
                    if (numMatches) {
                      let result = {
                        isMatch: true,
                        score: totalScore / numMatches
                      };
                      if (includeMatches) {
                        result.indices = allIndices;
                      }
                      return result;
                    }
                  }
                  return {
                    isMatch: false,
                    score: 1
                  };
                }
              }
              const registeredSearchers = [];
              function register(...args) {
                registeredSearchers.push(...args);
              }
              function createSearcher(pattern, options) {
                for (let i = 0, len = registeredSearchers.length; i < len; i += 1) {
                  let searcherClass = registeredSearchers[i];
                  if (searcherClass.condition(pattern, options)) {
                    return new searcherClass(pattern, options);
                  }
                }
                return new BitapSearch(pattern, options);
              }
              const LogicalOperator = {
                AND: "$and",
                OR: "$or"
              };
              const KeyType = {
                PATH: "$path",
                PATTERN: "$val"
              };
              const isExpression = (query) => !!(query[LogicalOperator.AND] || query[LogicalOperator.OR]);
              const isPath = (query) => !!query[KeyType.PATH];
              const isLeaf = (query) => !isArray2(query) && isObject2(query) && !isExpression(query);
              const convertToExplicit = (query) => ({
                [LogicalOperator.AND]: Object.keys(query).map((key) => ({
                  [key]: query[key]
                }))
              });
              function parse(query, options, { auto = true } = {}) {
                const next2 = (query2) => {
                  let keys = Object.keys(query2);
                  const isQueryPath = isPath(query2);
                  if (!isQueryPath && keys.length > 1 && !isExpression(query2)) {
                    return next2(convertToExplicit(query2));
                  }
                  if (isLeaf(query2)) {
                    const key = isQueryPath ? query2[KeyType.PATH] : keys[0];
                    const pattern = isQueryPath ? query2[KeyType.PATTERN] : query2[key];
                    if (!isString2(pattern)) {
                      throw new Error(LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
                    }
                    const obj = {
                      keyId: createKeyId(key),
                      pattern
                    };
                    if (auto) {
                      obj.searcher = createSearcher(pattern, options);
                    }
                    return obj;
                  }
                  let node = {
                    children: [],
                    operator: keys[0]
                  };
                  keys.forEach((key) => {
                    const value = query2[key];
                    if (isArray2(value)) {
                      value.forEach((item) => {
                        node.children.push(next2(item));
                      });
                    }
                  });
                  return node;
                };
                if (!isExpression(query)) {
                  query = convertToExplicit(query);
                }
                return next2(query);
              }
              function computeScore(results, { ignoreFieldNorm = Config.ignoreFieldNorm }) {
                results.forEach((result) => {
                  let totalScore = 1;
                  result.matches.forEach(({ key, norm: norm2, score }) => {
                    const weight = key ? key.weight : null;
                    totalScore *= Math.pow(
                      score === 0 && weight ? Number.EPSILON : score,
                      (weight || 1) * (ignoreFieldNorm ? 1 : norm2)
                    );
                  });
                  result.score = totalScore;
                });
              }
              function transformMatches(result, data2) {
                const matches = result.matches;
                data2.matches = [];
                if (!isDefined(matches)) {
                  return;
                }
                matches.forEach((match) => {
                  if (!isDefined(match.indices) || !match.indices.length) {
                    return;
                  }
                  const { indices, value } = match;
                  let obj = {
                    indices,
                    value
                  };
                  if (match.key) {
                    obj.key = match.key.src;
                  }
                  if (match.idx > -1) {
                    obj.refIndex = match.idx;
                  }
                  data2.matches.push(obj);
                });
              }
              function transformScore(result, data2) {
                data2.score = result.score;
              }
              function format(results, docs, {
                includeMatches = Config.includeMatches,
                includeScore = Config.includeScore
              } = {}) {
                const transformers = [];
                if (includeMatches)
                  transformers.push(transformMatches);
                if (includeScore)
                  transformers.push(transformScore);
                return results.map((result) => {
                  const { idx } = result;
                  const data2 = {
                    item: docs[idx],
                    refIndex: idx
                  };
                  if (transformers.length) {
                    transformers.forEach((transformer) => {
                      transformer(result, data2);
                    });
                  }
                  return data2;
                });
              }
              class Fuse {
                constructor(docs, options = {}, index2) {
                  this.options = { ...Config, ...options };
                  if (this.options.useExtendedSearch && false)
                    ;
                  this._keyStore = new KeyStore(this.options.keys);
                  this.setCollection(docs, index2);
                }
                setCollection(docs, index2) {
                  this._docs = docs;
                  if (index2 && !(index2 instanceof FuseIndex)) {
                    throw new Error(INCORRECT_INDEX_TYPE);
                  }
                  this._myIndex = index2 || createIndex(this.options.keys, this._docs, {
                    getFn: this.options.getFn,
                    fieldNormWeight: this.options.fieldNormWeight
                  });
                }
                add(doc) {
                  if (!isDefined(doc)) {
                    return;
                  }
                  this._docs.push(doc);
                  this._myIndex.add(doc);
                }
                remove(predicate = () => false) {
                  const results = [];
                  for (let i = 0, len = this._docs.length; i < len; i += 1) {
                    const doc = this._docs[i];
                    if (predicate(doc, i)) {
                      this.removeAt(i);
                      i -= 1;
                      len -= 1;
                      results.push(doc);
                    }
                  }
                  return results;
                }
                removeAt(idx) {
                  this._docs.splice(idx, 1);
                  this._myIndex.removeAt(idx);
                }
                getIndex() {
                  return this._myIndex;
                }
                search(query, { limit = -1 } = {}) {
                  const {
                    includeMatches,
                    includeScore,
                    shouldSort,
                    sortFn,
                    ignoreFieldNorm
                  } = this.options;
                  let results = isString2(query) ? isString2(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
                  computeScore(results, { ignoreFieldNorm });
                  if (shouldSort) {
                    results.sort(sortFn);
                  }
                  if (isNumber(limit) && limit > -1) {
                    results = results.slice(0, limit);
                  }
                  return format(results, this._docs, {
                    includeMatches,
                    includeScore
                  });
                }
                _searchStringList(query) {
                  const searcher = createSearcher(query, this.options);
                  const { records } = this._myIndex;
                  const results = [];
                  records.forEach(({ v: text2, i: idx, n: norm2 }) => {
                    if (!isDefined(text2)) {
                      return;
                    }
                    const { isMatch, score, indices } = searcher.searchIn(text2);
                    if (isMatch) {
                      results.push({
                        item: text2,
                        idx,
                        matches: [{ score, value: text2, norm: norm2, indices }]
                      });
                    }
                  });
                  return results;
                }
                _searchLogical(query) {
                  const expression = parse(query, this.options);
                  const evaluate2 = (node, item, idx) => {
                    if (!node.children) {
                      const { keyId, searcher } = node;
                      const matches = this._findMatches({
                        key: this._keyStore.get(keyId),
                        value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                        searcher
                      });
                      if (matches && matches.length) {
                        return [
                          {
                            idx,
                            item,
                            matches
                          }
                        ];
                      }
                      return [];
                    }
                    const res = [];
                    for (let i = 0, len = node.children.length; i < len; i += 1) {
                      const child = node.children[i];
                      const result = evaluate2(child, item, idx);
                      if (result.length) {
                        res.push(...result);
                      } else if (node.operator === LogicalOperator.AND) {
                        return [];
                      }
                    }
                    return res;
                  };
                  const records = this._myIndex.records;
                  const resultMap = {};
                  const results = [];
                  records.forEach(({ $: item, i: idx }) => {
                    if (isDefined(item)) {
                      let expResults = evaluate2(expression, item, idx);
                      if (expResults.length) {
                        if (!resultMap[idx]) {
                          resultMap[idx] = { idx, item, matches: [] };
                          results.push(resultMap[idx]);
                        }
                        expResults.forEach(({ matches }) => {
                          resultMap[idx].matches.push(...matches);
                        });
                      }
                    }
                  });
                  return results;
                }
                _searchObjectList(query) {
                  const searcher = createSearcher(query, this.options);
                  const { keys, records } = this._myIndex;
                  const results = [];
                  records.forEach(({ $: item, i: idx }) => {
                    if (!isDefined(item)) {
                      return;
                    }
                    let matches = [];
                    keys.forEach((key, keyIndex) => {
                      matches.push(
                        ...this._findMatches({
                          key,
                          value: item[keyIndex],
                          searcher
                        })
                      );
                    });
                    if (matches.length) {
                      results.push({
                        idx,
                        item,
                        matches
                      });
                    }
                  });
                  return results;
                }
                _findMatches({ key, value, searcher }) {
                  if (!isDefined(value)) {
                    return [];
                  }
                  let matches = [];
                  if (isArray2(value)) {
                    value.forEach(({ v: text2, i: idx, n: norm2 }) => {
                      if (!isDefined(text2)) {
                        return;
                      }
                      const { isMatch, score, indices } = searcher.searchIn(text2);
                      if (isMatch) {
                        matches.push({
                          score,
                          key,
                          value: text2,
                          idx,
                          norm: norm2,
                          indices
                        });
                      }
                    });
                  } else {
                    const { v: text2, n: norm2 } = value;
                    const { isMatch, score, indices } = searcher.searchIn(text2);
                    if (isMatch) {
                      matches.push({ score, key, value: text2, norm: norm2, indices });
                    }
                  }
                  return matches;
                }
              }
              Fuse.version = "6.6.2";
              Fuse.createIndex = createIndex;
              Fuse.parseIndex = parseIndex;
              Fuse.config = Config;
              {
                Fuse.parseQuery = parse;
              }
              {
                register(ExtendedSearch);
              }
            }
          ),
          /***/
          791: (
            /***/
            function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
              __webpack_require__2.r(__webpack_exports__2);
              __webpack_require__2.d(__webpack_exports__2, {
                "__DO_NOT_USE__ActionTypes": function() {
                  return (
                    /* binding */
                    ActionTypes
                  );
                },
                "applyMiddleware": function() {
                  return (
                    /* binding */
                    applyMiddleware
                  );
                },
                "bindActionCreators": function() {
                  return (
                    /* binding */
                    bindActionCreators
                  );
                },
                "combineReducers": function() {
                  return (
                    /* binding */
                    combineReducers
                  );
                },
                "compose": function() {
                  return (
                    /* binding */
                    compose
                  );
                },
                "createStore": function() {
                  return (
                    /* binding */
                    createStore
                  );
                },
                "legacy_createStore": function() {
                  return (
                    /* binding */
                    legacy_createStore
                  );
                }
              });
              function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
                  return typeof obj2;
                } : function(obj2) {
                  return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
                }, _typeof(obj);
              }
              function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null)
                  return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== void 0) {
                  var res = prim.call(input, hint || "default");
                  if (_typeof(res) !== "object")
                    return res;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
              }
              function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
              }
              function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                  Object.defineProperty(obj, key, {
                    value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                  });
                } else {
                  obj[key] = value;
                }
                return obj;
              }
              function ownKeys2(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                  var symbols = Object.getOwnPropertySymbols(object);
                  enumerableOnly && (symbols = symbols.filter(function(sym) {
                    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                  })), keys.push.apply(keys, symbols);
                }
                return keys;
              }
              function _objectSpread2(target) {
                for (var i = 1; i < arguments.length; i++) {
                  var source = null != arguments[i] ? arguments[i] : {};
                  i % 2 ? ownKeys2(Object(source), true).forEach(function(key) {
                    _defineProperty(target, key, source[key]);
                  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys2(Object(source)).forEach(function(key) {
                    Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                  });
                }
                return target;
              }
              function formatProdErrorMessage(code) {
                return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or use the non-minified dev environment for full errors. ";
              }
              var $$observable = function() {
                return typeof Symbol === "function" && Symbol.observable || "@@observable";
              }();
              var randomString = function randomString2() {
                return Math.random().toString(36).substring(7).split("").join(".");
              };
              var ActionTypes = {
                INIT: "@@redux/INIT" + randomString(),
                REPLACE: "@@redux/REPLACE" + randomString(),
                PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
                  return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
                }
              };
              function isPlainObject(obj) {
                if (typeof obj !== "object" || obj === null)
                  return false;
                var proto = obj;
                while (Object.getPrototypeOf(proto) !== null) {
                  proto = Object.getPrototypeOf(proto);
                }
                return Object.getPrototypeOf(obj) === proto;
              }
              function createStore(reducer, preloadedState, enhancer) {
                var _ref2;
                if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") {
                  throw new Error(formatProdErrorMessage(0));
                }
                if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
                  enhancer = preloadedState;
                  preloadedState = void 0;
                }
                if (typeof enhancer !== "undefined") {
                  if (typeof enhancer !== "function") {
                    throw new Error(formatProdErrorMessage(1));
                  }
                  return enhancer(createStore)(reducer, preloadedState);
                }
                if (typeof reducer !== "function") {
                  throw new Error(formatProdErrorMessage(2));
                }
                var currentReducer = reducer;
                var currentState = preloadedState;
                var currentListeners = [];
                var nextListeners = currentListeners;
                var isDispatching = false;
                function ensureCanMutateNextListeners() {
                  if (nextListeners === currentListeners) {
                    nextListeners = currentListeners.slice();
                  }
                }
                function getState() {
                  if (isDispatching) {
                    throw new Error(formatProdErrorMessage(3));
                  }
                  return currentState;
                }
                function subscribe(listener) {
                  if (typeof listener !== "function") {
                    throw new Error(formatProdErrorMessage(4));
                  }
                  if (isDispatching) {
                    throw new Error(formatProdErrorMessage(5));
                  }
                  var isSubscribed = true;
                  ensureCanMutateNextListeners();
                  nextListeners.push(listener);
                  return function unsubscribe() {
                    if (!isSubscribed) {
                      return;
                    }
                    if (isDispatching) {
                      throw new Error(formatProdErrorMessage(6));
                    }
                    isSubscribed = false;
                    ensureCanMutateNextListeners();
                    var index2 = nextListeners.indexOf(listener);
                    nextListeners.splice(index2, 1);
                    currentListeners = null;
                  };
                }
                function dispatch2(action) {
                  if (!isPlainObject(action)) {
                    throw new Error(formatProdErrorMessage(7));
                  }
                  if (typeof action.type === "undefined") {
                    throw new Error(formatProdErrorMessage(8));
                  }
                  if (isDispatching) {
                    throw new Error(formatProdErrorMessage(9));
                  }
                  try {
                    isDispatching = true;
                    currentState = currentReducer(currentState, action);
                  } finally {
                    isDispatching = false;
                  }
                  var listeners = currentListeners = nextListeners;
                  for (var i = 0; i < listeners.length; i++) {
                    var listener = listeners[i];
                    listener();
                  }
                  return action;
                }
                function replaceReducer(nextReducer) {
                  if (typeof nextReducer !== "function") {
                    throw new Error(formatProdErrorMessage(10));
                  }
                  currentReducer = nextReducer;
                  dispatch2({
                    type: ActionTypes.REPLACE
                  });
                }
                function observable() {
                  var _ref;
                  var outerSubscribe = subscribe;
                  return _ref = {
                    /**
                     * The minimal observable subscription method.
                     * @param {Object} observer Any object that can be used as an observer.
                     * The observer object should have a `next` method.
                     * @returns {subscription} An object with an `unsubscribe` method that can
                     * be used to unsubscribe the observable from the store, and prevent further
                     * emission of values from the observable.
                     */
                    subscribe: function subscribe2(observer2) {
                      if (typeof observer2 !== "object" || observer2 === null) {
                        throw new Error(formatProdErrorMessage(11));
                      }
                      function observeState() {
                        if (observer2.next) {
                          observer2.next(getState());
                        }
                      }
                      observeState();
                      var unsubscribe = outerSubscribe(observeState);
                      return {
                        unsubscribe
                      };
                    }
                  }, _ref[$$observable] = function() {
                    return this;
                  }, _ref;
                }
                dispatch2({
                  type: ActionTypes.INIT
                });
                return _ref2 = {
                  dispatch: dispatch2,
                  subscribe,
                  getState,
                  replaceReducer
                }, _ref2[$$observable] = observable, _ref2;
              }
              var legacy_createStore = createStore;
              function assertReducerShape(reducers) {
                Object.keys(reducers).forEach(function(key) {
                  var reducer = reducers[key];
                  var initialState = reducer(void 0, {
                    type: ActionTypes.INIT
                  });
                  if (typeof initialState === "undefined") {
                    throw new Error(formatProdErrorMessage(12));
                  }
                  if (typeof reducer(void 0, {
                    type: ActionTypes.PROBE_UNKNOWN_ACTION()
                  }) === "undefined") {
                    throw new Error(formatProdErrorMessage(13));
                  }
                });
              }
              function combineReducers(reducers) {
                var reducerKeys = Object.keys(reducers);
                var finalReducers = {};
                for (var i = 0; i < reducerKeys.length; i++) {
                  var key = reducerKeys[i];
                  if (typeof reducers[key] === "function") {
                    finalReducers[key] = reducers[key];
                  }
                }
                var finalReducerKeys = Object.keys(finalReducers);
                var shapeAssertionError;
                try {
                  assertReducerShape(finalReducers);
                } catch (e) {
                  shapeAssertionError = e;
                }
                return function combination(state, action) {
                  if (state === void 0) {
                    state = {};
                  }
                  if (shapeAssertionError) {
                    throw shapeAssertionError;
                  }
                  var hasChanged2 = false;
                  var nextState = {};
                  for (var _i = 0; _i < finalReducerKeys.length; _i++) {
                    var _key = finalReducerKeys[_i];
                    var reducer = finalReducers[_key];
                    var previousStateForKey = state[_key];
                    var nextStateForKey = reducer(previousStateForKey, action);
                    if (typeof nextStateForKey === "undefined") {
                      action && action.type;
                      throw new Error(formatProdErrorMessage(14));
                    }
                    nextState[_key] = nextStateForKey;
                    hasChanged2 = hasChanged2 || nextStateForKey !== previousStateForKey;
                  }
                  hasChanged2 = hasChanged2 || finalReducerKeys.length !== Object.keys(state).length;
                  return hasChanged2 ? nextState : state;
                };
              }
              function bindActionCreator(actionCreator, dispatch2) {
                return function() {
                  return dispatch2(actionCreator.apply(this, arguments));
                };
              }
              function bindActionCreators(actionCreators, dispatch2) {
                if (typeof actionCreators === "function") {
                  return bindActionCreator(actionCreators, dispatch2);
                }
                if (typeof actionCreators !== "object" || actionCreators === null) {
                  throw new Error(formatProdErrorMessage(16));
                }
                var boundActionCreators = {};
                for (var key in actionCreators) {
                  var actionCreator = actionCreators[key];
                  if (typeof actionCreator === "function") {
                    boundActionCreators[key] = bindActionCreator(actionCreator, dispatch2);
                  }
                }
                return boundActionCreators;
              }
              function compose() {
                for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
                  funcs[_key] = arguments[_key];
                }
                if (funcs.length === 0) {
                  return function(arg) {
                    return arg;
                  };
                }
                if (funcs.length === 1) {
                  return funcs[0];
                }
                return funcs.reduce(function(a, b) {
                  return function() {
                    return a(b.apply(void 0, arguments));
                  };
                });
              }
              function applyMiddleware() {
                for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
                  middlewares[_key] = arguments[_key];
                }
                return function(createStore2) {
                  return function() {
                    var store2 = createStore2.apply(void 0, arguments);
                    var _dispatch = function dispatch2() {
                      throw new Error(formatProdErrorMessage(15));
                    };
                    var middlewareAPI = {
                      getState: store2.getState,
                      dispatch: function dispatch2() {
                        return _dispatch.apply(void 0, arguments);
                      }
                    };
                    var chain = middlewares.map(function(middleware) {
                      return middleware(middlewareAPI);
                    });
                    _dispatch = compose.apply(void 0, chain)(store2.dispatch);
                    return _objectSpread2(_objectSpread2({}, store2), {}, {
                      dispatch: _dispatch
                    });
                  };
                };
              }
            }
          )
          /******/
        };
        var __webpack_module_cache__ = {};
        function __webpack_require__(moduleId) {
          var cachedModule = __webpack_module_cache__[moduleId];
          if (cachedModule !== void 0) {
            return cachedModule.exports;
          }
          var module2 = __webpack_module_cache__[moduleId] = {
            /******/
            // no module.id needed
            /******/
            // no module.loaded needed
            /******/
            exports: {}
            /******/
          };
          __webpack_modules__[moduleId].call(module2.exports, module2, module2.exports, __webpack_require__);
          return module2.exports;
        }
        !function() {
          __webpack_require__.n = function(module2) {
            var getter = module2 && module2.__esModule ? (
              /******/
              function() {
                return module2["default"];
              }
            ) : (
              /******/
              function() {
                return module2;
              }
            );
            __webpack_require__.d(getter, { a: getter });
            return getter;
          };
        }();
        !function() {
          __webpack_require__.d = function(exports2, definition) {
            for (var key in definition) {
              if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports2, key)) {
                Object.defineProperty(exports2, key, { enumerable: true, get: definition[key] });
              }
            }
          };
        }();
        !function() {
          __webpack_require__.o = function(obj, prop) {
            return Object.prototype.hasOwnProperty.call(obj, prop);
          };
        }();
        !function() {
          __webpack_require__.r = function(exports2) {
            if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
              Object.defineProperty(exports2, Symbol.toStringTag, { value: "Module" });
            }
            Object.defineProperty(exports2, "__esModule", { value: true });
          };
        }();
        var __webpack_exports__ = {};
        !function() {
          var _scripts_choices__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(373);
          var _scripts_choices__WEBPACK_IMPORTED_MODULE_0___default = /* @__PURE__ */ __webpack_require__.n(_scripts_choices__WEBPACK_IMPORTED_MODULE_0__);
          __webpack_require__(187);
          __webpack_require__(883);
          __webpack_require__(789);
          __webpack_require__(686);
          __webpack_exports__["default"] = _scripts_choices__WEBPACK_IMPORTED_MODULE_0___default();
        }();
        __webpack_exports__ = __webpack_exports__["default"];
        return __webpack_exports__;
      }()
    );
  });
})(choices);
var choicesExports = choices.exports;
const Choices = /* @__PURE__ */ getDefaultExportFromCjs(choicesExports);
const init = async () => {
  const { default: Alpine2 } = await __vitePreload(() => Promise.resolve().then(() => module_esm), true ? void 0 : void 0, import.meta.url);
  const { default: ProductGallery } = await __vitePreload(() => import("./hm-chunk-index-bb46434c.js"), true ? [] : void 0, import.meta.url);
  const { default: ProductOptions } = await __vitePreload(() => import("./hm-chunk-index-f304a862.js"), true ? [] : void 0, import.meta.url);
  const { default: ProductRecharge } = await __vitePreload(() => import("./hm-chunk-index-013bd285.js"), true ? [] : void 0, import.meta.url);
  const { default: RegisterFormValidation } = await __vitePreload(() => import("./hm-chunk-index-398f2301.js"), true ? [] : void 0, import.meta.url);
  const { default: LoginFormValidation } = await __vitePreload(() => import("./hm-chunk-index-a2bcf562.js"), true ? [] : void 0, import.meta.url);
  const { default: RecoverPasswordValidation } = await __vitePreload(() => import("./hm-chunk-index-f28e6eeb.js"), true ? [] : void 0, import.meta.url);
  const { default: ResetPasswordValidation } = await __vitePreload(() => import("./hm-chunk-index-5ca64a74.js"), true ? [] : void 0, import.meta.url);
  const { default: ActivateCustomerValidation } = await __vitePreload(() => import("./hm-chunk-index-af31ce69.js"), true ? [] : void 0, import.meta.url);
  const { default: AddressCustomerValidation } = await __vitePreload(() => import("./hm-chunk-index-1da16278.js"), true ? [] : void 0, import.meta.url);
  const { default: CustomerAddress } = await __vitePreload(() => import("./hm-chunk-index-c2e5583d.js"), true ? [] : void 0, import.meta.url);
  const { default: Tooltip } = await __vitePreload(() => import("./hm-chunk-index-6097084d.js"), true ? [] : void 0, import.meta.url);
  const { default: Cart } = await __vitePreload(() => import("./hm-chunk-index-4876e098.js"), true ? [] : void 0, import.meta.url);
  Alpine2.plugin(ProductGallery);
  Alpine2.plugin(ProductOptions);
  Alpine2.plugin(ProductRecharge);
  Alpine2.plugin(RegisterFormValidation);
  Alpine2.plugin(LoginFormValidation);
  Alpine2.plugin(RecoverPasswordValidation);
  Alpine2.plugin(ResetPasswordValidation);
  Alpine2.plugin(ActivateCustomerValidation);
  Alpine2.plugin(AddressCustomerValidation);
  Alpine2.plugin(CustomerAddress);
  Alpine2.plugin(Tooltip);
  Alpine2.plugin(Cart);
  Alpine2.start();
  window.Alpine = Alpine2;
};
window.addEventListener("DOMContentLoaded", () => {
  init();
});
const defaults = {
  modules: [Navigation, Pagination, Scrollbar],
  loop: true,
  scrollbar: {
    el: ".swiper-scrollbar",
    hide: false,
    draggable: false,
    dragSize: 110
  }
};
function initSwipers(defaults2 = {}, selector = ".swiper-slider") {
  const swipers = document.querySelectorAll(selector);
  swipers.forEach((swiper) => {
    const optionsData = swiper.dataset.swiper ? JSON.parse(swiper.dataset.swiper) : {};
    const options = {
      ...defaults2,
      ...optionsData
    };
    new Swiper(swiper, options);
  });
}
initSwipers(defaults);
document.addEventListener("DOMContentLoaded", () => {
  const selectElements = document.querySelectorAll(".js-choice-select");
  selectElements.forEach((select) => {
    new Choices(select, {
      searchEnabled: false,
      itemSelectText: "",
      shouldSort: false
    });
  });
});
export {
  $,
  Navigation as N,
  Pagination as P,
  Swiper as S,
  isObject$1 as i
};
